/**
 * Ring Builder — extracted from ring-builder-collection template
 * Fixes:
 *  - Removed stopImmediatePropagation (it was breaking theme click handlers after first interaction)
 *  - Preserves selected metal/shape keys when swapping products
 *  - Moves popup + intl-tel-input init here
 */

// -----------------------------
// RB: Global helpers (loader + ajax filters + clear selections)
// -----------------------------

/* ===== RB early reset from URL params: must run before all other builder code ===== */
/* ===== RB early reset from URL params: must run before all other builder code ===== */
/* ===== RB early reset from URL params: must run before all other builder code ===== */
 

function rbEnsurePageLoader() {
  if (document.getElementById('rb-page-loader')) return;
  var el = document.createElement('div');
  el.id = 'rb-page-loader'; 
  el.style.cssText = 'position:fixed;inset:0;z-index:999999;background:rgba(255,255,255,.8);display:none;align-items:center;justify-content:center;';
  el.innerHTML = '<div style="font:600 16px/1.2 system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#111">Loading…</div>';
  document.body.appendChild(el);
}
function rbShowPageLoader() {
  try { rbEnsurePageLoader(); } catch (e) {}
  var el = document.getElementById('rb-page-loader');
  if (el) el.style.display = 'flex';
}
function rbHidePageLoader() {
  var el = document.getElementById('rb-page-loader');
  if (el) el.style.display = 'none';
}




function rbGetSectionId(fromEl) {
  var host = fromEl && fromEl.closest ? fromEl.closest('[id^="shopify-section-"]') : null;
  if (!host) return '';
  return host.id.replace('shopify-section-', '');
}
function rbAjaxSubmit(form) {
  if (!form) return;
  var __rbActiveStep = '1';
  try {
    var __rbStepEl = document.querySelector('.rb-step-grid.is-active[data-step]') || document.querySelector('.rb-grid[data-step]:not([style*="display: none"])');
    if (__rbStepEl) __rbActiveStep = String(__rbStepEl.getAttribute('data-step') || '1');
  } catch (e) {}
  rbShowPageLoader();

  // Build params from the RB filter form.
  // IMPORTANT: Shopify will break/ignore filters when the same param is repeated many times
  // (e.g. filter.v.price.gte / lte), so we dedupe those keys.
  var params = new URLSearchParams();
  var lastPriceGte = null;
  var lastPriceLte = null;

  try {
    new FormData(form).forEach(function (v, k) {
      if (!k) return;
      if (k === 'filter.v.price.gte') { lastPriceGte = v; return; }
      if (k === 'filter.v.price.lte') { lastPriceLte = v; return; }
      params.append(k, v);
    });
  } catch (e) {}

  // Ensure price params exist at most once (and remove any stale ones).
  params.delete('filter.v.price.gte');
  params.delete('filter.v.price.lte');
  if (lastPriceGte != null && String(lastPriceGte).trim() !== '') params.set('filter.v.price.gte', String(lastPriceGte).trim());
  if (lastPriceLte != null && String(lastPriceLte).trim() !== '') params.set('filter.v.price.lte', String(lastPriceLte).trim());

  var action = form.getAttribute('action') || window.location.pathname;
  var url = new URL(action, window.location.origin);
  url.search = params.toString();

  var sid = rbGetSectionId(form);
  if (sid) url.searchParams.set('section_id', sid);

  fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');

      // 1) Replace filter form (mobile cards + desktop swipers)
      var newForm = doc.querySelector('form[data-rb-form]');
      var curForm = document.querySelector('form[data-rb-form]');
      if (newForm && curForm) {
        curForm.replaceWith(newForm);
      }

      // 2) Replace the ring sort bar (the one that contains [data-rb-sort])
      var newSort = doc.querySelector('[data-rb-sort]');
      var curSort = document.querySelector('[data-rb-sort]');
      if (newSort && curSort) {
        var newBar = newSort.closest('.rb-bar');
        var curBar = curSort.closest('.rb-bar');
        if (newBar && curBar) curBar.replaceWith(newBar);
      }

      // 3) Replace ring products + pagination
      var newProducts = doc.querySelector('.rb-products');
      var curProducts = document.querySelector('.rb-products');
      if (newProducts && curProducts) {
        curProducts.replaceWith(newProducts);
      }
      try {
        var __rbRoot = document.querySelector('[data-rb-root]');
        if (__rbRoot) __rbRoot.__rbModalBound = false;
      } catch (e) {}

      // Re-bind UI handlers within newly injected DOM
      rbInitRingFiltersUI(document);
      try {
        if (window.activateStep) window.activateStep(__rbActiveStep);
      } catch (e) {}  

      // Patch current RB filter form to prevent programmatic submits from reloading
      rbPatchFormSubmit(document.querySelector('form[data-rb-form]'));

      // Re-patch after any AJAX HTML swap
      document.addEventListener('rb:ajax:updated', function(){ rbPatchFormSubmit(document.querySelector('form[data-rb-form]')); }, { once: false });
      // try {
      //   var cleanUrl = new URL(url.toString(), window.location.origin);
      //   cleanUrl.searchParams.delete('section_id');
      //   window.history.replaceState({}, '', cleanUrl.pathname + (cleanUrl.search ? cleanUrl.search : ''));
      // } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('rb:ajax:updated')); } catch (e) {}
    })
    .catch(function (e) { console.error(e); })
    .finally(function () { rbHidePageLoader(); }); 
}

function rbInitRingFiltersUI(scope) {
  // scope: optional element to search within (default document)
  var doc = scope || document;

  // Sort select
  try {
    doc.querySelectorAll('[data-rb-sort]').forEach(function (sort) {
      if (sort.__rb_bound) return;
      sort.__rb_bound = true;
      sort.addEventListener('change', function () {
        var form = document.querySelector('form[data-rb-form]');
        if (!form) return;
        var hidden = form.querySelector('input[name="sort_by"]');
        if (hidden) hidden.value = sort.value;
        rbAjaxSubmit(form);
      });
    });
  } catch (e) {}
          
  // Price slider + min/max displays
  try {
    doc.querySelectorAll('[data-rb-price]').forEach(function (root) {
      if (root.__rb_bound) return;
      root.__rb_bound = true;

      var from = root.querySelector('[data-rb-from]');
      var to = root.querySelector('[data-rb-to]');
      var minHidden = root.querySelector('[data-rb-min]');
      var maxHidden = root.querySelector('[data-rb-max]');
      var minDisp = root.querySelector('[data-rb-min-display]');
      var maxDisp = root.querySelector('[data-rb-max-display]');
      if (!from || !to || !minHidden || !maxHidden || !minDisp || !maxDisp) return;

      function clamp(n, lo, hi) { if (isNaN(n)) return lo; return Math.min(Math.max(n, lo), hi); }
      function centsToDollars(c) { return Math.round((parseInt(c || '0', 10) / 100) * 100) / 100; }
      function dollarsToCents(d) { var x = parseFloat(String(d).replace(/[^0-9.]/g, '')); if (isNaN(x)) x = 0; return Math.round(x * 100); }

      function isInStep2Price(el) {
        try {
          return !!(el && el.closest && el.closest('.rb-grid[data-step=\"2\"], .rb-step-grid[data-step=\"2\"], .rb-modal[data-step=\"2\"], .rb-modal__body[body-step=\"2\"]'));
        } catch (e) { return false; }
      }

      function syncFromSliders() {
        var a = parseInt(from.value || '0', 10);
        var b = parseInt(to.value || '0', 10);
        if (a > b) { var t = a; a = b; b = t; }
        from.value = a; to.value = b;
        // Shopify price filter URL params expect currency units (e.g. 19.01), while the slider runs in cents.
        // So: slider = cents, hidden inputs = dollars.
        minHidden.value = (a / 100).toFixed(2);
        maxHidden.value = (b / 100).toFixed(2);
        // Display inputs are dollars.
        minDisp.value = String(centsToDollars(a));
        maxDisp.value = String(centsToDollars(b));
      }

      function syncFromInputs() {
        var maxRange = parseInt(from.max || '0', 10);
        var a = clamp(dollarsToCents(minDisp.value), 0, maxRange);
        var b = clamp(dollarsToCents(maxDisp.value), 0, maxRange);
        if (a > b) { var t = a; a = b; b = t; }
        from.value = a; to.value = b;
        minHidden.value = (a / 100).toFixed(2);
        maxHidden.value = (b / 100).toFixed(2);
        minDisp.value = String(centsToDollars(a));
        maxDisp.value = String(centsToDollars(b));
      }
       
      var submitTimer = null;
      function scheduleSubmit() {
        if (window.__rbSuppressPopupAjax) return;
        // Step 2 price widgets must NOT submit the collection form.
        if (isInStep2Price(root)) return;
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function () {
          var form = null;
          try { form = root.closest && root.closest('form'); } catch (e) {}
          if (!form) form = document.querySelector('form[data-rb-form]');
          if (form) rbAjaxSubmit(form);
        }, 600);
      }

      from.addEventListener('input', function () { syncFromSliders(); scheduleSubmit(); });
      to.addEventListener('input', function () { syncFromSliders(); scheduleSubmit(); });
      minDisp.addEventListener('change', function () { syncFromInputs(); scheduleSubmit(); });
      maxDisp.addEventListener('change', function () { syncFromInputs(); scheduleSubmit(); });

      if (!window.__rbApplyingParamsOnly) {
        syncFromSliders();
      }
    });
  } catch (e) {}
}

function rbAjaxLoadUrl(urlString, fromEl) {
  if (!urlString) return;
  var __rbActiveStep = '1';
  try {
    var __rbStepEl = document.querySelector('.rb-step-grid.is-active[data-step]') || document.querySelector('.rb-grid[data-step]:not([style*="display: none"])');
    if (__rbStepEl) __rbActiveStep = String(__rbStepEl.getAttribute('data-step') || '1');
  } catch (e) {}
  rbShowPageLoader();
  try {
    var url = new URL(urlString, window.location.origin);
    var sid = rbGetSectionId(fromEl || document.querySelector('form[data-rb-form]'));
    if (sid) url.searchParams.set('section_id', sid);

    fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // 1) Replace filter form
        var newForm = doc.querySelector('form[data-rb-form]');
        var curForm = document.querySelector('form[data-rb-form]');
        if (newForm && curForm) {
          curForm.replaceWith(newForm);
        }

        // 2) Replace the ring sort bar (the one that contains [data-rb-sort])
        var newSort = doc.querySelector('[data-rb-sort]');
        var curSort = document.querySelector('[data-rb-sort]');
        if (newSort && curSort) {
          var newBar = newSort.closest('.rb-bar');
          var curBar = curSort.closest('.rb-bar');
          if (newBar && curBar) curBar.replaceWith(newBar);
        }

        // 3) Replace ring products + pagination
        var newProducts = doc.querySelector('.rb-products');
        var curProducts = document.querySelector('.rb-products');
        if (newProducts && curProducts) {
          curProducts.replaceWith(newProducts);
        }
        try {
          var __rbRoot = document.querySelector('[data-rb-root]');
          if (__rbRoot) __rbRoot.__rbModalBound = false;
        } catch (e) {}

        // Re-bind UI handlers within newly injected DOM
        rbInitRingFiltersUI(document);
        // try {
        //   var cleanUrl = new URL(url.toString(), window.location.origin);
        //   cleanUrl.searchParams.delete('section_id');
        //   window.history.replaceState({}, '', cleanUrl.pathname + (cleanUrl.search ? cleanUrl.search : ''));
        // } catch (e) {}
        console.log('teeeesasssstt')
        try { document.dispatchEvent(new CustomEvent('rb:ajax:updated')); } catch (e) {console.log(e)}
        
      })
      .catch(function (e) { console.error(e); })
      .finally(function () { rbHidePageLoader(); });
  } catch (e) {
    console.error(e);
    rbHidePageLoader();
  }
}
  

function rbPatchFormSubmit(form) {
  if (!form || form.__rbSubmitPatched) return;
  form.__rbSubmitPatched = true;

  // Patch form.submit() - some theme scripts call this directly (bypasses submit events)
  try {
    var nativeSubmit = form.submit;
    form.__rbNativeSubmit = nativeSubmit;
    form.submit = function () {
      try { rbAjaxSubmit(form); } catch (e) { console.error(e); nativeSubmit.call(form); }
    };
  } catch (e) {}

  // Patch requestSubmit() if available (can also bypass submit listeners in some flows)
  try {
    if (typeof form.requestSubmit === 'function') {
      var nativeReq = form.requestSubmit;
      form.__rbNativeRequestSubmit = nativeReq;
      form.requestSubmit = function (submitter) {
        try { rbAjaxSubmit(form); } catch (e) { console.error(e); nativeReq.call(form, submitter); }
      };
    }
  } catch (e) {}
}

function rbBindRingFiltersAjax() {
  if (document.documentElement.getAttribute('data-rb-ajax-bound') === '1') return;
  document.documentElement.setAttribute('data-rb-ajax-bound', '1');

  rbInitRingFiltersUI(document);

  // Intercept submit of the RB filter form (prevents full page reload)
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-rb-form]') : null;
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    rbPatchFormSubmit(form);
    rbAjaxSubmit(form);
  }, true);

  // Intercept change on filter controls (checkbox/radio/select) inside the RB form
  document.addEventListener('change', function (e) {
    if (window.__rbSuppressPopupAjax) return;
    var form = e.target && e.target.closest ? e.target.closest('form[data-rb-form]') : null;
    if (!form) return;

    // Price displays have their own debounce logic
    if (e.target && e.target.matches && e.target.matches('[data-rb-min-display],[data-rb-max-display],[data-rb-from],[data-rb-to]')) return;
    if (e.target && e.target.closest && e.target.closest('[data-rb-ignore-ajax]')) return;

    var t = (e.target && e.target.type) ? e.target.type.toLowerCase() : '';
    var tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : '';
    if (tag === 'select' || t === 'checkbox' || t === 'radio') {
      if (e.preventDefault) e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      rbPatchFormSubmit(form);
      rbAjaxSubmit(form);
    }
  }, true);

  // Intercept pagination / filter links inside the RB section
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!href) return;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('#') === 0) return;

    var within = a.closest ? a.closest('[data-rb-root], form[data-rb-form]') : null;
    if (!within) return;
    // Do not treat product-card links as filter/pagination navigation.
    // These are handled by the Ring Builder modal opener.
    if (a.hasAttribute('data-rb-product-link')) return;

    // Static Ring Style tag tiles 
      if (a.hasAttribute('data-rb-ring-tag')) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        var tag = (a.getAttribute('data-rb-ring-tag') || '').trim();
        var isActive = a.classList.contains('is-active') || a.classList.contains('active');

        function rbSlugifyTag(v) {
          return String(v || '')
            .trim()
            .toLowerCase()
            .replace(/&/g, 'and')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
        }  

        function rbGetCollectionBase(pathname) {
          var m = String(pathname || '').match(/^(\/collections\/[^\/]+)/i);
          return m ? m[1] : String(pathname || '');
        }

        function rbCollectActiveFilterParams() {
          var params = new URLSearchParams();
          var seen = {};

          var activeTiles = document.querySelectorAll('.rb-tile.is-active[href]'); 

          activeTiles.forEach(function (tile) {
            if (tile.hasAttribute('data-rb-ring-tag')) return;

            var href = tile.getAttribute('href') || '';
            if (!href || href === '#' || href.indexOf('?') === -1) return;

            try {
              var u = new URL(href, window.location.origin);
              u.searchParams.forEach(function (value, key) {
                if (!key) return;
                if (key === 'page' || key === 'section_id' || key === 'rb_tag') return;

                var mapKey = key + '::' + value;
                if (seen[mapKey]) return;
                seen[mapKey] = true;

                params.append(key, value);
              });
            } catch (err) {}
          });

          return params;
        }

        var params = rbCollectActiveFilterParams();
        params.delete('page');
        params.delete('section_id');
        params.delete('rb_tag');
        params.set('rb_tag', '1');

        var basePath = rbGetCollectionBase(window.location.pathname || '');
        var requestPath = isActive ? basePath : (basePath + '/' + rbSlugifyTag(tag));
        var requestUrl = requestPath + (params.toString() ? ('?' + params.toString()) : '');

        rbAjaxLoadUrl(requestUrl, a);   
        return;
      }

    // Ajax-navigate:
    // - any link with query params (pagination/filter)
    // - Reset filters link/button (often has no query params)
    var isReset = !!(a && a.closest && a.closest('.rb-reset')) || a.classList.contains('rb-reset') || a.hasAttribute('data-rb-reset');
    // If this reset link belongs to Step 2 UI, don't handle it here (Step 2 has its own reset logic).      
    var isStep2Context = !!(a.closest && a.closest('[data-step="2"], .rb-grid[data-step="2"], .rb-step-grid[data-step="2"], .rb-modal__body[body-step="2"]'));
    if (isReset && isStep2Context) return;
    if (href.indexOf('?') !== -1 || isReset) {
      e.preventDefault();
      e.stopPropagation();
      // Force a query param so rbAjaxLoadUrl runs through the section rendering pipeline
      var u = href;
      if (isReset && href.indexOf('?') === -1) u = href + '?rb_reset=1';
      rbAjaxLoadUrl(u, a);
    }

  }, true);
}


function clearRingBuilderSelections() {
  var keys = [
    'rb_setting',
    'rb_setting_handle',
    'rb_setting_variant_id',
    'rb_setting_price',
    'rb_setting_image',
    'rb_setting_purity',
    'rb_setting_base_price',
    'rb_setting_ring_size',
    'rb_setting_ring_size_unknown',
    'rb_setting_engraving',
    'rb_setting_product_url',
    'rb_diamond',
    'rb_total_price',
    'rb_setting_shape'
  ];
  try { keys.forEach(function (k) { localStorage.removeItem(k); }); } catch (e) {}
  try { if (window.updateHeadersFromStorage) window.updateHeadersFromStorage(); } catch (e) {}
}

clearRingBuilderSelections();

(function () {

rbBindRingFiltersAjax();

var state = {
            currentHandle: '',
            currentVariantId: '',
            currentPurity: '',
            currentProduct: null,
            currentMetalKey: '',
            currentShapeKey: '',
            // Base handle is the product card the user opened the modal from.
            // We keep its link map as a fallback in case some linked products have incomplete maps.
            baseHandle: '',
            masterLinks: { metal: {}, shape: {} },
            mediaItems: [],
          };

  // ----------------------------- 
  // Step header (top progress) helpers
  // -----------------------------
  function moneyText(v) {  
    if (v == null || v === '') return '';
    var n = Number(v);
    if (!isFinite(n)) return String(v);
    return '$' + (Math.round(n * 100) / 100).toFixed(n % 1 === 0 ? 0 : 2);
  }
  // -----------------------------
  // Pricing helpers (Gold Purity upcharge)
  // -----------------------------
  function parseMoneyNumber(v) {
    if (v == null) return NaN;
    var n = Number(String(v).replace(/[^0-9.]/g, ''));
    return isFinite(n) ? n : NaN;
  }

  function purityUpcharge(purity) {
    var p = String(purity || '').trim().toUpperCase();
    if (p === '14K' || p === '14KT') return 100;
    if (p === '18K' || p === '18KT') return 200;
    return 0; // 10K default
  }

  function applyPurityPriceUI(els, state) {
    // Base price comes from the selected variant (10K baseline), we add a flat upcharge
    var base = (state && isFinite(state.currentBasePrice)) ? Number(state.currentBasePrice) : NaN;
    if (!isFinite(base)) {
      // Fallback: derive base from current UI price by subtracting current purity upcharge
      var ui = els && els.price ? parseMoneyNumber(els.price.textContent || '') : NaN;
      if (isFinite(ui)) base = ui - purityUpcharge(state && state.currentPurity);
    }
    if (!isFinite(base)) return null;

    var adj = base + purityUpcharge(state && state.currentPurity);
    if (els && els.price) els.price.textContent = moneyText(adj);
    return adj;
  }


  function setStepHeader(step, data) {
    var grid = document.querySelector('.rb-step-grid[data-step="' + step + '"]');
    if (!grid) return;
    var icon = grid.querySelector('.icon');
    if (!icon) return;

    var baseIcon = icon.querySelector('.vdb-rb-icon');
    var ph = icon.querySelector('.selected_placeholder');
    if (!ph) return;

    var has = !!(data && (data.image || data.price));
    console.log(data)

    // Theme uses BOTH a "hidden" class and sometimes the [hidden] attribute.
    // Keep them in sync so previews show correctly.
    if (baseIcon) {
      baseIcon.hidden = has ? true : false;
      if (baseIcon.classList) baseIcon.classList.toggle('hidden', has);
    }
    ph.hidden = has ? false : true;
    if (ph.classList) ph.classList.toggle('hidden', !has);

    if (has) {  
      var img = ph.querySelector('img.select_image');
      if (img && data.image) img.src = data.image;
      var price = ph.querySelector('.selected_price');
      if (price && data.price != null) price.textContent = moneyText(data.price);
    }
  }

  function updateHeadersFromStorage() {
    function setMobileStepPopup(step, title, price) {
      var popup = document.querySelector('.step-' + step + '-mobile-popup');
      if (!popup) return;
      var heading = popup.querySelector('.heading');
      var priceEl = popup.querySelector('.selected_price');
      if (heading) heading.textContent = title || '';
      if (priceEl) priceEl.textContent = price ? moneyText(price) : '';
    }

    function getRingTitle(handle) {
      if (!handle) return '';
      var link = document.querySelector('[data-rb-product-link][data-handle="' + handle + '"]');
      var card = link ? (link.closest('.rb-product') || link.closest('[data-rb-product-card]') || link.closest('.grid__item')) : null;
      var titleEl = card ? card.querySelector('.rb-pname, .card__heading, .product-card__title, .title') : null;
      return titleEl ? String(titleEl.textContent || '').trim() : '';
    }

    function getStoneTitle(stone) {
      if (!stone) return '';
      var parts = [];
      if (stone.shape) parts.push(String(stone.shape).trim());
      if (stone.carat !== '' && stone.carat != null) {
        var c = Number(stone.carat);
        parts.push(isFinite(c) ? c.toFixed(2) : String(stone.carat).trim());
      }
      if (stone.color) parts.push(String(stone.color).trim());
      if (stone.clarity) parts.push(String(stone.clarity).trim());
      return parts.join(' ').trim();
    }

    var ringHandle = '';
    var ringPrice = '';
    var ringImage = '';
    try {
      ringHandle = localStorage.getItem('rb_setting_handle') || '';
      ringPrice = localStorage.getItem('rb_setting_price') || '';
      ringImage = localStorage.getItem('rb_setting_image') || '';
    } catch (e) {}

    if (ringHandle && (!ringImage || !ringPrice)) {
      var link = document.querySelector('[data-rb-product-link][data-handle="' + ringHandle + '"]');
      var card = link ? (link.closest('.rb-product') || link.closest('[data-rb-product-card]') || link.closest('.grid__item')) : null;
      if (card) {
        if (!ringImage) {
          var imgEl = card.querySelector('img');
          if (imgEl && imgEl.src) ringImage = imgEl.src;
        }
        if (!ringPrice) {
          var pEl = card.querySelector('.rb-pprice, [data-rb-price], .price, .rb-price');
          if (pEl && pEl.textContent) ringPrice = pEl.textContent.replace(/[^0-9.]/g, '');
        }
      }
    }

    setStepHeader('1', ringHandle ? { price: ringPrice, image: ringImage } : null);
    setMobileStepPopup('1', getRingTitle(ringHandle), ringPrice);

    var stone = null;
    try {
      var s = localStorage.getItem('rb_diamond');
      if (s) stone = JSON.parse(s);
    } catch (e) {}

    setStepHeader('2', stone ? { price: stone.price, image: stone.image_url } : null);
    setMobileStepPopup('2', getStoneTitle(stone), stone && stone.price != null ? stone.price : '');
  }

  // expose for other modules
  try { window.updateHeadersFromStorage = updateHeadersFromStorage; } catch (e) {}

  function activateStep(step) {
    // Step header state
    var steps = document.querySelectorAll('.rb-step-grid[data-step]');
    steps.forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-step') === String(step));
    });

    // Main step grids (1/2 inside builder)
    var all = document.querySelectorAll('.rb-grid[data-step]');
    all.forEach(function (g) {
      var s = g.getAttribute('data-step');
      if (String(s) !== String(step)) {
        g.style.display = 'none';
        return;
      }
      // Step 2 uses CSS grid layout
      g.style.display = (String(step) === '2') ? 'grid' : '';
    });

    // Toggle ring list UI (ONLY on step 1)
    // - Hide ring bars + ring product grids on step 2/3
    // - IMPORTANT: do NOT hide the stone grid which also uses .rb-products-grid and has [data-rb-diamond-grid]
    var ringBars = document.querySelectorAll('.rb-bar');
    ringBars.forEach(function (b) {
      // If this bar is inside the diamond results container, let diamondWrap handle it
      if (b.closest && b.closest('[data-rb-diamond-results]')) return;
      b.style.display = (String(step) === '1') ? '' : 'none';
    });

    var ringProducts = document.querySelector('.rb-products');
    if (ringProducts) ringProducts.style.display = (String(step) === '1') ? '' : 'none';

    var ringGrids = document.querySelectorAll('.rb-products-grid:not([data-rb-diamond-grid])');
    ringGrids.forEach(function (g) {
      g.style.display = (String(step) === '1') ? '' : 'none';
    });

    // Step 2: diamond results container (stone list + advanced filters)
    var diamondWrap = document.querySelector('[data-rb-diamond-results]');
    if (diamondWrap) diamondWrap.hidden = (String(step) !== '2');

    // Step 3: "Complete Ring" section (rendered outside modal)
    var completeWrap = document.querySelector('.main-rb-modal__body.complete-step[complete-step="3"]');
    if (completeWrap) completeWrap.hidden = (String(step) !== '3');

    // Broadcast for other modules
    try { document.dispatchEvent(new CustomEvent('rb:step:' + String(step))); } catch (e) {}
  }

  // expose for other modules
  try { window.activateStep = activateStep; } catch (e) {}

  function openRingModalByHandle(handle) {
    if (!handle) return;
    var link = document.querySelector('[data-rb-product-link][data-handle="' + handle + '"]');
    if (link) link.click();
  }

  function bindHeaderActions() {
    // Delegate Change / View in step headers
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.rb-step-grid .selected_buttons .select_button');
      if (!btn) return;
      var stepGrid = btn.closest('.rb-step-grid[data-step]');
      if (!stepGrid) return;
      var step = stepGrid.getAttribute('data-step');
      var isChange = btn.classList.contains('change-button');
      var isView = btn.classList.contains('view-button');

      if (step === '1') {
        if (isChange) {
          e.preventDefault();
          window.location.href = 'https://renaissancejewel.com/collections/engagement-rings';
          return;
        }

        if (isView) {
          e.preventDefault();
          try {
            var productUrl = localStorage.getItem('rb_setting_product_url') || '';
            var handle = localStorage.getItem('rb_setting_handle') || '';
            if (!productUrl && handle) productUrl = '/products/' + handle;
            if (productUrl) window.location.href = productUrl;
          } catch (err) {}
          return;
        }
      }

      if (step === '2') {
        if (isChange) {
          e.preventDefault();
          // Stay on step 2 but clear current stone selection
          //  try { localStorage.removeItem('rb_diamond'); } catch (err) {}
          document.querySelectorAll('.steps-popup-container').forEach(function (item) {  
              item.style.display = 'none';
          });
          updateHeadersFromStorage();
          activateStep(2);
          // refetch defaults
          try { document.dispatchEvent(new CustomEvent('rb:step:2')); } catch (err) {}
          return;
        }
        if (isView) {
          e.preventDefault();
          try {
            var s = localStorage.getItem('rb_diamond');
            if (s && window.rbOpenStoneModal) window.rbOpenStoneModal(JSON.parse(s));
          } catch (err) {}
          return;
        }
      }
    }, false);
  }

  // Mark a product card as selected in the setting grid (Step 1)
  function markSelectedOnGrid(handle) {
    if (!handle) return;
    try { handle = String(handle); } catch(e) {}
    // Cards are rendered as links with [data-rb-product-link][data-handle]
    document.querySelectorAll('[data-rb-product-link][data-handle]').forEach(function (a) {
      a.classList.toggle('is-selected', a.getAttribute('data-handle') === handle);
      var card = a.closest('.rb-product-card, .grid__item, .rb-product');
      if (card) card.classList.toggle('is-selected', a.getAttribute('data-handle') === handle);
    });
  }


      (function () {
        function initSwipers() {
          if (typeof Swiper === 'undefined') return;

          document.querySelectorAll('[data-rb-swiper]').forEach(function (el) {
            if (el.__rb_inited) return;
            el.__rb_inited = true;

            var key = el.getAttribute('data-rb-swiper');
            var next = el.querySelector('[data-rb-next="' + key + '"]');
            var prev = el.querySelector('[data-rb-prev="' + key + '"]');

            new Swiper(el, {
              slidesPerView: 'auto',
              spaceBetween: 0,
              navigation: { nextEl: next || null, prevEl: prev || null },
              breakpoints: { 0: { slidesPerView: 'auto' }, 750: { slidesPerView: 'auto' } },
            });
          });
        }

        function bindPrice() {
          var root = document.querySelector('[data-rb-price]');
          if (!root) return;

          var from = root.querySelector('[data-rb-from]');
          var to = root.querySelector('[data-rb-to]');
          var minHidden = root.querySelector('[data-rb-min]');
          var maxHidden = root.querySelector('[data-rb-max]');
          var minDisp = root.querySelector('[data-rb-min-display]');
          var maxDisp = root.querySelector('[data-rb-max-display]');

          if (!from || !to || !minHidden || !maxHidden || !minDisp || !maxDisp) return;

          function clamp(n, lo, hi) {
            if (isNaN(n)) return lo;
            return Math.min(Math.max(n, lo), hi);
          }

          function centsToDollars(c) {
            return Math.round((parseInt(c || '0', 10) / 100) * 100) / 100;
          }

          function dollarsToCents(d) {
            var x = parseFloat(String(d).replace(/[^0-9.]/g, ''));
            if (isNaN(x)) x = 0;
            return Math.round(x * 100);
          }

          function syncFromSliders() {
            var a = parseInt(from.value || '0', 10);
            var b = parseInt(to.value || '0', 10);
            if (a > b) {
              var t = a;
              a = b;
              b = t;
            }
            from.value = a;
            to.value = b;
            minHidden.value = centsToDollars(a);
            maxHidden.value = centsToDollars(b);
            minDisp.value = String(centsToDollars(a));
            maxDisp.value = String(centsToDollars(b));
          }

          function syncFromInputs() {
            var maxRange = parseInt(from.max || '0', 10);
            var a = clamp(dollarsToCents(minDisp.value), 0, maxRange);
            var b = clamp(dollarsToCents(maxDisp.value), 0, maxRange);
            if (a > b) {
              var t = a;
              a = b;
              b = t;
            }
            from.value = a;
            to.value = b;
            minHidden.value = a;
            maxHidden.value = b;
            minDisp.value = String(centsToDollars(a));
            maxDisp.value = String(centsToDollars(b));
          }

          var submitTimer = null;
          function scheduleSubmit() {
            clearTimeout(submitTimer);
            submitTimer = setTimeout(function () {
              var form = document.querySelector('[data-rb-form]');
              if (form) rbAjaxSubmit(form);
            }, 600);
          }

          from.addEventListener('input', function () {
            syncFromSliders();
            scheduleSubmit();
          });
          to.addEventListener('input', function () {
            syncFromSliders();
            scheduleSubmit();
          });

          minDisp.addEventListener('change', function () {
            syncFromInputs();
            scheduleSubmit();
          });
          maxDisp.addEventListener('change', function () {
            syncFromInputs();
            scheduleSubmit();
          });

          // init
          if (!window.__rbApplyingParamsOnly) {
            syncFromSliders();
          }
        }

        function bindSort() {
          var sort = document.querySelector('[data-rb-sort]');
          if (!sort) return;
          sort.addEventListener('change', function () {
            var form = document.querySelector('[data-rb-form]');
            if (!form) return;
            var hidden = form.querySelector('input[name="sort_by"]');
            if (hidden) hidden.value = sort.value;
            rbAjaxSubmit(form);
          });
        }

        // -----------------------------
        // Full-page product selection modal
        // -----------------------------
        function bindModal() {
          var root = document.querySelector('[data-rb-root]');
          if (!root || root.__rbModalBound) return;
          root.__rbModalBound = true;

          var modal = document.querySelector('[data-rb-modal]');
          var overlay = document.querySelector('[data-rb-modal-overlay]');
          if (!modal || !overlay) return;

          var els = {
            thumbs: modal.querySelector('[data-rb-thumbs]'),
            mainImg: modal.querySelector('[data-rb-main-img]'),
            sku: modal.querySelector('[data-rb-sku]'),
            description: modal.querySelector('[data-rb-description]'),
            title: modal.querySelector('[data-rb-title]'),
            price: modal.querySelector('[data-rb-modal-price]'),
            metalSelected: modal.querySelector('[data-rb-metal-selected]'),
            railMetal: modal.querySelector('[data-rb-rail="metal"]'),
            railShape: modal.querySelector('[data-rb-rail="shape"]'),
            sizeSelect: modal.querySelector('[data-rb-size-select]'),
            purityGroup: modal.querySelector('[data-rb-purity-group]'),
            purityWrap: modal.querySelector('[data-rb-purity]'),
            sizeUnknown: modal.querySelector('[data-rb-size-unknown]'),
            selectBtn: modal.querySelector('[data-rb-select-setting]'),
          };

          var metaMap = {};
          document.querySelectorAll('script[data-rb-product-json]').forEach(function (s) {
            try {
              var obj = JSON.parse(s.textContent || '{}');
              if (obj && obj.handle) metaMap[obj.handle] = obj;
            } catch (e) {}
          });

          var state = {
            currentHandle: '',
            currentVariantId: '',
            currentPurity: '',
            currentProduct: null,
            currentMetalKey: '',
            currentShapeKey: '',
            // Base handle is the product card the user opened the modal from.
            // We keep its link map as a fallback in case some linked products have incomplete maps.
            baseHandle: '',
            masterLinks: { metal: {}, shape: {} },
            mediaItems: [],
          };

          function moneyFromCents(cents) {
            try {
              var n = (Number(cents) || 0) / 100;
              return n.toLocaleString(undefined, {
                style: 'currency',
                currency: '{{ localization.country.currency.iso_code }}',
              });
            } catch (e) {
              return '$' + ((Number(cents) || 0) / 100).toFixed(2);
            }
          }

          function syncSwiperNavVisibility(kind) {
            var scope = modal.querySelector('[data-rb-swiper="' + kind + '"]');
            if (!scope) return;

            var prev = scope.querySelector('[data-rb-prev="' + kind + '"]');
            var next = scope.querySelector('[data-rb-next="' + kind + '"]');
            var slides = Array.prototype.slice.call(scope.querySelectorAll('.swiper-slide'));

            var visibleSlides = slides.filter(function (slide) {
              if (!slide) return false;
              if (slide.hidden) return false;
              if (slide.style.display === 'none') return false;

              var tile = slide.querySelector('a.rb-tile, button.rb-tile, .rb-modal__tile');
              if (!tile) return false;
              if (tile.hidden) return false;
              if (tile.style.display === 'none') return false;

              return true;
            });

            var showNav = visibleSlides.length > 1;

            if (prev) {
              prev.style.display = showNav ? '' : 'none';
              prev.hidden = !showNav;
            }
            if (next) {
              next.style.display = showNav ? '' : 'none';
              next.hidden = !showNav;
            }
          }

          function syncAnchorTileVisibility(kind, linksObj) {
            var scope = modal.querySelector('[data-rb-swiper="' + kind + '"]');
            if (!scope) return;

            scope.querySelectorAll('a.rb-tile').forEach(function (a) {
              var key = String(a.getAttribute('data-rb-key') || '');

              if (!key) {
                var lbl = a.querySelector('.rb-label');
                key = keyFromLabel(kind, lbl ? lbl.textContent : '');
              }

              var hasHandle = !!(key && linksObj && linksObj[key]);
              var slide = a.closest('.swiper-slide');

              a.style.display = hasHandle ? '' : 'none';
              a.hidden = !hasHandle;
              a.classList.toggle('is-hidden', !hasHandle);

              if (slide) {
                slide.style.display = hasHandle ? '' : 'none';
                slide.hidden = !hasHandle;
              }

              if (hasHandle) {
                a.setAttribute('href', 'javascript:void(0)');
              }
            });

            syncSwiperNavVisibility(kind);
          }

          function lockScroll(on) {
            document.documentElement.classList.toggle('rb-modal-lock', !!on);
            document.body.style.overflow = on ? 'hidden' : '';
          }

          function open() {
             try { rbShowPageLoader(); } catch (e) {}
            // If stone modal body was shown previously, force ring body (step 1)
            // so ring product clicks never open the stone view.
            try {
              modal.querySelectorAll('.rb-modal__body[body-step]').forEach(function (b) {
                b.hidden = b.getAttribute('body-step') !== '1';
              });
            } catch (e) {}
            modal.hidden = false;
            overlay.hidden = false;
            lockScroll(true);
            // Swiper needs visible dimensions; update after the modal is shown
            try {
              requestAnimationFrame(function(){
                try { if (thumbsSwiper) { thumbsSwiper.update(); thumbsSwiper.slideTo(0); } } catch(e) {}
                try { if (mainSwiper) { mainSwiper.update(); mainSwiper.slideTo(0); } } catch(e) {}
                 try { rbHidePageLoader(); } catch (e) {}
              });
            } catch (e) {}
          }

          function close() {
            modal.hidden = true;
            overlay.hidden = true;
            lockScroll(false);
          }

          function railScroll(rail, dir) {
            if (!rail) return;
            var amt = 240 * (dir === 'next' ? 1 : -1);
            rail.scrollLeft = rail.scrollLeft + amt;
          }

          function setActiveTile(railEl, key) {
            if (!railEl) return;
            railEl.querySelectorAll('.rb-modal__tile').forEach(function (t) {
              t.classList.toggle('is-active', t.getAttribute('data-key') === key);
            });
          }

      

          function renderThumbs(images, productJson) {
            els.thumbs.innerHTML = '';
            if (!images || !images.length) return;

            images.forEach(function (src, i) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'rb-modal__thumb' + (i === 0 ? ' is-active' : '');

              var altText = '';
              try {
                if (productJson && productJson.media && productJson.media[i] && productJson.media[i].alt) {
                  altText = productJson.media[i].alt;
                }
              } catch (e) {}

              b.innerHTML =
                '<img loading="lazy" src="' +
                src +
                '" alt="' +
                altText +
                '">' +
                (altText ? '<span class="rb-modal__thumb-name">' + altText + '</span>' : '');

              b.addEventListener('click', function () {
                els.thumbs.querySelectorAll('.rb-modal__thumb').forEach(function (x) {
                  x.classList.remove('is-active');
                });
                b.classList.add('is-active');
                els.mainImg.src = src;
              });

              els.thumbs.appendChild(b);
            });

            els.mainImg.src = images[0];
          }


 // -----------------------------
// Static Gold Purity (UI-only)
// -----------------------------
function normalizePurityStatic(v) {
  var s = String(v || '').trim().toUpperCase().replace(/\s+/g, '');
  if (s === '10KT') s = '10K';
  if (s === '14KT') s = '14K';
  if (s === '18KT') s = '18K';
  return s;
}

function renderPurityStatic() {
  if (!els.purityGroup || !els.purityWrap) return;

  // Show purity only after a SHAPE is selected (as you requested)
  var show = !!state.currentShapeKey;
  els.purityGroup.hidden = !show;

  if (!show) {
    els.purityWrap.innerHTML = '';
    return;
  }

  var options = ['10K', '14K', '18K'];

  // keep current selection / default 10K
  var selected = normalizePurityStatic(state.currentPurity || '');
  if (!selected || options.indexOf(selected) === -1) selected = '10K';
  state.currentPurity = selected;

  // build static buttons
  els.purityWrap.innerHTML = '';
  options.forEach(function (p) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rb-purity__btn' + (p === selected ? ' is-active' : '');
    btn.setAttribute('data-rb-purity-btn', 'true');
    btn.setAttribute('data-purity', p);
    btn.textContent = p;
    els.purityWrap.appendChild(btn);
  });
}

// UI-only: keep your variant logic independent of purity
function applySelectedVariantStatic(productJson) {
  var variants = productJson && Array.isArray(productJson.variants) ? productJson.variants : [];
  if (!variants.length) { state.currentVariantId = ''; return; }

  var v = null;
  for (var i = 0; i < variants.length; i++) {
    if (variants[i] && variants[i].available) { v = variants[i]; break; }
  }
  if (!v) v = variants[0];

  state.currentVariantId = String(v.id || '');

  // price/sku (as before)
  if (els.price) els.price.textContent = moneyFromCents(typeof v.price !== 'undefined' ? v.price : productJson.price);
  // Keep a 10K baseline price in dollars for purity upcharge calculations
  try {
    var cents = null;
    if (typeof v !== 'undefined' && v && typeof v.price !== 'undefined') cents = v.price;
    if (cents == null && productJson && typeof productJson.price !== 'undefined') cents = productJson.price;
    if (cents != null) state.currentBasePrice = Math.round((Number(cents) / 100) * 100) / 100;
  } catch (e) {}

  // Apply purity upcharge immediately in the modal UI
  try { applyPurityPriceUI(els, state); } catch (e) {}
  if (els.sku) els.sku.innerHTML = v.sku ? ('Certificate ID # ' + `<div style="text-decoration:underline;cursor:pointer" onclick="window.open(${item.cert_url}, '_blank').focus();;" target="_blank">` +v.sku + `</div>`) : '';

  
  // Access the description directly from productJson
  console.log('Product Description from productJson:', productJson.description);  // Log the description for troubleshooting
  if (els.description) {
    els.description.textContent = productJson.description;
  } else {
    console.error('Description element is missing!');
  }
  // ring size is static select
  state.currentRingSize = (els.sizeSelect && els.sizeSelect.value) ? String(els.sizeSelect.value) : '';
}
 
function renderTiles(kind, linksObj, activeKey) {
            var rail = kind === 'metal' ? els.railMetal : els.railShape;
            if (!rail) return;
            rail.innerHTML = '';

            var labels =
              kind === 'metal'
                ? {
                    silver: 'Silver',
                    white_gold: 'White Gold',
                    yellow_gold: 'Yellow Gold',
                    rose_gold: 'Rose Gold',
                    platinum: 'Platinum',
                  }
                : {
                    round: 'Round',
                    oval: 'Oval',
                    pear: 'Pear',
                    emerald: 'Emerald',
                    princess: 'Princess',
                    radiant: 'Radiant',
                    cushion: 'Cushion',
                    heart: 'Heart',
                    marquise: 'Marquise',
                  };

            Object.keys(labels).forEach(function (key) {
              var handle = linksObj && linksObj[key] ? String(linksObj[key]) : '';
              if (!handle) return;

              var tile = document.createElement('button');
              tile.type = 'button';
              tile.className = 'rb-modal__tile' + (key === activeKey ? ' is-active' : '');
              tile.setAttribute('data-key', key);
              tile.setAttribute('data-handle', handle);

              // Keep swatch minimal (your design uses icons/images; you can replace later)
              var swatchText = kind === 'metal' ? (key === 'platinum' ? 'PT' : key === 'silver' ? 'SL' : '10K') : '';
              tile.innerHTML =
                '<div class="rb-modal__tile-swatch">' +
                swatchText +
                '</div><div class="rb-modal__tile-label">' +
                labels[key] +
                '</div>';

              tile.addEventListener('click', function () {
                if (kind === 'metal') state.currentMetalKey = key;
                if (kind === 'shape') state.currentShapeKey = key;
                loadProduct(handle, { preserveOpen: true });
              });

              rail.appendChild(tile);
            });
          }

          function guessActiveKeyByCurrent(metaObj, kind) {
            var cur = kind === 'metal' ? metaObj.current_metal || '' : metaObj.current_shape || '';
            var s = String(cur).toLowerCase();

            if (kind === 'metal') {
              if (s.indexOf('silver') >= 0) return 'silver';
              if (s.indexOf('white') >= 0) return 'white_gold';
              if (s.indexOf('yellow') >= 0) return 'yellow_gold';
              if (s.indexOf('rose') >= 0) return 'rose_gold';
              if (s.indexOf('platinum') >= 0) return 'platinum';
              return '';
            } else {
              var map = ['round', 'oval', 'pear', 'emerald', 'princess', 'radiant', 'cushion', 'heart', 'marquise'];
              for (var i = 0; i < map.length; i++) {
                if (s.indexOf(map[i]) >= 0) return map[i];
              }
              return '';
            }
          }


          function keyFromLabel(kind, label) {
            var s = String(label || '').trim().toLowerCase();
            if (kind === 'metal') {
              if (s.indexOf('silver') >= 0) return 'silver';
              if (s.indexOf('white') >= 0) return 'white_gold';
              if (s.indexOf('yellow') >= 0) return 'yellow_gold';
              if (s.indexOf('rose') >= 0) return 'rose_gold';
              if (s.indexOf('platinum') >= 0) return 'platinum';
              return '';
            }
            // shape
            if (s.indexOf('round') >= 0) return 'round';
            if (s.indexOf('oval') >= 0) return 'oval';
            if (s.indexOf('pear') >= 0) return 'pear';
            if (s.indexOf('emerald') >= 0) return 'emerald';
            if (s.indexOf('princess') >= 0) return 'princess';
            if (s.indexOf('radiant') >= 0) return 'radiant';
            if (s.indexOf('cushion') >= 0) return 'cushion';
            if (s.indexOf('heart') >= 0) return 'heart';
            if (s.indexOf('marquise') >= 0) return 'marquise';
            return '';
          }

          function setActiveAnchorTiles(kind, activeKey) {
            var scope = modal.querySelector('[data-rb-swiper="' + kind + '"]');
            if (!scope) return;
            scope.querySelectorAll('a.rb-tile').forEach(function (a) {
              // Prefer explicit key if present, fallback to label heuristics.
              var key = String(a.getAttribute('data-rb-key') || '');
              if (!key) {
                var lbl = a.querySelector('.rb-label');
                key = keyFromLabel(kind, lbl ? lbl.textContent : '');
              }
              a.classList.toggle('is-active', !!activeKey && key === activeKey);
            });
          }


          // -----------------------------
          // Gallery helpers (FIXED)
          // -----------------------------
          var mainSwiper = null;
          var thumbsSwiper = null;

          function waitForSwiper(cb, tries) {
            tries = tries || 60;
            if (typeof Swiper !== 'undefined') return cb();
            if (tries <= 0) return;
            setTimeout(function () {
              waitForSwiper(cb, tries - 1);
            }, 100);
          }

          function getGalleryEls() {
            var main = modal.querySelector('[data-rb-main-swiper]');
            var thumbs = modal.querySelector('[data-rb-thumbs-swiper]');
            return {
              main: main,
              thumbs: thumbs,
              mainWrap: main ? (main.querySelector('[data-rb-main-wrapper]') || main.querySelector('.swiper-wrapper')) : null,
              thumbWrap: thumbs ? (thumbs.querySelector('[data-rb-thumbs-wrapper]') || thumbs.querySelector('.swiper-wrapper')) : null,
            };
          }

          function destroySwipers() {
            try {
              if (mainSwiper) mainSwiper.destroy(true, true);
            } catch (e) {}
            try {
              if (thumbsSwiper) thumbsSwiper.destroy(true, true);
            } catch (e) {}
            mainSwiper = null;
            thumbsSwiper = null;
          }

          // Normalise into [{src, thumb}] expected by renderGallery
          function normalizeMedia(productJson, metaObj) {
            // Goal: return [{src, thumb, type}] for gallery.
            // Shopify /products/{handle}.js commonly provides:
            // - images: [url, url, ...]
            // - featured_image: "url" (sometimes)
            // Some setups may also include:
            // - media: [{media_type:'image', src:'...'}, {media_type:'video', sources:[...], preview_image:{src:'...'}}]

            var items = [];

            // 1) Prefer productJson.media if present (covers some setups + videos)
            try {
              if (productJson && Array.isArray(productJson.media) && productJson.media.length) {
                productJson.media.forEach(function (m) {
                  if (!m) return;

                  if (m.media_type === 'image' && m.src) {
                    items.push({ type: 'image', src: m.src, thumb: m.src });
                    return;
                  }

                  if (m.media_type === 'video') {
                    var vsrc = '';
                    try { vsrc = m.sources && m.sources[0] && m.sources[0].url ? m.sources[0].url : ''; } catch(e){}
                    var thumb = '';
                    try { thumb = m.preview_image && m.preview_image.src ? m.preview_image.src : ''; } catch(e){}
                    if (vsrc) items.push({ type: 'video', src: vsrc, thumb: thumb || (productJson.featured_image || '') || '' });
                  }
                });
              }
            } catch (e) {}

            // 2) Fallback to productJson.images array
            if (!items.length) {
              var imgs = [];
              if (productJson && Array.isArray(productJson.images)) imgs = productJson.images.slice();

              // Sometimes featured_image can be object or string
              if (!imgs.length && productJson && productJson.featured_image) {
                if (typeof productJson.featured_image === 'string') imgs = [productJson.featured_image];
                else if (productJson.featured_image && productJson.featured_image.src) imgs = [productJson.featured_image.src];
              }

              // Defensive normalize if "images" is string/CSV
              if (imgs && !Array.isArray(imgs)) {
                try {
                  if (typeof imgs === 'string') {
                    imgs = imgs.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
                  } else {
                    imgs = [];
                  }
                } catch (e) { imgs = []; }
              }

              if (Array.isArray(imgs) && imgs.length) {
                items = imgs.map(function (src) {
                  return { type: 'image', src: src, thumb: src };
                });
              }
            }

            // 3) Fallback to metaObj.media if you ever add it
            if (!items.length && metaObj && Array.isArray(metaObj.media)) {
              items = metaObj.media
                .filter(function (x) { return x && x.src; })
                .map(function (x) { return { src: x.src, thumb: x.thumb || x.src, type: x.type || 'image' }; });
            }

            return items;
          }

          function renderGallery(items) {
            var g = getGalleryEls();
            if (!g.mainWrap || !g.thumbWrap) return;

            destroySwipers();
            g.mainWrap.innerHTML = '';
            g.thumbWrap.innerHTML = '';

            if (!items || !items.length) return;

            items.forEach(function (item) {
              var m = document.createElement('div');
              m.className = 'swiper-slide';

              if (item.type === 'video') {
                var posterAttr = item.thumb ? (' poster="' + item.thumb + '"') : '';
                m.innerHTML =
                  '<div class="image media">' +
                    '<video autoplay playsinline muted loop preload="metadata"' + posterAttr + '>' +
                      '<source src="' + item.src + '" type="video/mp4">' +
                    '</video>' +
                  '</div>';
              } else {
                m.innerHTML =
                  '<div class="image media">' +
                    '<img src="' + item.src + '" alt="">' +
                  '</div>';
              }

              g.mainWrap.appendChild(m);

              var t = document.createElement('div');
              t.className = 'swiper-slide';

              if (item.type === 'video') {
                if (item.thumb) {
                  t.innerHTML =
                    '<div class="image media" style="position:relative;">' +
                      '<img src="' + item.thumb + '" alt="">' +
                      '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-weight:700;background:rgba(255,255,255,.35);">▶</span>' +
                    '</div>';
                } else {
                  t.innerHTML =
                    '<div class="image media" style="display:flex;align-items:center;justify-content:center;">' +
                      '<span>▶</span>' +
                    '</div>';
                }
              } else {
                t.innerHTML =
                  '<div class="image media">' +
                    '<img src="' + (item.thumb || item.src) + '" alt="">' +
                  '</div>';
              }

              g.thumbWrap.appendChild(t);
            });

            waitForSwiper(function () {
              var nextBtn = modal.querySelector('.rb-modal-main-next, [data-rb-main-next], #rb-modal-main-next');
              var prevBtn = modal.querySelector('.rb-modal-main-prev, [data-rb-main-prev], #rb-modal-main-prev');
              var nextBtnt = modal.querySelector('.swiper-button-next');
              var prevBtnt = modal.querySelector('.swiper-button-prev');

              thumbsSwiper = new Swiper(g.thumbs, {
                slidesPerView: 4,
                direction: 'horizontal',
                spaceBetween: 10,
                freeMode: true,
                watchSlidesProgress: true,
                navigation: {
                  nextEl: nextBtnt,
                  prevEl: prevBtnt,
                },
                breakpoints: {
                  500: {
                    slidesPerView: 5,
                    direction: 'horizontal',
                    spaceBetween: 10,
                  },
                  700: {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                  },
                },
              });

              mainSwiper = new Swiper(g.main, {
                slidesPerView: 1,
                thumbs: { swiper: thumbsSwiper },
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                on: {
                  slideChange: function () {
                    try {
                      g.mainWrap.querySelectorAll('video').forEach(function (v, idx) {
                        if (idx !== mainSwiper.activeIndex) {
                          try {
                            // v.pause();
                            // v.currentTime = 0;
                          } catch (e) {}
                        }
                      });
                    } catch (e) {}
                  }
                }
              });

              if (mainSwiper.navigation) {
                mainSwiper.navigation.init();
                mainSwiper.navigation.update();
              }
            });
          }
          function renderModal(productJson, metaObj) {
            els.title.textContent = productJson.title || '';
 
            var imgs = (productJson.images || []).slice(0, 12);
        

            // active keys from meta (preserve user's selection if already set)
            var metalKey = state.currentMetalKey || guessActiveKeyByCurrent(metaObj, 'metal');
            var shapeKey = state.currentShapeKey || guessActiveKeyByCurrent(metaObj, 'shape');

            state.currentMetalKey = metalKey;
            state.currentShapeKey = shapeKey;

            renderPurityStatic();
            applySelectedVariantStatic(productJson);

            els.metalSelected.textContent = metaObj.current_metal || '';
            // mark active tiles inside the modal swipers
            setActiveAnchorTiles('metal', metalKey);
            setActiveAnchorTiles('shape', shapeKey);


            // tiles (based on metafield links)
// Some linked products may have partial/empty link maps.
// Use the base product's links as a fallback so users can keep switching shapes/metals.
var metalLinks =
  metaObj.links && metaObj.links.metal && Object.keys(metaObj.links.metal).length
    ? metaObj.links.metal
    : (state.masterLinks && state.masterLinks.metal ? state.masterLinks.metal : {});
var shapeLinks =
  metaObj.links && metaObj.links.shape && Object.keys(metaObj.links.shape).length
    ? metaObj.links.shape
    : (state.masterLinks && state.masterLinks.shape ? state.masterLinks.shape : {});

            syncAnchorTileVisibility('metal', metalLinks);
            syncAnchorTileVisibility('shape', shapeLinks);

            syncSwiperNavVisibility('metal');
            syncSwiperNavVisibility('shape');

            renderTiles('metal', metalLinks, metalKey);
            renderTiles('shape', shapeLinks, shapeKey);

            setActiveTile(els.railMetal, metalKey);
            setActiveTile(els.railShape, shapeKey);
          }

          function loadProduct(handle, opts) {
            opts = opts || {};
            state.currentHandle = handle;

            var metaObj = metaMap[handle] || { handle: handle, links: { metal: {}, shape: {} } };
             try { rbShowPageLoader(); } catch (e) {}   
            fetch((Shopify.routes.root || '/') + 'products/' + encodeURIComponent(handle) + '.js', {
              credentials: 'same-origin',
            })
              .then(function (r) {
                return r.json();
              })
              .then(function (productJson) {
                // ✅ old modal render (title/price/sizes/tiles etc.)
                 console.log('dddddd')
                 console.log(productJson)
                state.currentProduct = productJson;
                renderModal(productJson, metaObj);
console.log('dddddd')
                 console.log(productJson)
                // ✅ new gallery render (swiper media)
                state.mediaItems = normalizeMedia(productJson, metaObj);  
               
                console.log(state.mediaItems)
                renderGallery(state.mediaItems);

                // Ensure ring (step 1) body is visible even if a stone popup was opened earlier.
                try {
                  modal.querySelectorAll('.rb-modal__body[body-step]').forEach(function (b) {
                    b.hidden = b.getAttribute('body-step') !== '1';
                  });    
                } catch (e) {}

                 requestAnimationFrame(function () {
                  try { rbHidePageLoader(); } catch (e) {}
                });

                if (!opts.preserveOpen) open();
              })
              .catch(function (e) {
                 console.log(e)
                els.title.textContent = handle;
                if (!opts.preserveOpen) open();
              });
          }

          // Intercept product click (bubble). IMPORTANT:
          // - Do NOT use capture.
          // - Do NOT use stopImmediatePropagation.
          // Otherwise theme-level delegated clicks can break after one interaction.
          root.addEventListener('click', function (e) {
            var link = e.target.closest('[data-rb-product-link]');
            if (!link) return;

            // Prevent navigation but keep the rest of the page functional.
            e.preventDefault();

            var handle = link.getAttribute('data-handle');
            if (!handle) return;

            // New entry point: reset selection keys and capture a "master" link map
            // to keep navigation working even if some linked products (e.g. Oval) have incomplete maps.
            state.currentMetalKey = '';
            state.currentShapeKey = '';
            state.baseHandle = handle;
            var baseMeta = metaMap[handle] || {};
            state.masterLinks = (baseMeta.links && (baseMeta.links.metal || baseMeta.links.shape))
              ? {
                  metal: baseMeta.links && baseMeta.links.metal ? baseMeta.links.metal : {},
                  shape: baseMeta.links && baseMeta.links.shape ? baseMeta.links.shape : {},
                }
              : { metal: {}, shape: {} };    

            loadProduct(handle);    
          });


          // Ring modal: Add current ring to cart (Step 1 modal)
          if (!modal.__rbRingAddBound) {
            modal.__rbRingAddBound = true;
            modal.addEventListener('click', function (e) {
              var btn = e.target && e.target.closest ? e.target.closest('[data-rb-add-to-cart-setting]') : null;
              if (!btn) return;
              // Only in ring body (body-step="1")
              var body = btn.closest('.rb-modal__body[body-step]');
              if (!body || body.getAttribute('body-step') !== '1') return;

              e.preventDefault();
              e.stopPropagation();

              var variantId = state.currentVariantId || '';
              if (!variantId) return;

              var ringSize = '';
              var ringSizeUnknown = '';
              try {
                ringSize = (els.sizeSelect && els.sizeSelect.value) ? String(els.sizeSelect.value) : '';
              } catch (err) {}
              try {
                ringSizeUnknown = (els.sizeUnknown && els.sizeUnknown.checked) ? '1' : '0';
              } catch (err) {}

              var props = {};
              try { if (state.currentPurity) props['Gold Purity'] = String(state.currentPurity); } catch (err) {}
              if (ringSizeUnknown === '1') props['Ring Size'] = "I Don't Know";
              else if (ringSize) props['Ring Size'] = ringSize;

              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: props }] }),
              })
                .then(function (r) { return r.ok ? r.json() : r.text().then(function(t){ throw new Error(t); }); })
                .then(function () {
                  // Clear builder selections after ATC
                  try { clearRingBuilderSelections(); } catch (e) {}
                  // try { document.dispatchEvent(new CustomEvent('opencartdrawer')); } catch (e) {}
                 try { window.location.href = '/cart'; } catch (e) {}
                })
                .catch(function (err) { console.error('Ring add-to-cart failed', err); });
            });
          }

// close
          modal.querySelectorAll('[data-rb-modal-close]').forEach(function (btn) {
            console.log('tessssst')
            btn.addEventListener('click', close);
          });  
          overlay.addEventListener('click', close);

          // rail prev/next
          modal.addEventListener('click', function (e) {
            var p = e.target.closest('[data-rb-rail-prev]');
            var n = e.target.closest('[data-rb-rail-next]');
            if (p) {
              railScroll(modal.querySelector('[data-rb-rail="' + p.getAttribute('data-rb-rail-prev') + '"]'), 'prev');
            }
            if (n) {
              railScroll(modal.querySelector('[data-rb-rail="' + n.getAttribute('data-rb-rail-next') + '"]'), 'next');
            }
          });


          // Intercept metal/shape swatch clicks inside modal.
          // Use event delegation on the modal (bubble), so it keeps working after DOM updates.
         modal.addEventListener('click', function (e) {
            // -----------------------------
            // Purity buttons (UI-only)
            // IMPORTANT:
            // Do NOT return early when the click is NOT a purity button.
            // Returning early breaks metal/shape tile handling and causes anchor redirects.
            // -----------------------------
            var pbtn = e.target.closest('[data-rb-purity-btn]');
            if (pbtn) {
              e.preventDefault();

              state.currentPurity = normalizePurityStatic(pbtn.getAttribute('data-purity'));

              // update UI
              if (els.purityWrap) {
                els.purityWrap.querySelectorAll('[data-rb-purity-btn]').forEach(function (b) {
                  b.classList.toggle('is-active', b.getAttribute('data-purity') === state.currentPurity);
                });
              }
                            // Update price in modal (10K baseline + upcharge)
              var adj = null;
              try { adj = applyPurityPriceUI(els, state); } catch (e) {}

              // If this ring is already selected, persist purity + adjusted price so totals update immediately
              try {
                var savedHandle = localStorage.getItem('rb_setting_handle') || '';
                if (savedHandle && savedHandle === state.currentHandle) {
                  localStorage.setItem('rb_setting_purity', state.currentPurity || '');
                  if (isFinite(state.currentBasePrice)) localStorage.setItem('rb_setting_base_price', String(state.currentBasePrice));
                  if (adj != null) localStorage.setItem('rb_setting_price', String(adj));
                  try { if (window.updateHeadersFromStorage) window.updateHeadersFromStorage(); } catch (err) {}
                  try { document.dispatchEvent(new CustomEvent('rb:pricing:changed')); } catch (err) {}
                }
              } catch (e) {}

              return; // purity handled
            }

            // -----------------------------
            // Metal / Shape tiles
            // Supports BOTH:       
            // - Swiper anchor tiles: <div data-rb-swiper="metal|shape"> ... <a class="rb-tile"> ...
            // - Button tiles (if you ever switch to renderTiles): <button class="rb-modal__tile" data-key data-handle>
            var tileAnchor = e.target.closest('[data-rb-swiper="metal"] a.rb-tile, [data-rb-swiper="shape"] a.rb-tile');
            var tileButton = e.target.closest('button.rb-modal__tile[data-key][data-handle]');
            var tile = tileAnchor || tileButton;
            if (!tile) return;

            // Prevent filter navigation; we swap product details in-place.
            e.preventDefault();

            var kind = 'metal';
            if (tileButton) {
              // If using button tiles, infer kind from the container.
              var inMetal = !!tile.closest('[data-rb-rail="metal"]');
              kind = inMetal ? 'metal' : 'shape';  
            } else {
              // Robust inference: read the nearest data-rb-swiper container if present.
              var swiperHost = tile.closest('[data-rb-swiper]');
              if (swiperHost) {
                kind = String(swiperHost.getAttribute('data-rb-swiper') || '') || 'metal';
              } else {
                kind = tile.closest('[data-rb-swiper="shape"]') ? 'shape' : 'metal';
              }
            }

            var key = '';
            if (tileButton) {
              key = String(tile.getAttribute('data-key') || '');
            } else {
              var lbl = tile.querySelector('.rb-label');
              key = keyFromLabel(kind, lbl ? lbl.textContent : '');
            }
            if (!key) return;

            var curMeta = metaMap[state.currentHandle] || {};  
            var links = curMeta.links && curMeta.links[kind] ? curMeta.links[kind] : {};
            var nextHandle = links[key] ? String(links[key]) : '';

            // Fallback: if the current linked product doesn't have a full map (common on some shapes like Oval),
            // use the base product's map so other options remain selectable.
            if (!nextHandle && state.masterLinks && state.masterLinks[kind] && state.masterLinks[kind][key]) {
              nextHandle = String(state.masterLinks[kind][key]);
            }

            if (!nextHandle) return;

            if (kind === 'metal') state.currentMetalKey = key;
            if (kind === 'shape') state.currentShapeKey = key;
            setActiveAnchorTiles(kind, key);

            loadProduct(nextHandle, { preserveOpen: true });
          });  

// size selection (static ring size dropdown)          
          if (els.sizeSelect) {
            els.sizeSelect.addEventListener('change', function () {
              state.currentRingSize = els.sizeSelect.value || '';
              // selecting a size should uncheck "I don't know"
              if (els.sizeUnknown) {
                els.sizeUnknown.checked = false;
                try { localStorage.setItem('rb_setting_ring_size_unknown', '0'); } catch (e) {}
              }
              try { localStorage.setItem('rb_setting_ring_size', state.currentRingSize || ''); } catch (e) {}
            });
          }

          // "I don't know my ring size" checkbox
          if (els.sizeUnknown) {  
            els.sizeUnknown.addEventListener('change', function () {
              if (els.sizeUnknown.checked) {
                // Clear the dropdown selection when unknown is checked
                if (els.sizeSelect) {
                  try { els.sizeSelect.value = ''; } catch (e) {}
                }
                state.currentRingSize = '';
                try { localStorage.setItem('rb_setting_ring_size', ''); } catch (e) {}
                try { localStorage.setItem('rb_setting_ring_size_unknown', '1'); } catch (e) {}
              } else {
                try { localStorage.setItem('rb_setting_ring_size_unknown', '0'); } catch (e) {}
              }
            });
          }

// save selection
          els.selectBtn.addEventListener('click', function () {
            // If "unknown size" is checked, ignore selected size but still save product
            var ringSizeValue = els.sizeUnknown.checked ? '' : (els.sizeSelect.value || '');
            var metaObj = metaMap[state.currentHandle] || {};
            var payload = {
              handle: state.currentHandle,
              variant_id: state.currentVariantId || '',
              ring_size: ringSizeValue,
              purity: state.currentPurity || '',
              style_id: metaObj.style_id || '',
              metal: metaObj.current_metal || '',
              shape: metaObj.current_shape || '',
              ts: Date.now(),
            };
            try {
              localStorage.setItem('rb_setting', JSON.stringify(payload));
              localStorage.setItem('rb_setting_handle', payload.handle);
              localStorage.setItem('rb_setting_variant_id', payload.variant_id);
              localStorage.setItem('rb_setting_ring_size', payload.ring_size || '');
              localStorage.setItem('rb_setting_ring_size_unknown', (els.sizeUnknown && els.sizeUnknown.checked) ? '1' : '0');
              localStorage.setItem('rb_setting_purity', payload.purity || '');

              // Save ring header info (price + image)
              // price: prefer modal price text, fallback to product json price
              // Price: base (10K) + purity upcharge (14K:+100, 18K:+200)
              var adjPrice = null;
              try { adjPrice = applyPurityPriceUI(els, state); } catch (e) {}
              if (isFinite(state.currentBasePrice)) {
                try { localStorage.setItem('rb_setting_base_price', String(state.currentBasePrice)); } catch (e) {}
              }
              if (adjPrice != null) {
                try { localStorage.setItem('rb_setting_price', String(adjPrice)); } catch (e) {}
              } else {
                var priceTxt = els.price ? (els.price.textContent || '') : '';
                if (priceTxt) localStorage.setItem('rb_setting_price', priceTxt.replace(/[^0-9.]/g, ''));
              }
              // image: first media item if present
              if (state.mediaItems && state.mediaItems[0] && state.mediaItems[0].src) {
                localStorage.setItem('rb_setting_image', state.mediaItems[0].src);
              }
            } catch (e) {}

            markSelectedOnGrid(state.currentHandle);
            close();

            // Notify other scripts (step 2 stone picker etc.)
            document.dispatchEvent(new CustomEvent('rb:setting:selected', { detail: payload }));

            // Update step header UI
            updateHeadersFromStorage();
          });

          // restore selected state on load
          try {
            var saved = localStorage.getItem('rb_setting_handle');
            if (saved) markSelectedOnGrid(saved);
          } catch (e) {}
        }

       
  
        function boot() {
          try { rbShowPageLoader(); } catch(e) {}
          initSwipers();
          bindPrice();
          bindSort();
          bindModal();

          

          // Restore UI from saved selections so the builder does NOT reset on reload
          try { updateHeadersFromStorage(); } catch (e) {}
          try {
            var targetStep = '';
            var activeUi = document.querySelector('.rb-step-grid.is-active[data-step]');
            if (activeUi) targetStep = String(activeUi.getAttribute('data-step') || '');
            if (!targetStep) {
              var hasRing = false;
              var hasStone = false;
              try { hasRing = !!(localStorage.getItem('rb_setting_handle') || ''); } catch (e) {}
              try { hasStone = !!(localStorage.getItem('rb_diamond') || ''); } catch (e) {}
              if (hasStone) targetStep = '3';
              else if (hasRing) targetStep = '2';
              else targetStep = '1';
            }
            activateStep(targetStep || '1');
          } catch (e) {}

          // Ensure initial loader is hidden after boot
          if (!window.__rbUrlDefaultsPresent && !document.__rbCollectionDefaultsApplying) {
            try { rbHidePageLoader(); } catch (e) {}
            try { setTimeout(function(){ rbHidePageLoader(); }, 150); } catch (e) {}
          }
        }

        try { window.__rbBoot = boot; } catch (e) {}

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', boot);
        } else {
          boot();
        }

        document.addEventListener('shopify:section:load', boot);
        document.addEventListener('rb:ajax:updated', function(){ try{ if(window.__rbBoot) window.__rbBoot(); }catch(e){} try{ if(window.updateHeadersFromStorage) window.updateHeadersFromStorage(); }catch(e){} });
      })();


      /* RB: Duplicate gallery-only modal script removed (kept single modal controller above) */
   

      function initRbPriceColorOnly() {
          document
            .querySelectorAll('[data-rb-price], [data-rb-color], [data-rb-ring-popup-price], [data-rb-stone-popup-carat], [data-rb-stone-popup-price]')
            .forEach(function (root) {
              var from = root.querySelector('[data-rb-from]');
              var to = root.querySelector('[data-rb-to]');
              var showfrom = root.querySelector('[data-rb-min-display]');
              var showto = root.querySelector('[data-rb-max-display]');

              if (!from || !to) return;

              var activeColor = '#222222';
              var inactiveColor = '#edebeb';

              function getLabels() {
                return Array.prototype.slice.call(root.querySelectorAll('.rb-range-label-wrapper .rb-range-label'))
                  .map(function (el) { return (el.getAttribute('value') || (el.textContent || '')).trim(); })
                  .filter(Boolean);
              }

              function isMoneyRange() {
                if (
                  root.hasAttribute('data-rb-ring-popup-price') ||
                  root.hasAttribute('data-rb-stone-popup-price')
                ) return true;

                if (root.hasAttribute('data-rb-stone-popup-carat')) return false;
                if (root.hasAttribute('data-rb-color')) return false;

                var labels = getLabels();
                if (labels.length) return false;

                var max = parseFloat(from.max || '0');
                return max > 100;
              }

              function isCaratRange() {
                return root.hasAttribute('data-rb-stone-popup-carat');
              }

              function centsToDollars(cents) {
                var n = parseFloat(cents || '0');
                if (!isFinite(n)) n = 0;
                return Math.round(n) / 100;
              }

              function rawToCarat(raw) {
                var n = parseFloat(raw || '0');
                if (!isFinite(n)) n = 0;
                return (Math.round(n) / 100).toFixed(2).replace(/\.00$/, '');
              }

              function caratToRaw(v) {
                var n = parseFloat(String(v || '').replace(/[^0-9.]/g, ''));
                if (!isFinite(n)) n = 0;
                return Math.round(n * 100);
              }

              function setDisplayValues() {
                if (!showfrom || !showto) return;

                var labels = getLabels();
                var fromVal = parseFloat(from.value || '0');
                var toVal = parseFloat(to.value || '0');

                if (labels.length) {
                  var i1 = Math.max(0, Math.min(labels.length - 1, parseInt(fromVal, 10) || 0));
                  var i2 = Math.max(0, Math.min(labels.length - 1, parseInt(toVal, 10) || 0));
                  showfrom.value = labels[i1] || '';
                  showto.value = labels[i2] || '';
                  return;
                }

                if (isMoneyRange()) {
                  showfrom.value = String(centsToDollars(fromVal));
                  showto.value = String(centsToDollars(toVal));
                  return;
                }

                if (isCaratRange()) {
                  showfrom.value = rawToCarat(fromVal);
                  showto.value = rawToCarat(toVal);
                  return;
                }

                showfrom.value = String(fromVal);
                showto.value = String(toVal);
              }

              function updateBackground() {
                var min = parseFloat(from.min || '0');
                var max = parseFloat(from.max || '0');
                var fromVal = parseFloat(from.value || '0');
                var toVal = parseFloat(to.value || '0');

                if (!isFinite(min)) min = 0;
                if (!isFinite(max) || max <= min) max = min + 1;
                if (!isFinite(fromVal)) fromVal = min;
                if (!isFinite(toVal)) toVal = max;

                if (fromVal > toVal) {
                  var tmp = fromVal;
                  fromVal = toVal;
                  toVal = tmp;
                  from.value = fromVal;
                  to.value = toVal;
                }

                setDisplayValues();

                var percent1 = ((fromVal - min) / (max - min)) * 100;
                var percent2 = ((toVal - min) / (max - min)) * 100;

                var gradient =
                  'linear-gradient(to right, ' +
                  inactiveColor + ' 0%, ' +
                  inactiveColor + ' ' + percent1 + '%, ' +
                  activeColor + ' ' + percent1 + '%, ' +
                  activeColor + ' ' + percent2 + '%, ' +
                  inactiveColor + ' ' + percent2 + '%, ' +
                  inactiveColor + ' 100%)';

                from.style.background = gradient;
                to.style.background = gradient;
              }

              if (!root.__rbVisualBound) {
                from.addEventListener('input', updateBackground);
                to.addEventListener('input', updateBackground);
                from.addEventListener('change', updateBackground);
                to.addEventListener('change', updateBackground);

                function syncSlidersFromDisplay(isLive) {
                  if (!showfrom || !showto) return;

                  var labels = getLabels();
                  var min = parseFloat(from.min || '0');
                  var max = parseFloat(from.max || '0');

                  if (labels.length) {
                    function labelToIndex(val, fallback) {
                      var needle = String(val || '').trim().toLowerCase();
                      if (!needle) return fallback;
                      for (var i = 0; i < labels.length; i++) {
                        if (String(labels[i]).trim().toLowerCase() === needle) return i;
                      }
                      return fallback;
                    }

                    var curA = parseInt(from.value || '0', 10);
                    var curB = parseInt(to.value || '0', 10);

                    var a = labelToIndex(showfrom.value, curA);
                    var b = labelToIndex(showto.value, curB);

                    if (a > b) {
                      var tt = a; a = b; b = tt;
                    }

                    from.value = a;
                    to.value = b;
                    updateBackground();
                    return;
                  }

                  function parseField(v) {
                    var s = String(v || '').trim();
                    if (!s) return null;
                    var n = parseFloat(s.replace(/[^0-9.]/g, ''));
                    return isFinite(n) ? n : null;
                  }

                  var rawA = parseField(showfrom.value);
                  var rawB = parseField(showto.value);

                  if (isLive && (rawA === null || rawB === null)) return;

                  var a, b;

                  if (isMoneyRange()) {
                    var curFrom = parseFloat(from.value || '0');
                    var curTo = parseFloat(to.value || '0');

                    a = rawA === null ? curFrom : Math.round(rawA * 100);
                    b = rawB === null ? curTo : Math.round(rawB * 100);
                  } else if (isCaratRange()) {
                    var curFromCarat = parseFloat(from.value || '0');
                    var curToCarat = parseFloat(to.value || '0');

                    a = rawA === null ? curFromCarat : caratToRaw(rawA);
                    b = rawB === null ? curToCarat : caratToRaw(rawB);
                  } else {
                    var curFromNum = parseFloat(from.value || '0');
                    var curToNum = parseFloat(to.value || '0');

                    a = rawA === null ? curFromNum : rawA;
                    b = rawB === null ? curToNum : rawB;
                  }

                  if (!isFinite(a)) a = min;
                  if (!isFinite(b)) b = max;

                  a = Math.min(Math.max(a, min), max);
                  b = Math.min(Math.max(b, min), max);

                  if (a > b) {
                    var t = a; a = b; b = t;
                  }

                  from.value = a;
                  to.value = b;

                  updateBackground();
                }

                if (showfrom) {
                  showfrom.addEventListener('input', function () { syncSlidersFromDisplay(true); });
                  showfrom.addEventListener('change', function () { syncSlidersFromDisplay(false); });
                  showfrom.addEventListener('blur', function () { syncSlidersFromDisplay(false); });
                }

                if (showto) {
                  showto.addEventListener('input', function () { syncSlidersFromDisplay(true); });
                  showto.addEventListener('change', function () { syncSlidersFromDisplay(false); });
                  showto.addEventListener('blur', function () { syncSlidersFromDisplay(false); });
                }

                root.__rbVisualBound = true;
              }

              if (!window.__rbApplyingParamsOnly) {
                updateBackground();
              }
            });
        }

  document.addEventListener('DOMContentLoaded', initRbPriceColorOnly);
  document.addEventListener('rb:ajax:updated', function(){ try{ initRbPriceColorOnly(); }catch(e){} });  
  try { window.rbReinitPriceColorOnly = initRbPriceColorOnly; } catch (e) {}

  function rbFindStep2CardByTitle(title) {
    var grid = getStep2DesktopGrid();
    if (!grid) return null;
    var wanted = String(title || '').trim().toLowerCase();
    return qsa('.rb-card', grid).find(function (card) {
      var t = card.querySelector('.rb-title');
      if (!t) return false;
      var txt = String(t.textContent || '').trim().toLowerCase();
      if (wanted === 'shape') return isShapeTitle(txt);
      return txt === wanted;
    }) || null;
  }

  function rbSetDesktopTileActive(card, labelText) {
    if (!card) return;
    var target = normalizeShapeLabel(labelText);
    qsa('.rb-tile', card).forEach(function (tile) {
      var lbl = tile.querySelector('.rb-label');
      var match = lbl && normalizeShapeLabel(lbl.textContent) === target;
      tile.classList.toggle('is-active', !!match);
    });
  }

  function rbSyncRangePopupToCard(modal, title) {
    var card = rbFindStep2CardByTitle(title);
    if (!card || !modal) return;

    var popupRoot = modal.querySelector('[data-rb-price], [data-rb-color]');
    var cardRoot = card.querySelector('[data-rb-price], [data-rb-color]');
    if (!popupRoot || !cardRoot) return;

    ['[data-rb-from]','[data-rb-to]','[data-rb-min-display]','[data-rb-max-display]'].forEach(function (sel) {
      var src = popupRoot.querySelector(sel);
      var dst = cardRoot.querySelector(sel);
      if (src && dst) dst.value = src.value;
    });

    // Do NOT re-trigger desktop handlers while params are being restored
    if (window.__rbApplyingParamsOnly) return;

    try {
      var from = cardRoot.querySelector('[data-rb-from]');
      var to = cardRoot.querySelector('[data-rb-to]');
      if (from) from.dispatchEvent(new Event('input', { bubbles: true }));
      if (to) to.dispatchEvent(new Event('input', { bubbles: true }));
    } catch (e) {}
  }

  function rbSyncColorPopupToDesktop(modal) {
    var card = rbFindStep2CardByTitle('color');
    if (!card || !modal) return;
    var activeTab = modal.querySelector('.rb-swatch.active[data-rb-color-tab]');
    var tab = activeTab ? String(activeTab.getAttribute('data-rb-color-tab') || 'white').toLowerCase() : 'white';
    qsa('.rb-swatch[data-rb-color]', card).forEach(function (x) {
      x.classList.toggle('active', String(x.getAttribute('data-rb-color') || '').toLowerCase() === tab);
    });
    qsa('[data-color-type]', card).forEach(function (wrap) {
      wrap.style.display = (String(wrap.getAttribute('data-color-type') || '').toLowerCase() === tab) ? '' : 'none';
    });
    if (tab === 'white') {
      rbSyncRangePopupToCard(modal, 'color');
    } else {
      var activeFancy = modal.querySelector('[data-rb-fancy-color].is-active, [data-rb-fancy-color].active');
      var fancyText = activeFancy ? String(activeFancy.getAttribute('data-rb-fancy-color') || '').trim() : '';
      qsa('[data-rb-fancy-color]', card).forEach(function (x) {
        var same = String(x.getAttribute('data-rb-fancy-color') || '').trim().toLowerCase() === fancyText.toLowerCase();
        x.classList.toggle('is-active', !!same);
        x.classList.toggle('active', !!same);
      });
    }
  }

  function rbSyncMobileStep2ToDesktop(sourceEl) {
    var modal = sourceEl && sourceEl.closest ? sourceEl.closest('.rb-modal-popup[id$="_stone_modal"]') : null;
    if (!modal) modal = document.querySelector('.rb-modal-popup.is-open[id$="_stone_modal"]');
    if (!modal) return;
    var id = modal.id || '';
    if (id === 'rb_shape_stone_modal') rbSetDesktopTileActive(rbFindStep2CardByTitle('shape'), (modal.querySelector('.rb-tile.is-active .rb-label') || {}).textContent || '');
    else if (id === 'rb_lab_stone_modal') rbSetDesktopTileActive(rbFindStep2CardByTitle('lab'), (modal.querySelector('.rb-tile.is-active .rb-label') || {}).textContent || '');
    else if (id === 'rb_carat_stone_modal') rbSyncRangePopupToCard(modal, 'carat');
    else if (id === 'rb_price_stone_modal') rbSyncRangePopupToCard(modal, 'price');
    else if (id === 'rb_clarity_stone_modal') rbSyncRangePopupToCard(modal, 'clarity');
    else if (id === 'rb_cut_stone_modal') rbSyncRangePopupToCard(modal, 'cut');
    else if (id === 'rb_polish_stone_modal') rbSyncRangePopupToCard(modal, 'polish');
    else if (id === 'rb_symmetry_stone_modal') rbSyncRangePopupToCard(modal, 'symmetry');
    else if (id === 'rb_fluorescence_stone_modal') rbSyncRangePopupToCard(modal, 'fluorescence');
    else if (id === 'rb_color_stone_modal') rbSyncColorPopupToDesktop(modal);
  }

  try { window.rbSyncMobileStep2ToDesktop = rbSyncMobileStep2ToDesktop; } catch (e) {}
   
    (function () {
      function ready(fn) {
        if (document.readyState !== 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
      }

      ready(function () {
        function getOverlay() {
          return document.querySelector('.rb-modal-overlay[data-rb-overlay]');
        }

        function closeAllPopups() {
          var overlay = getOverlay();

          document.querySelectorAll('.rb-modal-popup, .rb-modal-popup-mob').forEach(function (modal) {
            modal.classList.remove('is-open');
            modal.hidden = true;
          });

          if (overlay) {
            overlay.classList.remove('is-open');
            overlay.hidden = true;
            overlay.style.display = 'none';
            overlay.removeAttribute('data-rb-active');
          }

          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
          if (window.jQuery) jQuery('body').css('overflow', '');
        }

        document.addEventListener('click', function (e) {
          var card = e.target.closest('.rb-filter-card[data-rb-open], .rb-filter-card[data-filter]');
          if (card) {
            e.preventDefault();

            var target = card.getAttribute('data-rb-open');
            var modal = null;

            if (target) {
              modal = document.querySelector(target);
            } else {
              var filter = card.getAttribute('data-filter');
              if (filter) modal = document.getElementById('rb_' + filter + '_modal');
            }

            var overlay = getOverlay();
            if (!modal) return;

            modal.hidden = false;
            modal.classList.add('is-open');

            if (overlay) {
              overlay.hidden = false;
              overlay.style.display = 'block';
              overlay.classList.add('is-open');
              overlay.setAttribute('data-rb-active', modal.id || '');
            }

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
            if (window.jQuery) jQuery('body').css('overflow', 'hidden');
            return;
          }

          if (
            e.target.closest('.rb-modal-close') ||
            e.target.closest('.rb-modal-overlay') ||
            e.target.matches('.rb-modal-overlay')
          ) {
            e.preventDefault();
            closeAllPopups();
            return;
          }

          var tile = e.target.closest('.rb-tile');
          if (tile) {
            var modal = tile.closest('.rb-modal-popup, .rb-modal-popup-mob');
            if (!modal) return;

            var id = modal.id
              .replace(/^rb_/, '')
              .replace(/_stone_modal$/, '')
              .replace(/_modal$/, '');

            var label = tile.querySelector('.rb-label');
            var output = document.querySelector('[data-filter-val="' + id + '"]');

            if (output && label) {
              output.textContent = label.textContent.trim();
            }
          }
        });

        


        document.addEventListener('click', function (e) {
          var closeBtn = e.target.closest('.rb-modal-popup[id$="_stone_modal"] .rb-modal-close');
          if (closeBtn) {
            e.preventDefault();
            e.stopPropagation();

            try { rbSyncMobileStep2ToDesktop(closeBtn); } catch (err) {}
            closeAllPopups();
            try { if (window.activateStep) window.activateStep(2); } catch (err2) {}

            if (!window.__rbApplyingParamsOnly) {
              try { fetchDiamonds(1, getStep2DesktopGrid() || closeBtn); } catch (err3) {}
            }
            return;
          }

          var colorTab = e.target.closest('.rb-modal-popup[id$="_stone_modal"] [data-rb-color-tab]');
          if (colorTab) {
            e.preventDefault();
            e.stopPropagation();

            var wrap = colorTab.closest('.rb-modal-popup');
            qsa('[data-rb-color-tab]', wrap).forEach(function (x) { x.classList.remove('active'); });
            colorTab.classList.add('active');

            var tab = String(colorTab.getAttribute('data-rb-color-tab') || '').toLowerCase();
            qsa('[data-color-type]', wrap).forEach(function (el) {
              el.style.display = String(el.getAttribute('data-color-type') || '').toLowerCase() === tab ? '' : 'none';
            });

            if (!window.__rbApplyingParamsOnly) {
              try { rbSyncMobileStep2ToDesktop(colorTab); } catch (err4) {}
            }
            return;
          }
        }, true);

       

        document.addEventListener('change', function (e) {
          var t = e.target;
          if (!t || !t.closest || !t.closest('.rb-modal-popup[id$="_stone_modal"]')) return;
          try { rbSyncMobileStep2ToDesktop(t); } catch (err) {}
        }, true);

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeAllPopups();
        });

        document.addEventListener('rb:ajax:updated', function () {
          closeAllPopups();
        });

        try { updateHeadersFromStorage(); } catch (e) {}
      });
    })();

  // Bind header actions once
  if (!document.__rbHeaderActionsBound) {
    document.__rbHeaderActionsBound = true;
    bindHeaderActions();
  }


  $(document).on('click', '.rb-modal__select', function () {
    var $btn = $(this);

    $('.rb-modal').attr('hidden', true);
    $('.rb-modal__overlay').hide();
    $('body').css('overflow', '');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';

    var isRingSettingSelect =
      $btn.is('[data-rb-select-setting]') &&
      $btn.closest('.rb-modal__body[body-step="1"]').length > 0;

    if (!isRingSettingSelect) return;

    try {
      if (window.activateStep) {
        window.activateStep(2);
      } else {
        $('.rb-step-grid[data-step="1"]').removeClass('is-active');
        $('.rb-step-grid[data-step="2"]').addClass('is-active');
        $('.rb-grid[data-step="1"]').hide();
        $('.rb-grid[data-step="2"]').css('display', 'grid');
      }
    } catch (e) {}
  });

  // $('.rb-diamond-card[data-rb-diamond-card]').click(function(){  
  //   $('.rb-modal').attr('hidden', false);
  //   $('.rb-modal__overlay').show();
  //   $('body').css('overflow','hidden');
  //   // $('.rb-step-grid[data-step="1"]').removeClass('is-active');
  //   // $('.rb-step-grid[data-step="2"]').addClass('is-active');
  //   // $('.rb-grid[data-step="2"]').css('display','grid');
  //   // $('.rb-grid[data-step="1"]').hide();
  // });

  

  $('.advanced_filters_button').click(function(){
    console.log('tesssszst')
    var $grid = $(this).closest('.rb-grid');
    var advanced = $grid.find('.diamond-swatch.is-active').attr('data-type');
    if (!advanced) return;

    var $extras = $grid.find('.rb-card[data-extra][data-content="' + advanced + '"]');

    if ($extras.first().is(':visible')) {
      $extras.hide();
      $(this).removeClass('is-active');
    } else {
      $extras.css('display','flex');
      $(this).addClass('is-active');
    }
  });

  // $('.thumbnail-media--image').on('click', function() {
  //   var container = $(this).closest('.rb-modal__media-container');

  //   var primaryImg = container.find('.primary-image');
  //   var secondaryImg = container.find('.secondary-image');

  //   var primarySrc = primaryImg.attr('src');
  //   var secondarySrc = secondaryImg.attr('src');

  //   console.log('primary src:', primarySrc);
  //   console.log('secondary src:', secondarySrc);

  //   primaryImg.attr('src', secondarySrc);
  //   secondaryImg.attr('src', primarySrc);
  // });

// Popup + phone input (moved from inline)
document.addEventListener('click', function (e) {
  var closeBtn = e.target.closest('.popup-close-btn');
  var overlay  = e.target.closest('.popup-overlay');
  if (closeBtn || overlay) {
    var form = document.querySelector('.popup-form');
    if (form) form.style.display = 'none';
    return;
  }

  var askBtn = e.target.closest('.ask-button');
  if (askBtn) {
    var form2 = document.querySelector('.popup-form');
    if (form2) form2.style.display = 'block';
    return;
  }
});

// intl-tel-input init (only if library is present)
(function initIntlTelInput() {
  if (!window.intlTelInput) return;

  var input = document.querySelector('[data-rb-phone="true"]');
  if (!input) return;

  try {
    var iti = window.intlTelInput(input, {
      initialCountry: 'auto',
      separateDialCode: true,
      geoIpLookup: function (callback) {
        fetch('https://ipapi.co/json')
          .then(function (res) { return res.json(); })
          .then(function (data) { callback(data.country_code); })
          .catch(function () { callback('us'); }); // fallback   
      },
    });

    if (input.form) {
      input.form.addEventListener('submit', function () {
        input.value = iti.getNumber();
      });
    }
  } catch (err) {
    // fail silently
  }
})();

})();



/* ==============================
   RB Step switching on load
   - If a ring setting is already selected (rb_setting_handle in localStorage),
     move UI to Step 2 (STONE) and show stone filters + grid.
================================= */
(function () {
  function activateStep2UI() {
    try {
      if (window.activateStep) {
        window.activateStep(2);
      } else {
        // fallback
        if (window.jQuery) {
          jQuery('.rb-step-grid[data-step="1"]').removeClass('is-active');
          jQuery('.rb-step-grid[data-step="2"]').addClass('is-active');
          jQuery('.rb-grid[data-step="2"]').css('display','grid');
          jQuery('.rb-grid[data-step="1"]').hide();
        }
      }
    } catch (e) {}
  }

  function boot() {
    try {
      var savedHandle = localStorage.getItem('rb_setting_handle'); 
      if (savedHandle) {
        activateStep2UI();
        // Some themes re-run section JS after DOMContentLoaded; re-assert step 2 once.
        setTimeout(function(){ try { activateStep2UI(); } catch(e){} }, 50);
        // Ensure step headers reflect persisted selection immediately
        try { if (window.updateHeadersFromStorage) window.updateHeadersFromStorage(); } catch (e) {}
      } else {
        // Still paint headers (clears placeholders correctly)
        try { if (window.updateHeadersFromStorage) window.updateHeadersFromStorage(); } catch (e) {}
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ==============================
   RB Step 2 — Diamond search grid
   - Consumes rb:setting:selected event
   - Reads current filter UI values from Step 2
   - Calls /api/get-vdb-diamond and renders results
================================= */
(function () {
  var API_URL = 'https://apirj.renaissancejewel.com/api/get-vdb-diamond';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function isVisible(el) {
    if (!el) return false;
    // hidden attribute
    if (el.hidden) return false;
    // display none / detached
    if (el.offsetParent === null && getComputedStyle(el).position !== 'fixed') return false;
    return true;
  }

  function getStep2Grid(preferEl) {
    // IMPORTANT: the template renders *two* step-2 grids (desktop + mobile).
    // The first .rb-grid[data-step="2"] in the DOM might be the hidden one, which breaks
    // event scoping + filter reads. Always prefer:
    //  1) the grid that contains the interacted element
    //  2) a visible desktop grid
    //  3) any other visible grid
    //  4) fallback to the first match
    if (preferEl && preferEl.closest) {
      var within = preferEl.closest('.rb-grid[data-step="2"]');
      if (within) return within;
    }

    var grids = qsa('.rb-grid[data-step="2"]');
    if (!grids.length) return null;

    // visible, non-mobile first
    var visDesktop = grids.find(function (g) {
      return isVisible(g) && !g.classList.contains('mobile-grid');
    });
    if (visDesktop) return visDesktop;

    var visAny = grids.find(function (g) { return isVisible(g); });
    if (visAny) return visAny;

    return grids[0] || null;
  }

  

  function getStep2DesktopGrid() {
    var grids = qsa('.rb-grid[data-step="2"]');
    if (!grids.length) return null;
    var desktop = grids.find(function (g) { return !g.classList.contains('mobile-grid'); });
    return desktop || grids[0] || null;
  }

  function rbSetRangeCardValues(card, fromValue, toValue, opts) {
    if (!card) return;

    opts = opts || {};

    var from = card.querySelector('[data-rb-from]');
    var to = card.querySelector('[data-rb-to]');
    var minDisplay = card.querySelector('[data-rb-min-display]');
    var maxDisplay = card.querySelector('[data-rb-max-display]');
    var minHidden = card.querySelector('[data-rb-min]');
    var maxHidden = card.querySelector('[data-rb-max]');

    if (from) from.value = fromValue;
    if (to) to.value = toValue;
    if (minHidden) minHidden.value = fromValue;
    if (maxHidden) maxHidden.value = toValue;

    var labels = qsa('.rb-range-label-wrapper .rb-range-label', card).map(function (el) {
      return (el.getAttribute('value') || el.textContent || '').trim();
    }).filter(Boolean);

    if (minDisplay && maxDisplay) {
      if (labels.length) {
        minDisplay.value = labels[fromValue] != null ? labels[fromValue] : '';
        maxDisplay.value = labels[toValue] != null ? labels[toValue] : '';
      } else if (opts.displayFrom != null || opts.displayTo != null) {
        minDisplay.value = opts.displayFrom != null ? opts.displayFrom : fromValue;
        maxDisplay.value = opts.displayTo != null ? opts.displayTo : toValue;
      } else {
        minDisplay.value = fromValue;
        maxDisplay.value = toValue;
      }
    }

    try {
      if (from) from.dispatchEvent(new Event('input', { bubbles: true }));
      if (to) to.dispatchEvent(new Event('input', { bubbles: true }));
      if (minDisplay) minDisplay.dispatchEvent(new Event('change', { bubbles: true }));
      if (maxDisplay) maxDisplay.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }

  function rbFindStep2CardByExactTitle(title, ctxEl) {
    var grid = getStep2DesktopGrid() || getStep2Grid(ctxEl);
    if (!grid) return null;

    title = String(title || '').trim().toLowerCase();

    return qsa('.rb-card', grid).find(function (card) {
      var t = card.querySelector('.rb-title');
      return t && String(t.textContent || '').trim().toLowerCase() === title;
    }) || null;
  }

  function rbApplyNaturalDiamondPresets(ctxEl) {
    var caratCard = rbFindStep2CardByExactTitle('carat', ctxEl);
    var colorCard = rbFindStep2CardByExactTitle('color', ctxEl);
    var clarityCard = rbFindStep2CardByExactTitle('clarity', ctxEl);
    var priceCard = rbFindStep2CardByExactTitle('price', ctxEl);
    var polishCard = rbFindStep2CardByExactTitle('polish', ctxEl);
    var symmetryCard = rbFindStep2CardByExactTitle('symmetry', ctxEl);
    var fluorescenceCard = rbFindStep2CardByExactTitle('fluorescence', ctxEl);

    if (caratCard) {
      rbSetRangeCardValues(caratCard, 15, 1000, {
        displayFrom: 0.15,
        displayTo: 10
      });
    }

    if (colorCard) {
      var whiteTab = colorCard.querySelector('[data-rb-color="white"], [data-rb-color-tab="white"]');
      var fancyTab = colorCard.querySelector('[data-rb-color="fancy"], [data-rb-color-tab="fancy"]');

      if (whiteTab && fancyTab) {
        whiteTab.classList.add('active');
        fancyTab.classList.remove('active');
      }

      qsa('[data-color-type]', colorCard).forEach(function (wrap) {
        var type = String(wrap.getAttribute('data-color-type') || '').toLowerCase();
        wrap.style.display = type === 'white' ? '' : 'none';
      });

      qsa('[data-rb-fancy-color]', colorCard).forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.classList.remove('active');
      });

      rbSetRangeCardValues(colorCard, 0, 5); // D -> I
    }

    if (clarityCard) rbSetRangeCardValues(clarityCard, 0, 5); // IF -> SI1
    if (priceCard) rbSetRangeCardValues(priceCard, 0, 400000000); // 0 -> 4,000,000
    if (polishCard) rbSetRangeCardValues(polishCard, 0, 5);
    if (symmetryCard) rbSetRangeCardValues(symmetryCard, 0, 5);
    if (fluorescenceCard) rbSetRangeCardValues(fluorescenceCard, 0, 4);
  }

  function rbApplyLabDiamondPresets(ctxEl) {
    var caratCard = rbFindStep2CardByExactTitle('carat', ctxEl);
    var colorCard = rbFindStep2CardByExactTitle('color', ctxEl);
    var clarityCard = rbFindStep2CardByExactTitle('clarity', ctxEl);
    var priceCard = rbFindStep2CardByExactTitle('price', ctxEl);
    var polishCard = rbFindStep2CardByExactTitle('polish', ctxEl);
    var symmetryCard = rbFindStep2CardByExactTitle('symmetry', ctxEl);
    var fluorescenceCard = rbFindStep2CardByExactTitle('fluorescence', ctxEl);
    var labCard = rbFindStep2CardByExactTitle('lab', ctxEl);

    if (caratCard) {
      rbSetRangeCardValues(caratCard, 200, 1000, {
        displayFrom: 2,
        displayTo: 10
      });
    }

    if (colorCard) {
      var whiteTab = colorCard.querySelector('[data-rb-color="white"], [data-rb-color-tab="white"]');
      var fancyTab = colorCard.querySelector('[data-rb-color="fancy"], [data-rb-color-tab="fancy"]');

      if (whiteTab && fancyTab) {
        whiteTab.classList.add('active');
        fancyTab.classList.remove('active');
      }

      qsa('[data-color-type]', colorCard).forEach(function (wrap) {
        var type = String(wrap.getAttribute('data-color-type') || '').toLowerCase();
        wrap.style.display = type === 'white' ? '' : 'none';
      });

      qsa('[data-rb-fancy-color]', colorCard).forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.classList.remove('active');
      });

      rbSetRangeCardValues(colorCard, 0, 2); // D -> F
    }

    if (clarityCard) rbSetRangeCardValues(clarityCard, 0, 3); // IF -> VS1
    if (priceCard) rbSetRangeCardValues(priceCard, 0, 10000000); // $0 -> $40000
    if (polishCard) rbSetRangeCardValues(polishCard, 0, 5); // full
    if (symmetryCard) rbSetRangeCardValues(symmetryCard, 0, 5); // full
    if (fluorescenceCard) rbSetRangeCardValues(fluorescenceCard, 0, 4); // full

    if (labCard) {
      qsa('.rb-tile', labCard).forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.classList.remove('active');
      });
    }
    
  }

  function inStep2MobilePopup(el) {
    try { return !!(el && el.closest && el.closest('.rb-modal-popup[id$="_stone_modal"]')); } catch (e) { return false; }
  }

  function isShapeTitle(txt) {
    txt = String(txt || '').trim().toLowerCase();
    return txt === 'shape' || txt === 'supported shape';
  }

  function getDiamondType(ctxEl) {
    var grid = getStep2Grid(ctxEl);
    if (!grid) return 'lab';
    var active = document.querySelector('.desktop-view .diamond-swatch.is-active');
    console.log(isMobileView() + ' isMobileView')
    if(isMobileView()){
      active = document.querySelector('.mobile-view .diamond-swatch.is-active');
    }
    return active ? (active.getAttribute('data-type') || 'diamond') : 'diamond';
  }

  function getActiveShapes(ctxEl) {
    var grid = getStep2Grid(ctxEl);
    if (!grid) return [];       
    // Shape card contains h3 rb-title "Shape"
    var card = qsa('.rb-card', grid).find(function (c) {
      var t = c.querySelector('.rb-title');
      return t && isShapeTitle(t.textContent);  
    });
    if (!card) return [];
    // allow multi-select: all active tiles in this card  
    var act = qsa('.rb-tile.is-active', card).map(function (a) {
      var lbl = a.querySelector('.rb-label');
      return (lbl ? lbl.textContent.trim() : '').replace(/\s+/g, ' ');
    }).filter(Boolean);
    // If none are active (because template uses plain links), default to the first visible tile
    if (!act.length) {
      var first = card.querySelector('.rb-tile .rb-label');
      if (first) act = [first.textContent.trim()];
    }
    return act;
  }

  function normalizeShapeLabel(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[^a-z ]/g, '');
  }

  function syncStep2ShapeFromRing(ctxEl) {
    // Goal: Step-2 "Shape" filter should mirror the ring-step selected shape
    var ringShape = '';
    try {
      var rs = localStorage.getItem('rb_setting');
      if (rs) {
        var rj = JSON.parse(rs);
        ringShape = (rj && (rj.shape || rj.current_shape || rj.currentShape)) ? (rj.shape || rj.current_shape || rj.currentShape) : '';
      }
    } catch (e) {}
    if (!ringShape) return;

    var grid = getStep2Grid(ctxEl);
    if (!grid) return;    

    // Find the "Shape" card
    var card = qsa('.rb-card', grid).find(function (c) {
      var t = c.querySelector('.rb-title');
      return t && isShapeTitle(t.textContent);
    });
    if (!card) return;

    var target = normalizeShapeLabel(ringShape);  
    var tiles = qsa('.rb-tile', card);
    if (!tiles.length) return;

    // Try exact match, then singular/plural fallback
    var found = null;
    tiles.some(function (tile) {
      var lbl = tile.querySelector('.rb-label');
      var txt = lbl ? lbl.textContent.trim() : '';
      var n = normalizeShapeLabel(txt);
      if (n === target) { found = tile; return true; }
      return false;
    });

    if (!found) {
      var targetSing = target.replace(/s\b/g, '');
      tiles.some(function (tile) {
        var lbl = tile.querySelector('.rb-label');
        var txt = lbl ? lbl.textContent.trim() : '';
        var n = normalizeShapeLabel(txt);
        if (n.replace(/s\b/g, '') === targetSing) { found = tile; return true; }
        return false;
      });
    }

    if (!found) return;

    // Single-select: clear others and activate the matched tile
    tiles.forEach(function (t) { t.classList.remove('is-active'); });
    found.classList.add('is-active');

    // If the tile contains a nested anchor (some themes do), prevent navigation and keep state purely in JS
    try {
      var a = found.querySelector('a');
      if (a) a.setAttribute('href', 'javascript:void(0)');
    } catch (e) {}
  }


  function getRangeByTitle(title, ctxEl) {
    var grid = getStep2Grid(ctxEl);
    if (!grid) return null;
    title = String(title || '').trim().toLowerCase();
    var card = qsa('.rb-card', grid).find(function (c) {
      var t = c.querySelector('.rb-title');   
      return t && t.textContent.trim().toLowerCase() === title;
    });
    if (!card) return null;

    var from = card.querySelector('input[type="range"][data-rb-from]');
    var to   = card.querySelector('input[type="range"][data-rb-to]');
    if (!from || !to) return null;

    var labels = qsa('.rb-range-label-wrapper .rb-range-label', card).map(function (el) {
      return el.getAttribute('value') || el.textContent.trim();
    }).filter(Boolean);

    var fromV = from.value;
    var toV   = to.value;

    return { from: fromV, to: toV, labels: labels, card: card };
  }

  function rangeToLabelPair(r) {
    if (!r || !r.labels || !r.labels.length) return null;
    var i1 = Math.max(0, Math.min(r.labels.length - 1, parseInt(r.from, 10)));
    var i2 = Math.max(0, Math.min(r.labels.length - 1, parseInt(r.to, 10)));
    // ensure ordering
    var lo = Math.min(i1, i2);
    var hi = Math.max(i1, i2);
    return { from: r.labels[lo], to: r.labels[hi] };
  }
 
  function num(v, fallback) {
    var n = Number(v);
    return isFinite(n) ? n : fallback;
  }

  function isMobileView() {
    // Checks if the screen width is less than or equal to a common mobile breakpoint (e.g., 768px)
    const mobileBreakpoint = 768; 
    return window.matchMedia(`(max-width: ${mobileBreakpoint}px)`).matches;
  }

  function buildRequest(page, ctxEl) {
    page = page || 1;

    var effectiveCtx = ctxEl || getStep2Grid();
    var cameFromMobile =
      inStep2MobilePopup(effectiveCtx) ||
      !!(effectiveCtx && effectiveCtx.classList && effectiveCtx.classList.contains('mobile-grid')) ||
      !!(effectiveCtx && effectiveCtx.closest && effectiveCtx.closest('.rb-grid.mobile-grid[data-step="2"]'));

    // Mobile UI is only a summary/popup layer.
    // Always read the actual filter values from desktop step-2 controls.
    if (cameFromMobile) {
      try {
        if (window.rbSyncMobileStep2ToDesktop) {
          window.rbSyncMobileStep2ToDesktop(effectiveCtx);
        }
      } catch (e) {}

      ctxEl = getStep2DesktopGrid() || effectiveCtx;
    } else {
      ctxEl = effectiveCtx;
    }

    var req = {
      page: page,
      limit: 50,
      sortKey: 'cut',
      sortOrder: 'DESC',
      i_search: {
        diamond_type: getDiamondType(ctxEl),
        lst_shape: getActiveShapes(ctxEl),
      },
    };

    var carat = getRangeByTitle('Carat', ctxEl);
    if (carat) {
      if (isMobileView()) {
        req.i_search.carat_from = num(carat.from, 0) / 100;
        req.i_search.carat_to   = num(carat.to, 0) / 100;
      } else {
        req.i_search.carat_from = num(carat.from, 0) / 100;
        req.i_search.carat_to   = num(carat.to, 0) / 100;
      }
    }

    var price = getRangeByTitle('Price', ctxEl);
    if (price) {
      req.i_search.price_from = num(price.from / 100, 0);
      req.i_search.price_to   = num(price.to / 100, 0);
    }

    var color = getRangeByTitle('Color', ctxEl);
    var colorPair = rangeToLabelPair(color);
    if (colorPair) {
      req.i_search.color_from = colorPair.to;
      req.i_search.color_to   = colorPair.from;
    }

    var grid = getStep2Grid(ctxEl);
    var colorCard = null;
    if (grid) {
      colorCard = qsa('.rb-card', grid).find(function (c) {
        var t = c.querySelector('.rb-title');
        return t && t.textContent.trim().toLowerCase() === 'color';
      }) || null;
    }

    var colorMode = 'white';
    if (colorCard) {
      var activeColorTab = colorCard.querySelector('.rb-swatch.active[data-rb-color]');
      if (activeColorTab) {
        colorMode = String(activeColorTab.getAttribute('data-rb-color') || 'white').toLowerCase();
      }
    }

    if (color && color.card) {
      if (colorMode === 'fancy') {
        req.i_search.is_fancy = 1;

        var activeFancyEls = colorCard
          ? Array.prototype.slice.call(
              colorCard.querySelectorAll('[data-rb-fancy-color].is-active, [data-rb-fancy-color].active')
            )
          : [];
          var ismobile = isMobileView();
       
        if(ismobile == false){
          activeFancyEls = colorCard
          ? Array.prototype.slice.call(
              colorCard.querySelectorAll('.desktop-view [data-rb-fancy-color].is-active')
            )
          : [];
         
        }  

        var fancyColors = activeFancyEls
          .map(function (el) {
            return String(el.getAttribute('data-rb-fancy-color') || '').trim();
          })
          .filter(Boolean);

        if (fancyColors.length) {
          req.i_search.lst_fancy_color = fancyColors;
        } else {
          delete req.i_search.lst_fancy_color;
        }

        delete req.i_search.color_from;
        delete req.i_search.color_to;
      } else {
        req.i_search.is_fancy = 0;
        delete req.i_search.lst_fancy_color;
      }
    }

    var clarity = getRangeByTitle('Clarity', ctxEl);
    var clarityPair = rangeToLabelPair(clarity);
    if (clarityPair) {
      req.i_search.clarity_from = clarityPair.to;
      req.i_search.clarity_to   = clarityPair.from;
    }

    var polish = getRangeByTitle('Polish', ctxEl);
    var polishPair = rangeToLabelPair(polish);
    if (polishPair) {
      req.i_search.polish_from = polishPair.from;
      req.i_search.polish_to   = polishPair.to;
    }

    var sym = getRangeByTitle('Symmetry', ctxEl);
    var symPair = rangeToLabelPair(sym);
    if (symPair) {
      req.i_search.symmetry_from = symPair.from;
      req.i_search.symmetry_to   = symPair.to;
    }

    var fluor = getRangeByTitle('Fluorescence', ctxEl);
    var fluorPair = rangeToLabelPair(fluor);
    if (fluorPair) {
      req.i_search.fluorescence_from = fluorPair.from;
      req.i_search.fluorescence_to   = fluorPair.to;
    }

    grid = getStep2Grid(ctxEl);
    if (grid) {
      var labSwiper = grid.querySelector('[data-rb-swiper="lab"]');
      if (labSwiper) {
        var activeLabs = qsa('.rb-tile.is-active [data-rb-lab], .rb-tile.is-active', labSwiper)
          .map(function (btn) {
            return btn.getAttribute('data-rb-lab') || (btn.querySelector('.rb-label') ? btn.querySelector('.rb-label').textContent.trim() : '');
          })
          .filter(Boolean);

        if (!activeLabs.length) {
          activeLabs = qsa('[data-rb-lab]', labSwiper).map(function (btn) {
            return btn.getAttribute('data-rb-lab');
          }).filter(Boolean);
        }

        if (activeLabs.length) req.i_search.lst_lab = activeLabs;
      }
    }

    req.i_search.depth_percent_from = 1;
    req.i_search.depth_percent_to = 100;
    req.i_search.table_percent_from = 1;
    req.i_search.table_percent_to = 100;

    if (typeof req.i_search.is_fancy === 'undefined') req.i_search.is_fancy = 0;

    Object.keys(req.i_search).forEach(function (k) {
      if (!k) { delete req.i_search[k]; return; }
      var v = req.i_search[k];
      if (v === null || typeof v === 'undefined') { delete req.i_search[k]; return; }
      if (typeof v === 'string' && v.trim() === '') { delete req.i_search[k]; return; }
      if (Array.isArray(v) && v.length === 0) { delete req.i_search[k]; return; }
    });

    req.i_search.is_fancy = Number(req.i_search.is_fancy) ? 1 : 0;

    return req;
  }

  function renderStatus(text) {
    var wrap = qs('[data-rb-diamond-results]'); 
    if (!wrap) return;
    var el = qs('[data-rb-diamond-status]', wrap);
    if (el) el.textContent = text || '';
  }

  function renderCount(n) {
    var wrap = qs('[data-rb-diamond-results]');
    if (!wrap) return;
    var el = qs('[data-rb-diamond-count]', wrap);
    if (el) el.textContent = (n || 0) + ' Stones';
  }

  function getResultsEls() {
    var wrap = qs('[data-rb-diamond-results]');
    return {
      wrap: wrap,
      grid: wrap ? qs('[data-rb-diamond-grid]', wrap) : null,
      pager: wrap ? qs('[data-rb-diamond-pager]', wrap) : null,
      prev: wrap ? qs('[data-rb-diamond-prev]', wrap) : null,
      next: wrap ? qs('[data-rb-diamond-next]', wrap) : null,
      page: wrap ? qs('[data-rb-diamond-page]', wrap) : null,
    };
  }

  function showResults() {
    var els = getResultsEls();
    if (!els.wrap) return;
    els.wrap.hidden = false;

    // hide rings product grid when step 2
    var rings = qs('.rb-products');
    if (rings) rings.style.display = 'none';
  }

  
  function moneyUSD(n) {
    var num = Number(n);
    if (!isFinite(num)) return String(n || '');   
    // your API returns dollars already (e.g. 810). Keep $ and 2 decimals only if needed.
    return '$' + (Math.round(num * 100) / 100).toFixed(num % 1 === 0 ? 0 : 2);
  }

  function cardHTML(d) {
    var id = d.id != null ? String(d.id) : '';
    var shape = d.shape || '';
    var carat = d.carat != null ? d.carat : (d.weight != null ? d.weight : '');
    var color = d.color || '';
    var clarity = d.clarity || '';
    var cut = d.cut || '';
    var lab = d.lab || '';
    var price = d.price != null ? d.price : '';
    var img = d.image_url || '';
    var certId = d.certificate_id || '';
    var certUrl = d.cert_url || '';
    var videoUrl = d.video_url || '';

    var meta = [
      shape ? ('<span>' + shape + '</span>') : '',
      carat !== '' ? ('<span>' + carat + ' ct</span>') : '',
      color ? ('<span>' + color + '</span>') : '',
      clarity ? ('<span>' + clarity + '</span>') : '',
      cut ? ('<span>' + cut + '</span>') : '',
      lab ? ('<span>' + lab + '</span>') : ''
    ].filter(Boolean).join(' · ');

    var actions = '';
    if (certUrl) actions += '<a class="rb-diamond-card__link" href="' + certUrl + '" target="_blank" rel="noopener">Certificate</a>';
    if (videoUrl) actions += '<a class="rb-diamond-card__link" href="' + videoUrl + '" target="_blank" rel="noopener">Video</a>';

    // no image = no card
    if (!img) return '';

    return (
      '<div class="rb-diamond-card rb-product" data-rb-diamond-card data-diamond-id="' + id + '">' +
        '<div class="rb-diamond-card__img rb-img">' +
          '<img loading="lazy" src="' + img + '" alt="" ' +
          'onerror="this.onerror=null; var card=this.closest(\'[data-rb-diamond-card]\'); if(card){card.style.display=\'none\';}">' +
        '</div>' +
        '<div class="rb-diamond-card__body">' +
          '<div class="rb-diamond-card__title rb-pname">' + (certId ? ('Cert # ' + certId) : 'Diamond') + '</div>' +
          (meta ? '<div class="rb-diamond-card__meta rb-pname">' + meta + '</div>' : '') +
          (price !== '' ? '<div class="rb-diamond-card__price rb-pprice">' + moneyUSD(price) + '</div>' : '') +
          (actions ? '<div class="rb-diamond-card__links rb-pname" style="display:none;">' + actions + '</div>' : '') +
          '<button type="button" class="rb-btn rb-btn--primary rb-diamond-card__select vdb-rb-btn vdb-rb-btn-secondary vdbrb-add-to-cart-btn" data-rb-diamond-select style="display:none;">Select</button>' +
        '</div>' +
      '</div>'
    );
  }


  function renderList(items) {
    var els = getResultsEls();
    if (!els.grid) return;

    els.grid.innerHTML = '';

    if (!items || !items.length) {
      els.grid.innerHTML = '<div class="rb-empty">No stones found for selected filters.</div>';
      return;
    }

    var fallbackImage = "";

    // ensure image_url exists
    items = items.map(function(item) {
      if (!item.image_url) {
        item.image_url = fallbackImage;
      }
      return item;
    });

    els.grid.innerHTML = items.map(cardHTML).join('');

    // keep a lookup for Select actions
    lastItemsById = {};
    items.forEach(function(it){
      if (it && it.id != null) lastItemsById[String(it.id)] = it;
    });
  }

  var currentPage = 1;
  var lastReq = null;
  var lastItemsById = {};  // ----------------------------
  // Diamond modal (body-step="2")
  // ----------------------------
  function getStoneModalEls() {
    var modal = qs('.rb-modal[data-rb-modal]');
    if (!modal) return null;

    var body2 = modal.querySelector('.rb-modal__body[body-step="2"]');
    if (!body2) return null;

    return {
      modal: modal,
      // IMPORTANT: overlay in template is: .rb-modal__overlay[data-rb-modal-overlay]
      overlay: qs('.rb-modal__overlay[data-rb-modal-overlay]') || qs('.rb-modal__overlay') || qs('.rb-modal-overlay') || qs('[data-rb-overlay]'),
      body2: body2,
      title: body2.querySelector('[data-rb-title]'),
      sku: body2.querySelector('[data-rb-sku]'),     
      price: body2.querySelector('[data-rb-modal-price], [data-rb-price]'),
      thumbsWrap: body2.querySelector('[data-rb-thumbs-wrapper]'),
      mainWrap: body2.querySelector('[data-rb-main-wrapper]') || body2.querySelector('[data-rb-gallery-wrapper]') || body2.querySelector('.rb-modal-main-swiper .swiper-wrapper'),
      thumbsEl: body2.querySelector('[data-rb-thumbs-swiper]'),
      mainEl: body2.querySelector('[data-rb-main-swiper]') || body2.querySelector('.rb-modal-main-swiper'),
      addBtn: body2.querySelector('[data-rb-add-to-cart-setting]'),
    };
  }

  $(document).on('click', '.diamond-swatch', function () {
    var $grid = $(this).closest('.rb-grid');
    var swatchDType = String($(this).attr('data-dtype') || '').trim();

    $grid.find('.diamond-swatch').removeClass('is-active');
    $(this).addClass('is-active');

    if (swatchDType === 'diamond') {
      try {
        rbApplyNaturalDiamondPresets(this);
      } catch (e) {
        console.error(e);
      }
    } else if (swatchDType === 'lab_grown_diamond') {
      try {
        rbApplyLabDiamondPresets(this);
      } catch (e) {
        console.error(e);
      }
    }

    if (!window.__rbApplyingParamsOnly) {
      try {
        fetchDiamonds(1, getStep2DesktopGrid() || getStep2Grid(this) || this);
      } catch (e) {
        console.error(e);
      }
    }
  });
  $('.diamond-swatch[data-dtype="lab_grown_diamond"]').click()

  function closeStoneModal() {
    var els = getStoneModalEls();
    if (!els) return;
    try {
      els.modal.hidden = true;
      qsa('.rb-modal__body[body-step]', els.modal).forEach(function (b) { b.hidden = true; });
      // show step 2 body next open
      var body2 = els.modal.querySelector('.rb-modal__body[body-step="2"]');
      if (body2) body2.hidden = false;
    } catch (e) {}

    if (els.overlay) {
      try {
        els.overlay.classList && els.overlay.classList.remove('is-open');
        els.overlay.hidden = true;
        if (window.jQuery) jQuery(els.overlay).hide();
      } catch (e) {}
    }
    document.body.style.overflow = '';
  }

  function openStoneModalWithItem(item) {
    var els = getStoneModalEls();
    if (!els) return;

    // remember current stone item for Add-to-Ring
    try { window.__rbCurrentStoneItem = item || null; } catch (e) {}

    // Switch modal body to step 2, hide step 1
    qsa('.rb-modal__body[body-step]', els.modal).forEach(function (b) {
      b.hidden = b.getAttribute('body-step') !== '2';
    });

    // Fill meta
    if (els.title) els.title.textContent = item && item.title ? item.title : (item && item.shape ? (item.shape + ' ' + (item.carat || item.weight || '') + 'ct ' + (item.color || '') + ' ' + (item.clarity || '')) : '');
    if (els.sku) els.sku.textContent = item && item.certificate_id ? ('Certificate ID # ' + item.certificate_id) : (item && item.stock_no ? ('Certificate ID # ' + item.stock_no) : '');
    if (els.price) {
      var p = item && item.price != null ? item.price : '';
      els.price.textContent = p !== '' ? ('$' + String(p)) : '';
    }

    // Render gallery (image/video)
    renderStoneGallery(item, els);

    // Fill product details table
    fillStoneDetails(item, els.body2);

    // Open
    els.modal.hidden = false;
    if (els.overlay) {
      try { els.overlay.hidden = false; } catch (e) {}
      if (window.jQuery) jQuery(els.overlay).show();
      els.overlay.classList && els.overlay.classList.add('is-open');
    }
    document.body.style.overflow = 'hidden';
  }

  // ----------------------------
  // Review / Complete Ring modal (body-step="3")
  // ----------------------------
  
function getReviewModalEls() {
    // Preferred: Step 3 "Complete Ring" is rendered OUTSIDE the modal (inside Step 3 page area)
    var completeWrap = qs('.main-rb-modal__body.complete-step[complete-step="3"]');
    var body3Outside = completeWrap ? completeWrap.querySelector('.rb-modal__body[body-step="3"]') : null;

    if (completeWrap && body3Outside) {
      return {
        container: completeWrap,
        modal: null,
        overlay: qs('.rb-modal__overlay[data-rb-modal-overlay]') || qs('.rb-modal__overlay') || qs('.rb-modal-overlay') || qs('[data-rb-overlay]'),
        body3: body3Outside,
        ringImg: body3Outside.querySelector('.rb-ring-image'),
        ringStock: body3Outside.querySelector('.rb-ring-stock'),
        ringTitle: body3Outside.querySelector('.rb-ring-title'),
        ringPrice: body3Outside.querySelector('.rb-ring-price'),
        ringSizeSelect: body3Outside.querySelector('.ring-variant-list'),
        ringSizeUnknown: body3Outside.querySelector('#dont_know'),
        diamondImg: body3Outside.querySelector('.rb-diamond-image'),
        diamondStock: body3Outside.querySelector('.rb-diamond-stock'),
        diamondTitle: body3Outside.querySelector('.rb-diamond-title'),
        diamondPrice: body3Outside.querySelector('.rb-diamond-price'),
        subtotal: body3Outside.querySelector('.rb-subtotal-price'),
        addToCartBtn: body3Outside.querySelector('.atc-button'),
        startOverBtn: body3Outside.querySelector('.link-wrapper a:last-child'),
      };
    }

    // Fallback: legacy Step 3 inside the modal
    var modal = qs('.rb-modal[data-rb-modal]');
    if (!modal) return null;
    var body3 = modal.querySelector('.rb-modal__body[body-step="3"]');
    if (!body3) return null;

    return {
      container: null,
      modal: modal,
      overlay: qs('.rb-modal__overlay[data-rb-modal-overlay]') || qs('.rb-modal__overlay') || qs('.rb-modal-overlay') || qs('[data-rb-overlay]'),
      body3: body3,
      ringImg: body3.querySelector('.rb-ring-image'),
      ringStock: body3.querySelector('.rb-ring-stock'),
      ringTitle: body3.querySelector('.rb-ring-title'),
      ringPrice: body3.querySelector('.rb-ring-price'),
      ringSizeSelect: body3.querySelector('.ring-variant-list'),
      ringSizeUnknown: body3.querySelector('#dont_know'),
      diamondImg: body3.querySelector('.rb-diamond-image'),
      diamondStock: body3.querySelector('.rb-diamond-stock'),
      diamondTitle: body3.querySelector('.rb-diamond-title'),
      diamondPrice: body3.querySelector('.rb-diamond-price'),
      subtotal: body3.querySelector('.rb-subtotal-price'),
      addToCartBtn: body3.querySelector('.atc-button'),
      startOverBtn: body3.querySelector('.link-wrapper a:last-child'),
    };
  }

  function openReviewModal() {
    var els = getReviewModalEls();
    if (!els) return;

    // NEW: Step 3 lives outside modal
    if (els.container) {
      try { activateStep(3); } catch (e) {}
      fillReviewFromStorage();  
      els.container.hidden = false;

      // ensure modal is closed if exists
      try {
        var modal = qs('.rb-modal[data-rb-modal]');
        if (modal) modal.hidden = true;
      } catch (e2) {}

      // prevent overlay locking scroll
      try {
        var ov = els.overlay;
        if (ov) {
          try { ov.hidden = true; } catch (e3) {}
          ov.classList && ov.classList.remove('is-open');
          if (window.jQuery) jQuery(ov).hide();
        }
      } catch (e4) {}

      document.body.style.overflow = '';
      try { document.dispatchEvent(new CustomEvent('rb:step:3')); } catch (e5) {}
      try { els.container.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e6) {}
      return;
    }

    // Legacy: modal Step 3
    qsa('.rb-modal__body[body-step]', els.modal).forEach(function (b) {
      b.hidden = b.getAttribute('body-step') !== '3';
    });
    fillReviewFromStorage();
    els.modal.hidden = false;
    if (els.overlay) {
      try { els.overlay.hidden = false; } catch (e7) {}
      if (window.jQuery) jQuery(els.overlay).show();
      els.overlay.classList && els.overlay.classList.add('is-open');
    }
    document.body.style.overflow = 'hidden';
    try { document.dispatchEvent(new CustomEvent('rb:step:3')); } catch (e8) {}
  }

  function fillReviewFromStorage() {
    var els = getReviewModalEls();
    if (!els) return;

    var ringHandle = '';
    var ringVariantId = '';
    var ringPrice = '';
    var ringImage = '';
    var ringTitle = '';
    var ringStock = '';
    var ringSize = '';
  
    try {
      ringHandle = localStorage.getItem('rb_setting_handle') || '';
      ringVariantId = localStorage.getItem('rb_setting_variant_id') || '';
      ringPrice = localStorage.getItem('rb_setting_price') || '';
      ringImage = localStorage.getItem('rb_setting_image') || '';
      ringSize = localStorage.getItem('rb_setting_ring_size') || '';
      var rs = localStorage.getItem('rb_setting');
      if (rs) {
        var rj = JSON.parse(rs);
        ringTitle = rj && (rj.title || rj.product_title) ? (rj.title || rj.product_title) : '';
        ringStock = rj && (rj.sku || rj.stock_no) ? (rj.sku || rj.stock_no) : '';
      }

  // If purity/price changes while a ring is already selected, refresh totals immediately
  document.addEventListener('rb:pricing:changed', function () {
    try { fillReviewFromStorage(); } catch (e) {}
  });

    } catch (e) {}

    // stone
    var stone = null;  
    try {
      var sd = localStorage.getItem('rb_diamond');
      if (sd) stone = JSON.parse(sd);
    } catch (e) {} 

    // Ring UI
    if (els.ringImg) {
      els.ringImg.innerHTML = ringImage ? ('<img src="' + ringImage + '" alt="">') : '';
    }
    if (els.ringStock) els.ringStock.textContent = ringStock ? String(ringStock) : '';
    if (els.ringTitle) els.ringTitle.textContent = ringTitle || 'Ring';
    if (els.ringPrice) {
      var rp = ringPrice !== '' ? ('$' + String(ringPrice)) : '';
      // preserve label span if exists
      els.ringPrice.innerHTML = rp + '<span class="price-label">Setting Price</span>';
    }

    // Ensure step-3 Ring Size dropdown matches step-1 dropdown options (same placeholder + list)
    try {
      if (els.ringSizeSelect) {
        var step1Select = document.querySelector('[data-rb-modal] [data-rb-size-select]');
        if (step1Select && step1Select.options && step1Select.options.length) {
          // Copy options HTML once (keeps same labels/order)
          if (!els.ringSizeSelect.__rb_synced) {
            els.ringSizeSelect.innerHTML = step1Select.innerHTML;
            els.ringSizeSelect.__rb_synced = true;
          }
        }
      }
    } catch (e) {}

    // Ring size + "I don't know" (step 3)
    var ringSizeUnknown = '';
    try { ringSizeUnknown = localStorage.getItem('rb_setting_ring_size_unknown') || ''; } catch (e) {}

    console.log(ringSize)

    if(ringSize == 'dont-know'){
      ringSizeUnknown = '0';
    }

    if (els.ringSizeUnknown) {
      els.ringSizeUnknown.checked = !!(ringSizeUnknown && ringSizeUnknown !== '0');
    }

    if(ringSize == 'dont-know'){
      els.ringSizeUnknown.checked = true;
    }

    if (els.ringSizeSelect) {
      // If "don't know" is checked, force empty selection
      if (els.ringSizeUnknown && els.ringSizeUnknown.checked) {
        try { els.ringSizeSelect.value = ''; } catch (e) {}
      } else if (ringSize) {
        try { els.ringSizeSelect.value = String(ringSize); } catch (e) {}
      }
    }


    // Stone UI
    if (els.diamondImg) {
      var simg = stone && stone.image_url ? stone.image_url : '';
      els.diamondImg.innerHTML = simg ? ('<img src="' + simg + '" alt="">') : '';
    }

    // Step-3 media gallery: thumbnail should show stone image, main should show ring image
    try {
      if (els.body3) {
        var thumbImg = els.body3.querySelector('.media-gallery .secondary-image');
        var mainImg = els.body3.querySelector('.media-gallery .primary-image');
        var stoneImg = stone && stone.image_url ? String(stone.image_url) : '';
        var ringImgSrc = ringImage ? String(ringImage) : '';

        if (thumbImg) {
          // Prefer stone thumbnail; fallback to ring if stone missing
          var tSrc = stoneImg || ringImgSrc || thumbImg.getAttribute('src') || '';   
          if (tSrc) thumbImg.setAttribute('src', tSrc);
        }
        if (mainImg) {
          // Prefer ring as main; fallback to stone if ring missing
          var mSrc = ringImgSrc || stoneImg || mainImg.getAttribute('src') || '';
          if (mSrc) mainImg.setAttribute('src', mSrc);
        }
      }
    } catch (e) {}

    var stonecert = stone && stone.certificate_id ? String(stone.certificate_id) : '';
    if (els.diamondStock) els.diamondStock.innerHTML = `<div style="text-decoration:underline;cursor:pointer" onclick="window.open('${stone.cert_url}', '_blank').focus();" target="_blank">${stonecert}</div>`  ;
    if (els.diamondTitle) {
      if (stone) {
        var t = [stone.shape, (stone.carat ? (stone.carat + ' Ct') : ''), stone.color, stone.clarity, stone.cut, stone.lab].filter(Boolean).join(' · ');
        els.diamondTitle.textContent = t || 'Diamond';
      } else {
        els.diamondTitle.textContent = 'Diamond';
      }
    }
    if (els.diamondPrice) {
      var sp = stone && stone.price != null ? stone.price : '';
      els.diamondPrice.textContent = sp !== '' ? moneyUSD(sp) : '';
    }

    // subtotal
    var total = null;
    var rpNum = Number(String(ringPrice || '').replace(/[^0-9.]/g, ''));
    var spNum = stone && stone.price != null ? Number(stone.price) : NaN;
    if (isFinite(rpNum) || isFinite(spNum)) {
      total = (isFinite(rpNum) ? rpNum : 0) + (isFinite(spNum) ? spNum : 0);
    }
    if (els.subtotal) els.subtotal.textContent = total != null ? moneyUSD(total) : '';

    // persist current total + selection for cart properties
    try {
      if (total != null) localStorage.setItem('rb_total_price', String(total));
      if (ringVariantId) localStorage.setItem('rb_setting_variant_id', ringVariantId);
      if (ringHandle) localStorage.setItem('rb_setting_handle', ringHandle);
    } catch (e) {}
  }


  // Bind ring size controls in review (step 3) so they behave like step 1
  function bindReviewRingSizeControls() {
    if (document.__rbReviewRingSizeBound) return;
    document.__rbReviewRingSizeBound = true;

    document.addEventListener('change', function (e) {
      // ring size select change
      var sel = e.target && e.target.closest ? e.target.closest('.rb-modal__body[body-step="3"] .ring-variant-list') : null;
      if (sel) {
        // selecting a size unchecks "don't know"
        var body3 = sel.closest('.rb-modal__body[body-step="3"]');
        var unk = body3 ? body3.querySelector('#dont_know') : null;
        if (unk) {
          unk.checked = false;
          try { localStorage.setItem('rb_setting_ring_size_unknown', '0'); } catch (err) {}
        }

        var v = sel.value || '';
        try {
          localStorage.setItem('rb_setting_ring_size', v);
          var rs = localStorage.getItem('rb_setting');
          if (rs) {
            try {
              var rj = JSON.parse(rs);
              rj.ring_size = v;
              localStorage.setItem('rb_setting', JSON.stringify(rj));
            } catch (err2) {}
          }
        } catch (err3) {}

        try { fillReviewFromStorage(); } catch (err4) {}
        return;
      }

      // "don't know" checkbox change
      var cb = e.target && e.target.closest ? e.target.closest('.rb-modal__body[body-step="3"] #dont_know') : null;
      if (cb) {
        var body = cb.closest('.rb-modal__body[body-step="3"]');
        var select = body ? body.querySelector('.ring-variant-list') : null;

        if (cb.checked) {
          // clear selection
          if (select) {
            try { select.value = ''; } catch (err5) {}
          }
          try {
            localStorage.setItem('rb_setting_ring_size', '');
            localStorage.setItem('rb_setting_ring_size_unknown', '1');
            var rs2 = localStorage.getItem('rb_setting');
            if (rs2) {
              try {
                var rj2 = JSON.parse(rs2);
                rj2.ring_size = '';
                localStorage.setItem('rb_setting', JSON.stringify(rj2));
              } catch (err6) {}
            }
          } catch (err7) {}
        } else {
          try { localStorage.setItem('rb_setting_ring_size_unknown', '0'); } catch (err8) {}
        }

        try { fillReviewFromStorage(); } catch (err9) {}
      }
    }, true);
  }

  // Bind step-3 Change/View actions (same behavior as header steps)
  function bindReviewActions() {
    if (document.__rbReviewActionsBound) return;
    document.__rbReviewActionsBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.rb-modal__body[body-step="3"] .selected_buttons .select_button') : null;
      if (!btn) return;

      var isChange = btn.classList.contains('change-button');
      var isView = btn.classList.contains('view-button');
      var ringBox = btn.closest('.rb-ring-information');
      var stoneBox = btn.closest('.rb-diamond-information');

      function closeReviewModal() {
        var els = getReviewModalEls();
        if (!els) return;
        try {
          els.modal.hidden = true;
          qsa('.rb-modal__body[body-step]', els.modal).forEach(function (b) { b.hidden = true; });
          // default back to step 1 for next open
          var body1 = els.modal.querySelector('.rb-modal__body[body-step="1"]');
          if (body1) body1.hidden = false;
        } catch (err) {}

        if (els.overlay) {
          try {
            els.overlay.classList && els.overlay.classList.remove('is-open');
            els.overlay.hidden = true;
            if (window.jQuery) jQuery(els.overlay).hide();
          } catch (err2) {}
        }
        document.body.style.overflow = '';
      }

      if (ringBox) {
        if (isChange) {
          e.preventDefault();
          closeReviewModal();
          activateStep(1);
          return;
        }
        if (isView) {
          e.preventDefault();
          try { openRingModalByHandle(localStorage.getItem('rb_setting_handle') || ''); } catch (err3) {}
          return;
        }
      }

      if (stoneBox) {
        if (isChange) {
          e.preventDefault();
          closeReviewModal();
        //  try { localStorage.removeItem('rb_diamond'); } catch (err4) {}
          try { updateHeadersFromStorage(); } catch (err5) {}
          activateStep(2);
          try { document.dispatchEvent(new CustomEvent('rb:step:2')); } catch (err6) {}
          return;
        }
        if (isView) {
          e.preventDefault();
          try {
            var s = localStorage.getItem('rb_diamond');
            if (s && window.rbOpenStoneModal) window.rbOpenStoneModal(JSON.parse(s));
          } catch (err7) {}
          return;
        }
      }
    }, true);
  }

  // init review bindings
  try { bindReviewRingSizeControls(); } catch (e) {}
  try { bindReviewActions(); } catch (e) {}

  async function addCompletedRingToCart() {
    var ringVariantId = '';
    var ringPrice = '';
    try {
      ringVariantId = localStorage.getItem('rb_setting_variant_id') || '';
      ringPrice = localStorage.getItem('rb_setting_price') || '';
    } catch (e) {}

    if (!ringVariantId) return;

    var engravingVal = '';
    try { engravingVal = localStorage.getItem('rb_setting_engraving') || ''; } catch (e) {}

    var stone = null;
    try {
      var sd = localStorage.getItem('rb_diamond');
      if (sd) stone = JSON.parse(sd);
    } catch (e) {}

    var rb_setting = null;
    try {
      var sds = localStorage.getItem('rb_setting');
      if (sds) rb_setting = JSON.parse(sds);
    } catch (e) {}

    var total = '';
    try { total = localStorage.getItem('rb_total_price') || ''; } catch (e) {}

    // properties to attach to ring line item
    // NOTE: Shopify treats underscore-prefixed keys as "hidden" in many UIs.
    // User requested: all fields visible + Capitalized, except _totalPrice.
    var goldPurity = '';
    try { goldPurity = localStorage.getItem('rb_setting_purity') || ''; } catch (e) {}
    var ringSizeVal = '';
    var ringSizeUnknown = '';
    try { ringSizeVal = localStorage.getItem('rb_setting_ring_size') || ''; } catch (e) {}
    try { ringSizeUnknown = localStorage.getItem('rb_setting_ring_size_unknown') || ''; } catch (e) {}

    var engraving = $('.engraving_input').val();

    var props = {
      'Stone Id': stone && stone.id ? String(stone.id) : '',
      'Stone Cert': stone && stone.certificate_id ? String(stone.certificate_id) : '',
      'Stone Shape': stone && stone.shape ? String(stone.shape) : '',
      'Stone Carat': stone && stone.carat != null ? String(stone.carat) : '',
      'Stone Color': stone && stone.color ? String(stone.color) : '',
      'Stone Clarity': stone && stone.clarity ? String(stone.clarity) : '',
      'Stone Cut': stone && stone.cut ? String(stone.cut) : '',
      'Stone Lab': stone && stone.lab ? String(stone.lab) : '',
      'Stone Price': stone && stone.price != null ? String(stone.price) : '',
      'Stone Video': stone && stone.video_url ? String(stone.video_url) : '',
      'Stone Cert': stone && stone.cert_url ? String(stone.cert_url) : '',
      '_Stone Image': stone && stone.image_url ? String(stone.image_url) : '',
      '_Stone Url': stone && stone.video_url ? String(stone.video_url) : '',
      'Metal Type': rb_setting && rb_setting.metal ? String(rb_setting.metal) : '',
      'Gold Purity': goldPurity ? String(goldPurity) : '',
      'Ring Size': (ringSizeUnknown && ringSizeUnknown !== '0') ? "I Don't Know" : (ringSizeVal ? String(ringSizeVal) : ''),
      'Engraving': engravingVal ? String(engravingVal) : '',
      _totalPrice: total || '',
    };
    // clean empties
    Object.keys(props).forEach(function (k) {
      if (k === '_totalPrice') return;
      if (props[k] === '') delete props[k];
    });

    var payload = {
      items: [
        {
          id: Number(ringVariantId),
          quantity: 1,
          properties: props,
        },
      ],
    };

    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      try { console.error('Add to cart failed', await res.text()); } catch (e) {}
      return;
    }

    // Clear selections so Ring Builder starts from scratch next time
    clearRingBuilderSelections();

    // If theme has cart drawer events, trigger; else go to cart.
    //try { document.dispatchEvent(new CustomEvent('opencartdrawer')); } catch (e) {}
    try { window.location.href = '/cart'; } catch (e) {}
  }

  // expose for header "View" on stone
  try { window.rbOpenStoneModal = openStoneModalWithItem; } catch (e) {}

  // Close binding for stone modal
  if (!document.__rbStoneModalCloseBound) {
    document.__rbStoneModalCloseBound = true;
    document.addEventListener('click', function (e) {
      // close by close buttons
      if (e.target.closest && e.target.closest('[data-rb-modal-close], .rb-modal__back, .cross-popup')) {
        e.preventDefault();
        closeStoneModal();
        return;
      }
      // close by overlay
      if (e.target.closest && e.target.closest('.rb-modal__overlay[data-rb-modal-overlay]')) {
        e.preventDefault();
        closeStoneModal();
        return;
      }
    }, true);
  }

  // Add-to-Ring in stone modal (button uses data-rb-add-to-cart-setting in template)
  if (!document.__rbStoneAddToRingBound) {
    document.__rbStoneAddToRingBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.rb-modal__body[body-step="2"] [data-rb-add-to-cart-setting]') : null;
      if (!btn) return;

      e.preventDefault();

      var item = null;
      try { item = window.__rbCurrentStoneItem || null; } catch (err) {}

      // If modal was opened via list click, we might not have item. Try fallback from storage.
      if (!item) {
        try {
          var sd = localStorage.getItem('rb_diamond');
          if (sd) item = JSON.parse(sd);
        } catch (err2) {}
      }

      // Persist selection (same payload as Select in list)
      if (item) {
        var payload = {
          id: item.id != null ? String(item.id) : (item.diamond_id ? String(item.diamond_id) : ''),
          certificate_id: item.certificate_id || '',
          shape: item.shape || '',
          carat: (item.carat != null ? item.carat : (item.weight != null ? item.weight : '')),
          color: item.color || '',
          clarity: item.clarity || '',
          cut: item.cut || '',
          lab: item.lab || '',
          price: item.price != null ? item.price : '',
          image_url: item.image_url || '',
          video_url: item.video_url || '',
          cert_url: item.cert_url || '',
          ts: Date.now(),
        };
        try { localStorage.setItem('rb_diamond', JSON.stringify(payload)); } catch (err3) {}
        try { if (window.updateHeadersFromStorage) window.updateHeadersFromStorage(); } catch (err4) {}
      }

      // Close stone modal and open review modal (step 3)
      closeStoneModal();
      openReviewModal();
    }, true);
  }

  
  // Step-3 Start Over button/link
  if (!document.__rbStartOverBound) {
    document.__rbStartOverBound = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.rb-modal__body[body-step="3"] .link-wrapper a:last-child') : null;
      if (!a) return;
      e.preventDefault();
      try { clearRingBuilderSelections(); } catch (err) {}
      try { window.location.reload(); } catch (err2) {
        try { window.location.href = window.location.pathname + window.location.search; } catch (err3) {}
      }
    }, true);
  }

// Step-3 Add to Cart button
  if (!document.__rbReviewATCBound) {
    document.__rbReviewATCBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.rb-modal__body[body-step="3"] .atc-button') : null;
      if (!btn) return;
      e.preventDefault();
      addCompletedRingToCart();
    }, true);
  }

  // Uses Swiper if present, but also works without it (shows first image)
  var stoneThumbsSwiper = null;
  var stoneMainSwiper = null;

  function destroyStoneSwipers() {
    try { if (stoneThumbsSwiper && stoneThumbsSwiper.destroy) stoneThumbsSwiper.destroy(true, true); } catch (e) {}
    try { if (stoneMainSwiper && stoneMainSwiper.destroy) stoneMainSwiper.destroy(true, true); } catch (e) {}
    stoneThumbsSwiper = null;
    stoneMainSwiper = null;
  }

  function renderStoneGallery(item, els) {
    if (!els) return;

    // Prefer VDB image_url/video_url/cert_url
    // Main gallery should only contain image/video. Certificate opens in a new tab.
    var media = [];
    var thumbs = [];
    var poster = item && item.image_url ? item.image_url : '';

    // Images
    if (item && item.image_url) {
      media.push({ type: 'image', src: item.image_url });
      thumbs.push({ type: 'image', src: item.image_url });
    }
    // Some APIs return array of images
    if (item && Array.isArray(item.images)) {
      item.images.forEach(function (u) {
        if (!u) return;
        media.push({ type: 'image', src: u });
        thumbs.push({ type: 'image', src: u });
      });
    }

    // Video (add first)
    if (item && item.video_url) {
      // Some vendors provide a 360 html viewer instead of mp4.
      var isMp4 = String(item.video_url).toLowerCase().indexOf('.mp4') !== -1;
      media.unshift({ type: isMp4 ? 'video' : 'iframe', src: item.video_url, poster: poster });
      thumbs.unshift({ type: 'video', src: item.video_url, poster: poster });
    }

    // Certificate (thumb only)
    if (item && item.cert_url) {
      thumbs.push({ type: 'cert', src: item.cert_url });
    }

    if (!els.thumbsWrap) return;

    // If main wrapper doesn't exist in markup, reuse thumbs wrapper as a fallback (still shows something)
    var mainWrap = els.mainWrap || els.thumbsWrap;

    destroyStoneSwipers();
    els.thumbsWrap.innerHTML = '';
    if (mainWrap) mainWrap.innerHTML = '';
   
    if (!thumbs.length && !media.length) return;

    // main slides
    media.forEach(function (m) {
      if (!mainWrap) return;
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      if (m.type === 'iframe') {
        slide.innerHTML = '<div class="image media" style="position:relative;padding-top:100%;"><iframe src="' + m.src + '" title="Stone video" style="z-index:2;position:absolute;inset:0;width:100%;height:100%;border:0" allowfullscreen></iframe></div>';
      } else if (m.type === 'video') {
        var posterAttr = m.poster ? (' poster="' + m.poster + '"') : '';
        slide.innerHTML = '<div class="image media"><video controls playsinline' + posterAttr + ' src="' + m.src + '" style="max-width:100%;height:auto"></video></div>';
      } else {
        slide.innerHTML = '<div class="image media"><img src="' + m.src + '" alt=""></div>';
      }
      mainWrap.appendChild(slide);
    });

    // thumb slides (image/video/cert)
    thumbs.forEach(function (m) {
      var t = document.createElement('div');
      t.className = 'swiper-slide';
      if (m.type === 'cert') {
        t.setAttribute('data-rb-cert-thumb', '1');
        t.setAttribute('data-cert-url', m.src);
        t.innerHTML =
          '<div class="image media">'
          + '<img src="https://cdn.shopify.com/s/files/1/0696/3707/9274/files/delolma-tab.avif?v=1771583830" alt="">'
          + '</div>';
      } else if (m.type === 'video') {
        // Use poster (image_url) for the thumb if available, otherwise show a simple play label.
        if (m.poster) {
          t.innerHTML = '<div class="image media" style="position:relative;"><img src="' + m.poster + '" alt=""><span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-weight:700;background:rgba(255,255,255,.35);">▶</span></div>';
        } else {
          t.innerHTML = '<div class="image media" ><img src="https://cdn.shopify.com/s/files/1/0696/3707/9274/files/video-icon.jpg?v=1772008563" alt=""></div>';
        }
      } else {
        t.innerHTML = '<div class="image media"><img src="' + m.src + '" alt=""></div>';
      }
      els.thumbsWrap.appendChild(t);
    });

    // init swiper if both wrappers exist and Swiper loaded
    if (window.Swiper && els.thumbsEl && els.mainEl && mainWrap !== els.thumbsWrap) {
      try {
        
              var nextBtn = els.modal.querySelector('.rb-modal-main-next, [data-rb-main-next], #rb-modal-main-next');
              var prevBtn = els.modal.querySelector('.rb-modal-main-prev, [data-rb-main-prev], #rb-modal-main-prev');
              var nextBtnt = els.modal.querySelector('.swiper-button-next');
              var prevBtnt = els.modal.querySelector('.swiper-button-prev');
        stoneThumbsSwiper = new Swiper(els.thumbsEl, {
                // slidesPerView: 'auto',
                slidesPerView: 4,
                direction: 'horizontal', 
                spaceBetween: 10,
                freeMode: true,
                // allowTouchMove: false, 
                // simulateTouch: false,   
                watchSlidesProgress: true,
                navigation: {
                  nextEl: nextBtnt,
                  prevEl: prevBtnt,
                },
                breakpoints: {
                  500: {
                    slidesPerView: 5,
                    direction: 'horizontal', 
                    spaceBetween: 10,
                  },
                  700: {
                    direction: 'vertical', 
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                  }, 
                },
        });

        stoneMainSwiper = new Swiper(els.mainEl, {
          slidesPerView: 1,
          thumbs: { swiper: stoneThumbsSwiper },
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
        });
        
       } catch (e) {}
    }

    // Certificate thumb click -> open new tab
    // Use capture so Swiper doesn't swallow it.
    if (!els.thumbsWrap.__rbCertBound) {
      els.thumbsWrap.__rbCertBound = true;
      els.thumbsWrap.addEventListener('click', function (ev) {
        var cert = ev.target && ev.target.closest ? ev.target.closest('[data-rb-cert-thumb]') : null;
        if (!cert) return;
        var url = cert.getAttribute('data-cert-url') || '';
        if (!url) return;
        ev.preventDefault();
        ev.stopPropagation();
        window.open(url, '_blank', 'noopener');
      }, true);
    }
  }

  // Fill the "Product Details" list inside step-2 stone modal from the API item.
  // Markup is static (no data attrs), so we match by label text.
  function fillStoneDetails(item, body2) {
    if (!body2 || !item) return;
    var container = body2.querySelector('.rb-description-container') || body2;
    if (!container) return;

    function norm(s) {
      return String(s || '').trim().toLowerCase();
    }

    // Build value map from known API fields.
    var vals = {
      shape: item.shape,
      carat: (item.carat != null ? item.carat : (item.weight != null ? item.weight : '')),
      color: item.color,
      clarity: item.clarity,
      cut: item.cut,
      polish: item.polish,
      symmetry: item.symmetry,
      fluor: item.fluor || item.fluorescence,
      lab:  item.lab ,
      depth: item.depth_percent != null ? (String(item.depth_percent) + '%') : (item.depth != null ? (String(item.depth) + '%') : ''),
      table: item.table_percent != null ? (String(item.table_percent) + '%') : (item.table != null ? (String(item.table) + '%') : ''),
      girdle: item.girdle,
      culet: item.culet,
      meas: item.meas || item.measurements,
      ratio: item.ratio,
      bgm: item.bgm,
      treatment: item.treatment,
      report: `<a style="text-decoration:underline;" href="${item.cert_url}" target="_blank">` +item.certificate_id || item.report_no || item.report+ `</a>`,
    };

    // Pretty carat formatting
    if (vals.carat !== '' && vals.carat != null) {
      var c = Number(vals.carat);
      vals.carat = isFinite(c) ? c.toFixed(2) : String(vals.carat);
    }

    var rows = container.querySelectorAll('.rb-list');
    if (!rows || !rows.length) return;

    rows.forEach(function (row) {
      var head = row.querySelector('.head');
      var text = row.querySelector('.text');
      if (!head || !text) return;
      var k = norm(head.textContent);

      // map headings to keys
      var key = null;
      if (k === 'shape') key = 'shape';
      else if (k === 'carat') key = 'carat';
      else if (k === 'color') key = 'color';
      else if (k === 'clarity') key = 'clarity';
      else if (k === 'cut') key = 'cut';
      else if (k === 'polish') key = 'polish';
      else if (k === 'symmetry') key = 'symmetry';
      else if (k === 'fluor' || k === 'fluorescence') key = 'fluor';
      else if (k === 'lab') key = 'lab';
      else if (k === 'depth') key = 'depth';
      else if (k === 'table') key = 'table';
      else if (k === 'girdle') key = 'girdle';
      else if (k === 'culet') key = 'culet';
      else if (k === 'meas' || k === 'measurements') key = 'meas';
      else if (k === 'ratio') key = 'ratio';
      else if (k === 'bgm') key = 'bgm';
      else if (k === 'treatment') key = 'treatment';
      else if (k.indexOf('report') === 0) key = 'report';

      if (!key) return;
      var v = vals[key];
      if (v == null || v === '') return;
      text.innerHTML = String(v);
    });
  }

  // Click any stone card -> open modal with details + gallery
  // IMPORTANT: scope this to step 2 diamond results only.
  // Some ring product cards / theme blocks can contain similarly-named attributes,
  // which was causing the stone modal to open on ring clicks.
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-rb-diamond-card]');
    if (!card) return;

    // Only when the card is inside the diamond results wrapper.
    // (Cards are rendered inside [data-rb-diamond-results] and may NOT be inside .rb-grid[data-step="2"].)
    var els = getResultsEls();
    if (!els || !els.wrap || !els.wrap.contains(card)) return;

    // avoid interfering with next/prev buttons etc.
    if (e.target.closest('[data-rb-diamond-prev], [data-rb-diamond-next], [data-rb-diamond-select]')) return;

    e.preventDefault();

    var id = card.getAttribute('data-diamond-id') || '';
    var item = id && lastItemsById[id] ? lastItemsById[id] : null;
    $('.model-step-header').html($('.rb-steps').prop("outerHTML"));
    if (item) openStoneModalWithItem(item);
  }, false);



  function fetchDiamonds(page, ctxEl) {
    try { rbShowPageLoader(); } catch(e) {}
    var els = getResultsEls();
    if (!els.wrap || !els.grid) { try { rbHidePageLoader(); } catch(e) {} return; }

    currentPage = page || 1;
    lastReq = buildRequest(currentPage, ctxEl);

    showResults();
    renderStatus('Loading…');

    return fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lastReq),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Expected response:
        // { success:true, message:'...', data:{ inventory:[...], count:123 } }
        var payload = (data && data.data) ? data.data : {};
        var items = Array.isArray(payload.inventory) ? payload.inventory : [];

        renderList(items);
        renderCount(typeof payload.count === 'number' ? payload.count : (Array.isArray(items) ? items.length : 0));

        // Basic pager + numbered buttons
        var total = (payload && typeof payload.count === 'number') ? payload.count : 0;
        var limit = lastReq.limit || 50;
        var pages = total ? Math.ceil(total / limit) : 1;

        if (els.page) els.page.textContent = 'Page ' + currentPage + (pages > 1 ? (' / ' + pages) : '');
        if (els.pager) els.pager.hidden = !(pages > 1);

        if (els.prev) els.prev.disabled = currentPage <= 1;
        if (els.next) els.next.disabled = currentPage >= pages;

        renderPagerButtons(pages);

        renderStatus('');
         
         try { document.dispatchEvent(new CustomEvent('rb:ajaxmobile:updated')); } catch (e) {}
          
      })
      .catch(function (err) {
        console.error(err);
        renderList([]);
        renderCount(0);
        renderStatus('Failed to load stones. Please try again.');
      }).finally(function(){ try { rbHidePageLoader(); } catch(e) {} });
  }

  try { window.fetchDiamonds = fetchDiamonds; } catch (e) {}

  function renderPagerButtons(totalPages) {
    var els = getResultsEls();
    if (!els.pager) return;
    var pages = Math.max(1, parseInt(totalPages || 1, 10));

    var holder = els.pager.querySelector('[data-rb-diamond-pages]');
    if (!holder) {
      holder = document.createElement('div');
      holder.setAttribute('data-rb-diamond-pages', '1');
      holder.style.display = 'flex';
      holder.style.gap = '8px';
      holder.style.alignItems = 'center';
      holder.style.justifyContent = 'center';
      // insert between prev and page label
      var pageLabel = els.pager.querySelector('[data-rb-diamond-page]');
      if (pageLabel && pageLabel.parentNode) pageLabel.parentNode.insertBefore(holder, pageLabel);
      else els.pager.appendChild(holder);
    }

    // compute window
    var windowSize = 5;
    var start = Math.max(1, currentPage - Math.floor(windowSize / 2));
    var end = Math.min(pages, start + windowSize - 1);
    start = Math.max(1, end - windowSize + 1);

    var btns = [];
    function pageBtn(p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rb-btn rb-btn--ghost';
      b.textContent = String(p);
      b.setAttribute('data-rb-page', String(p));
      if (p === currentPage) {
        b.disabled = true;
        b.style.opacity = '0.6';
      }
      return b;
    }

    holder.innerHTML = '';
    if (start > 1) {
      holder.appendChild(pageBtn(1));
      if (start > 2) {
        var dots = document.createElement('span');
        dots.textContent = '…';
        holder.appendChild(dots);
      }
    }
    for (var p = start; p <= end; p++) holder.appendChild(pageBtn(p));
    if (end < pages) {
      if (end < pages - 1) {
        var dots2 = document.createElement('span');
        dots2.textContent = '…';
        holder.appendChild(dots2);
      }
      holder.appendChild(pageBtn(pages));
    }
  }

  function bindFilterInteractions() {
    // Deprecated: older binding approach (kept for backward compatibility)
    // Step-2 filters are now bound globally with capture to reliably prevent
    // Shopify facet navigation (anchors with href) and Swiper click swallowing.
    return;
  }

  function bindPager() {
    var els = getResultsEls();
    if (!els.wrap) return;
    els.wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-rb-diamond-prev]')) {
        e.preventDefault();
        if (currentPage > 1) fetchDiamonds(currentPage - 1);
      }
      if (e.target.closest('[data-rb-diamond-next]')) {
        e.preventDefault();
        fetchDiamonds(currentPage + 1);
      }

      var pbtn = e.target.closest && e.target.closest('[data-rb-page]');
      if (pbtn) {
        e.preventDefault();
        var page = parseInt(pbtn.getAttribute('data-rb-page') || '1', 10);
        if (page && page !== currentPage) fetchDiamonds(page);
      }
    });
  }


  function bindDiamondSelect() {
    var els = getResultsEls();
    if (!els.wrap) return;

    els.wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rb-diamond-select]');
      if (!btn) return;

      e.preventDefault();

      var card = btn.closest('[data-rb-diamond-card]');
      var id = card ? card.getAttribute('data-diamond-id') : '';
      var item = id && lastItemsById[id] ? lastItemsById[id] : null;

      // Persist selection (setting already persisted in step 1)
      var payload = {
        id: id || '',
        certificate_id: item && item.certificate_id ? item.certificate_id : '',
        shape: item && item.shape ? item.shape : '',
        carat: item && (item.carat != null ? item.carat : item.weight) != null ? (item.carat != null ? item.carat : item.weight) : '',
        color: item && item.color ? item.color : '',
        clarity: item && item.clarity ? item.clarity : '',
        cut: item && item.cut ? item.cut : '',
        lab: item && item.lab ? item.lab : '',
        price: item && item.price != null ? item.price : '',
        image_url: item && item.image_url ? item.image_url : '',
        video_url: item && item.video_url ? item.video_url : '',
        cert_url: item && item.cert_url ? item.cert_url : '',
        ts: Date.now(),
      };

      try { localStorage.setItem('rb_diamond', JSON.stringify(payload)); } catch (err) {}

      // update step header (stone)
      try { if (window.updateHeadersFromStorage) window.updateHeadersFromStorage(); } catch (err) {}

      // Mark selected card UI
      qsa('[data-rb-diamond-card]', els.wrap).forEach(function (c) { c.classList.remove('is-selected'); });
      if (card) card.classList.add('is-selected');

      document.dispatchEvent(new CustomEvent('rb:diamond:selected', { detail: payload }));

      // Move to review step (optional), but keep current behavior unchanged.
    });
  }

  // expose header updater
  try { window.updateHeadersFromStorage = window.updateHeadersFromStorage || updateHeadersFromStorage; } catch (e) {}

  var __rbInitialStoneFetchTimer = null;

  // Hook: when a setting is selected in step 1 modal
  document.addEventListener('rb:setting:selected', function (e) {
    try { if (window.activateStep) window.activateStep(2); } catch (err) {}
    try { syncStep2ShapeFromRing(); } catch (err) {}

    if (window.__rbApplyingParamsOnly) return;

    clearTimeout(__rbInitialStoneFetchTimer);
    __rbInitialStoneFetchTimer = setTimeout(function () {
      try { if (window.rbUpdateMobileStoneSummaries) window.rbUpdateMobileStoneSummaries(); } catch (err) {}
      fetchDiamonds(1, getStep2DesktopGrid() || getStep2Grid());
    }, 220);
  });

  // If user reloads while already in step 2, auto-fetch
  document.addEventListener('DOMContentLoaded', function () {
    bindFilterInteractions();
    bindPager();
    bindDiamondSelect();

    try {
      var savedHandle = localStorage.getItem('rb_setting_handle');
      if (savedHandle && !window.__rbUrlDefaultsPresent) {
        var step2 = qs('.rb-step-grid[data-step="2"].is-active');
        if (step2) {
          try { syncStep2ShapeFromRing(); } catch (e) {}
          fetchDiamonds(1, getStep2DesktopGrid() || getStep2Grid());
        }
      }
    } catch (e) {}
  });

  // ----------------------------
  // Step-2 filter -> API refresh
  // ----------------------------
  (function bindDiamondFilters() {
    function inStep2(el) {
      if (!el || !el.closest) return false;
      return !!el.closest('.rb-grid[data-step="2"], .rb-step-grid[data-step="2"], .rb-modal[data-step="2"], .rb-modal__body[body-step="2"]');
    }

    // Ensure we only bind once (theme editors / PJAX / section reloads)
    if (document.__rbStep2FiltersBound) return;
    document.__rbStep2FiltersBound = true;

    // Prevent Shopify facet links from navigating (step 2 only)
    // Use capture so we can stop navigation even if Swiper/other scripts stop bubbling.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a.rb-tile') : null;
      if (!a) return;
      if (!inStep2(a)) return;
      // Stop URL navigation / full page reload
      e.preventDefault();
      e.stopPropagation();
    }, true);

    function resetStep2Filters(grid)
    {
      if (window.__rbUrlDefaultsPresent || window.__rbApplyingParamsOnly) return;
      console.log('tessst')
      grid = grid || getStep2Grid();
      if (!grid) return;

      // diamond type default: lab
      var labSw = grid.querySelector('.diamond-swatch[data-type="lab"]') || grid.querySelector('.diamond-swatch');
      if (labSw) {
        qsa('.diamond-swatch', grid).forEach(function (x) { x.classList.remove('is-active'); });
        labSw.classList.add('is-active');
      }

      // advanced filters hidden
      var advBtn = grid.querySelector('.advanced_filters_button');
      if (advBtn) advBtn.classList.remove('is-active');
      qsa('.rb-card[data-extra]', grid).forEach(function (c) { c.style.display = 'none'; });

      // show main cards for selected swatch
      var swType = labSw ? labSw.getAttribute('data-type') : 'lab';
      qsa('.rb-card', grid).forEach(function (c) {
        if (c.hasAttribute('data-extra')) return;
        var content = c.getAttribute('data-content');
        if (!content || content === swType) c.style.display = 'flex';
        else c.style.display = 'none';
      });

      // reset ranges to full span
      qsa('.rb-card input[type="range"][data-rb-from]', grid).forEach(function (from) {
        var card = from.closest('.rb-card');
        var to = card ? card.querySelector('input[type="range"][data-rb-to]') : null;
        if (!to) return;
        from.value = from.min;
        to.value = to.max;
        // trigger UI update
        from.dispatchEvent(new Event('input', { bubbles: true }));
        to.dispatchEvent(new Event('input', { bubbles: true }));
      });

      // reset tiles: set all shapes + labs active
      qsa('[data-rb-swiper="shape"], [data-rb-swiper="lab"]', grid).forEach(function (sw) {
        qsa('.rb-tile', sw).forEach(function (t) { t.classList.add('is-active'); });
      });

      // reset color type to White
      var colorCard = qsa('.rb-card', grid).find(function (c) {
        var t = c.querySelector('.rb-title');
        return t && t.textContent.trim().toLowerCase() === 'color';
      });
      if (colorCard) {
        qsa('.rb-swatch[data-rb-color]', colorCard).forEach(function (x) { x.classList.remove('active'); });
        var white = colorCard.querySelector('.rb-swatch[data-rb-color="white"]') || colorCard.querySelector('.rb-swatch[data-rb-color]');
        if (white) white.classList.add('active');
        qsa('[data-color-type]', colorCard).forEach(function (wrap) {
          wrap.style.display = (wrap.getAttribute('data-color-type') === 'white') ? '' : 'none';
        });
      }

      // remove query params so refresh state is clean
     // try { window.history && window.history.replaceState && window.history.replaceState(null, '', window.location.pathname); } catch (e) {}

      // refresh list
      try { fetchDiamonds(1, grid); } catch (e) {}
    }
    // Reset filters link in step2 (works for BOTH desktop grid + mobile grid + header reset)
    // NOTE: the reset link can live outside `.rb-grid` (e.g., in header / mobile drawer),
    // so we only require it to be *within Step 2 context*.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.rb-reset a, a.rb-reset, button.rb-reset, [data-rb-reset]') : null;
      if (!a) return;
      if (!inStep2(a)) return;
      e.preventDefault();
      e.stopPropagation();
      // Prefer the grid that contains the clicked reset control (important when both desktop+mobile DOM exist)
      try { resetStep2Filters(getStep2Grid(a)); } catch (err) { resetStep2Filters(); }
    }, true);

    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.reset-stone-mobile') : null;
      if (!a) return;

      e.preventDefault();
      e.stopPropagation();

      try {
        resetStep2Filters(getStep2DesktopGrid() || getStep2Grid(a));
      } catch (err) {
        resetStep2Filters();
      }

      try {
        if (window.rbUpdateMobileStoneSummaries) window.rbUpdateMobileStoneSummaries();
      } catch (e2) {}
    }, true);

    // Advanced filters toggle (Vanilla JS fallback; do NOT rely on jQuery)
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.advanced_filters_button') : null;
      if (!btn) return;
      if (!inStep2(btn)) return;

      e.preventDefault();
      e.stopPropagation();

      var grid = getStep2Grid(btn);
      if (!grid) return;

      // Determine which swatch type is active (lab/natural)
      var activeSwatch = grid.querySelector('.diamond-swatch.is-active');
      var dtype = activeSwatch ? (activeSwatch.getAttribute('data-type') || '') : '';
      if (!dtype) return;

      var extras = qsa('.rb-card[data-extra]', grid);
      if (!extras.length) return;

      var anyVisible = extras.some(function (x) { return x.style.display !== 'none' && (x.offsetParent !== null); });

      if (anyVisible) {
        extras.forEach(function (x) { x.style.display = 'none'; });
        btn.classList.remove('is-active');
      } else {
        extras.forEach(function (x) { x.style.display = 'flex'; });
        btn.classList.add('is-active');
      }
    }, true);
// Color type swatches (White/Fancy) inside the "Color" card
    document.addEventListener('click', function (e) {
      var sw = e.target && e.target.closest ? e.target.closest('.rb-card .rb-swatch[data-rb-color]') : null;
      if (!sw) return;
      if (!inStep2(sw)) return;

      e.preventDefault();
      var card = sw.closest('.rb-card');
      if (!card) return;

      // toggle active
      qsa('.rb-swatch[data-rb-color]', card).forEach(function (x) { x.classList.remove('active'); });
      sw.classList.add('active');

      // show/hide wrappers by data-color-type
      var type = sw.getAttribute('data-rb-color');
      qsa('[data-color-type]', card).forEach(function (wrap) {
        wrap.style.display = (wrap.getAttribute('data-color-type') === type) ? '' : 'none';
      });

      debounceFetch(1, sw);
    }, true);

    // Diamond type swatches (lab/natural)
    document.addEventListener('click', function (e) {
      var sw = e.target && e.target.closest ? e.target.closest('.diamond-swatch') : null;
      if (!sw) return;
      if (!inStep2(sw)) return;

      e.preventDefault();
      var grid = getStep2Grid();
      if (!grid) return;
      qsa('.diamond-swatch', grid).forEach(function (x) { x.classList.remove('is-active'); });
      sw.classList.add('is-active');
      debounceFetch(1, sw);
    }, true);

    // Toggle shape + lab tiles (multi-select) and refetch
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.rb-card [data-rb-swiper="shape"] .rb-tile, .rb-card [data-rb-swiper="lab"] .rb-tile');
      if (!btn) return;
      if (!inStep2(btn)) return;

      // Prevent any navigation (anchors)
      e.preventDefault();
      e.stopPropagation();

      // Toggle active state (multi-select)
      btn.classList.toggle('is-active');

      // If shape: ensure at least one shape stays selected by defaulting to current toggle set; if none, re-activate clicked
      var swiper = btn.closest('[data-rb-swiper]');
      var kind = swiper ? swiper.getAttribute('data-rb-swiper') : '';
      if (kind === 'shape') {
        var any = qsa('.rb-tile.is-active', swiper).length > 0;
       // if (!any) btn.classList.add('is-active');
      }

      debounceFetch(1, btn);
    }, true);

    // Any range input changes inside step2 -> refetch (debounced)
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t) return;
      if (!inStep2(t)) return;
      if (t.matches && (t.matches('input[type="range"][data-rb-from], input[type="range"][data-rb-to]') || t.matches('input[data-rb-min-display], input[data-rb-max-display]'))) {
        debounceFetch(1, t);
      }
    }, true);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (!inStep2(t)) return;
      if (t.matches && (t.matches('input[type="range"], select, input[type="text"], input[type="number"]'))) {
        debounceFetch(1, t);
      }
    }, true);

    // Debounced fetch helper
    var _t = null;
    var _ctx = null;
    function debounceFetch(page, ctxEl) {
      _ctx = ctxEl || _ctx;
      clearTimeout(_t);
      _t = setTimeout(function () { try { fetchDiamonds(page || 1, _ctx); } catch (err) {} }, 250);
    }

    // When step2 becomes visible, fetch once
    document.addEventListener('rb:step:2', function () {
      try { syncStep2ShapeFromRing(); } catch (e) {}

      if (window.__rbUrlDefaultsPresent) return;
      if (window.__rbSkipNextStep2AutoFetch) {
        window.__rbSkipNextStep2AutoFetch = false;
        return;
      }

      debounceFetch(1, getStep2Grid());
    });
  })();

})();



 
document.addEventListener("click", function(e) {

  const thumbnail = e.target.closest(
    ".rb-modal__media-container .thumbnail-media--image"
  );

  if (!thumbnail) return;

  console.log('tesssssstttttt')
  const container = thumbnail.closest(".rb-modal__media-container");

  const thumbImg = document.querySelector(
    ".complete-step .thumbnail-media--image img"
  );

  const mainImg = document.querySelector(
    ".complete-step .media--image img"
  );
     
  if (!thumbImg || !mainImg) return;

  // Swap sources
  const tempSrc = mainImg.src;
  mainImg.src = thumbImg.src;
  thumbImg.src = tempSrc;

}); 

// Mobile Grid step popup

document.addEventListener('DOMContentLoaded', function () {
  const stepGrids = document.querySelectorAll('.rb-step-grid');

  if (!stepGrids.length) return;

  document.addEventListener('click', function (e) {
    if (window.innerWidth > 768) return;

    const clickedStep = e.target.closest('.rb-step');
    const clickedPopup = e.target.closest('.steps-popup-container');

    if (clickedStep) {
      const parentGrid = clickedStep.closest('.rb-step-grid');
      if (!parentGrid) return;

      const popup = parentGrid.querySelector('.steps-popup-container');

      document.querySelectorAll('.steps-popup-container').forEach(function (item) {
        if (item !== popup) {
          item.style.display = 'none';
        }
      });

      if (popup) {
        popup.style.display = 'block';
      }

      return;
    }

    if (!clickedPopup) {
      document.querySelectorAll('.steps-popup-container').forEach(function (item) {
        item.style.display = 'none';
      });
    }
  });
});

// End Mobile Grid step popup


/* ===== RB mobile stone filters definitive patch ===== */
(function(){
  function qsa(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }
  function qs(sel, ctx){ return (ctx||document).querySelector(sel); }
  function txt(el){ return el ? String(el.textContent || '').trim() : ''; }
  function isVisible(el){ return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function getStep2DesktopGridPatched(){
    var grids = qsa('.rb-grid[data-step="2"]');
    for (var i=0;i<grids.length;i++) if (!grids[i].classList.contains('mobile-grid')) return grids[i];
    return grids[0] || null;
  }
  function findStep2Card(title){
    title = String(title || '').trim().toLowerCase();
    var grid = getStep2DesktopGridPatched();
    if (!grid) return null;

    var cards = qsa('.rb-card', grid);
    for (var i = 0; i < cards.length; i++) {
      var t = qs('.rb-title', cards[i]);
      if (!t) continue;

      var current = txt(t).toLowerCase();

      if (title === 'shape') {
        if (current === 'shape' || current === 'supported shape') return cards[i];
      } else if (current === title) {
        return cards[i];
      }
    }

    return null;
  }
  function modalToTitle(modalId){
    var m={
      rb_shape_stone_modal:'shape', rb_carat_stone_modal:'carat', rb_color_stone_modal:'color',
      rb_clarity_stone_modal:'clarity', rb_cut_stone_modal:'cut', rb_price_stone_modal:'price',
      rb_polish_stone_modal:'polish', rb_symmetry_stone_modal:'symmetry', rb_fluorescence_stone_modal:'fluorescence', rb_lab_stone_modal:'lab'
    };
    return m[modalId] || '';
  }
  function modalToSummaryKey(modalId){
    var m={
      rb_shape_stone_modal:'stone_shape', rb_carat_stone_modal:'stone_carat', rb_color_stone_modal:'stone_color',
      rb_clarity_stone_modal:'stone_clarity', rb_cut_stone_modal:'stone_cut', rb_price_stone_modal:'stone_price',
      rb_polish_stone_modal:'stone_polish', rb_symmetry_stone_modal:'stone_symmetry', rb_fluorescence_stone_modal:'stone_fluorescence', rb_lab_stone_modal:'stone_lab'
    };
    return m[modalId] || '';
  }
  function setSummary(key, value){ qsa('[data-filter-val="'+key+'"]').forEach(function(el){ el.textContent = value; }); }
  function rangeSummary(card, isMoney){
    if (!card) return 'Any';
    var minD = qs('[data-rb-min-display]', card);
    var maxD = qs('[data-rb-max-display]', card);
    var from = qs('[data-rb-from]', card);
    var to = qs('[data-rb-to]', card);
    var labels = qsa('.rb-range-label-wrapper .rb-range-label', card).map(function(el){ return (el.getAttribute('value') || txt(el)); }).filter(Boolean);
    if (labels.length && from && to) {
      var a = Math.max(0, Math.min(labels.length-1, parseInt(from.value||'0',10)));
      var b = Math.max(0, Math.min(labels.length-1, parseInt(to.value||'0',10)));
      var lo = Math.min(a,b), hi=Math.max(a,b);
      if (lo===0 && hi===labels.length-1) return 'Any';
      return labels[lo] + ' - ' + labels[hi];
    }
    if (minD && maxD) {
      var a2 = String(minD.value||'').trim();
      var b2 = String(maxD.value||'').trim();
      if (a2==='' || b2==='') return 'Any';
      return (isMoney ? ('$' + a2 + ' - $' + b2) : (a2 + ' - ' + b2));
    }
    return 'Any';
  }
  function activeTileLabel(card){
    if (!card) return 'Any';
    var labels = qsa('.rb-tile.is-active .rb-label', card).map(txt).filter(Boolean);
    if (!labels.length) return 'Any';
    if (labels.length === qsa('.rb-tile .rb-label', card).length) return 'Any';
    return labels.join(', ');
  }
  function activeColorSummary(card){
    if (!card) return 'Any';
    var fancyTab = qs('.rb-swatch.active[data-rb-color="fancy"]', card);
    if (fancyTab) {
      var fancy = qs('[data-rb-fancy-color].is-active, [data-rb-fancy-color].active', card);
      return fancy ? (fancy.getAttribute('data-rb-fancy-color') || txt(fancy) || 'Fancy') : 'Fancy';
    }
    return rangeSummary(card, false);
  }
  function updateMobileSummariesFromDesktop(){
    setSummary('stone_shape', activeTileLabel(findStep2Card('shape')));
    (function () {
      var caratCard = findStep2Card('carat');
      var caratText = rangeSummary(caratCard, false);

      try {
        var from = caratCard ? qs('[data-rb-from]', caratCard) : null;
        var to = caratCard ? qs('[data-rb-to]', caratCard) : null;
        var minD = caratCard ? qs('[data-rb-min-display]', caratCard) : null;
        var maxD = caratCard ? qs('[data-rb-max-display]', caratCard) : null;

        var rawFrom = from ? String(from.value || '').trim() : '';
        var rawTo = to ? String(to.value || '').trim() : '';
        var dispFrom = minD ? String(minD.value || '').trim() : '';
        var dispTo = maxD ? String(maxD.value || '').trim() : '';

        var nRawFrom = parseFloat(rawFrom);
        var nRawTo = parseFloat(rawTo);
        var nDispFrom = parseFloat(dispFrom);
        var nDispTo = parseFloat(dispTo);

        if (
          isFinite(nRawFrom) && isFinite(nRawTo) &&
          isFinite(nDispFrom) && isFinite(nDispTo) &&
          nRawTo > 0 &&
          nDispTo > 0 &&
          nDispTo < 1 &&
          nRawTo >= 1
        ) {
          caratText = rawFrom + ' - ' + rawTo;
        }
      } catch (e) {}

      setSummary('stone_carat', caratText);
    })();
    setSummary('stone_color', activeColorSummary(findStep2Card('color')));
    setSummary('stone_clarity', rangeSummary(findStep2Card('clarity'), false));
    setSummary('stone_cut', rangeSummary(findStep2Card('cut'), false));
    setSummary('stone_price', rangeSummary(findStep2Card('price'), true));
    setSummary('stone_polish', rangeSummary(findStep2Card('polish'), false));
    setSummary('stone_symmetry', rangeSummary(findStep2Card('symmetry'), false));
    setSummary('stone_fluorescence', rangeSummary(findStep2Card('fluorescence'), false));
    setSummary('stone_lab', activeTileLabel(findStep2Card('lab')));
  }
  function syncPopupFromDesktop(modal){
    if (!modal) return;

    var title = modalToTitle(modal.id || '');
    var card = findStep2Card(title);
    if (!card) return;

    // shape / lab tiles
    if (title === 'shape' || title === 'lab') {
      var active = qsa('.rb-tile.is-active .rb-label', card).map(function(el){
        return txt(el).toLowerCase();
      });

      qsa('.rb-tile', modal).forEach(function(tile){
        var lbl = txt(qs('.rb-label', tile)).toLowerCase();
        var same = active.indexOf(lbl) > -1;
        tile.classList.toggle('is-active', same);
        tile.classList.toggle('active', same);
      });
      return;
    }

    // color popup
    if (title === 'color') {
      var activeTab = qs('.rb-swatch.active[data-rb-color]', card);
      var tab = activeTab ? String(activeTab.getAttribute('data-rb-color') || 'white') : 'white';

      qsa('[data-rb-color-tab]', modal).forEach(function(el){
        el.classList.toggle('active', String(el.getAttribute('data-rb-color-tab') || '') === tab);
      });

      qsa('[data-color-type]', modal).forEach(function(el){
        el.style.display = String(el.getAttribute('data-color-type') || '') === tab ? '' : 'none';
      });

      if (tab === 'fancy') {
        var fancy = qs('[data-rb-fancy-color].is-active, [data-rb-fancy-color].active', card);
        var fv = fancy ? String(fancy.getAttribute('data-rb-fancy-color') || '').toLowerCase() : '';

        qsa('[data-rb-fancy-color]', modal).forEach(function(el){
          var same = String(el.getAttribute('data-rb-fancy-color') || '').toLowerCase() === fv;
          el.classList.toggle('is-active', same);
          el.classList.toggle('active', same);
        });
      } else {
        qsa('[data-rb-fancy-color]', modal).forEach(function(el){
          el.classList.remove('is-active');
          el.classList.remove('active');
        });
      }

      // force white-range values from desktop to popup
      var srcFrom = qs('[data-rb-from]', card);
      var srcTo = qs('[data-rb-to]', card);
      var srcMin = qs('[data-rb-min-display]', card);
      var srcMax = qs('[data-rb-max-display]', card);

      var dstFrom = qs('[data-rb-from]', modal);
      var dstTo = qs('[data-rb-to]', modal);
      var dstMin = qs('[data-rb-min-display]', modal);
      var dstMax = qs('[data-rb-max-display]', modal);

      window.__rbSyncingStonePopup = true;
      window.__rbSuppressPopupAjax = true;

      if (srcFrom && dstFrom) dstFrom.value = srcFrom.value;
      if (srcTo && dstTo) dstTo.value = srcTo.value;
      if (srcMin && dstMin) dstMin.value = srcMin.value;
      if (srcMax && dstMax) dstMax.value = srcMax.value;

      try {
        if (dstFrom) dstFrom.dispatchEvent(new Event('input', { bubbles: true }));
        if (dstTo) dstTo.dispatchEvent(new Event('input', { bubbles: true }));
        if (dstMin) dstMin.dispatchEvent(new Event('change', { bubbles: true }));
        if (dstMax) dstMax.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}

      setTimeout(function(){
        window.__rbSyncingStonePopup = false;
        window.__rbSuppressPopupAjax = false;
      }, 0);

      return;
    }

    // all other range popups
    var srcWrap = qs('[data-rb-price], [data-rb-color]', card);
    var dstWrap = qs('[data-rb-price], [data-rb-color], [data-rb-stone-popup-carat], [data-rb-stone-popup-price]', modal);
    if (srcWrap && dstWrap) {
      window.__rbSyncingStonePopup = true;
      window.__rbSuppressPopupAjax = true;

      ['[data-rb-from]','[data-rb-to]','[data-rb-min-display]','[data-rb-max-display]'].forEach(function(sel){
        var s = qs(sel, srcWrap), d = qs(sel, dstWrap);
        if (s && d) d.value = s.value;
      });

      ['[data-rb-from]','[data-rb-to]'].forEach(function(sel){
        var d = qs(sel, dstWrap);
        if (d) d.dispatchEvent(new Event('input', { bubbles: true }));
      });

      setTimeout(function(){
        window.__rbSyncingStonePopup = false;
        window.__rbSuppressPopupAjax = false;
      }, 0);
    }
  }

  function syncPopupToDesktop(modal){
    if (!modal) return;

    var title = modalToTitle(modal.id || '');
    var card = findStep2Card(title);
    if (!card) return;

    // shape / lab tiles
    if (title === 'shape' || title === 'lab') {
      var active = qsa('.rb-tile.is-active .rb-label', modal).map(function(el){
        return txt(el).toLowerCase();
      });

      qsa('.rb-tile', card).forEach(function(tile){
        var lbl = txt(qs('.rb-label', tile)).toLowerCase();
        var same = active.indexOf(lbl) > -1;
        tile.classList.toggle('is-active', same);
        tile.classList.toggle('active', same);
      });
      return;
    }

    // color special handling
    if (title === 'color') {
      var activeTab = qs('[data-rb-color-tab].active', modal);
      var tab = activeTab ? String(activeTab.getAttribute('data-rb-color-tab') || 'white') : 'white';

      // sync desktop tabs
      qsa('.rb-swatch[data-rb-color]', card).forEach(function(el){
        el.classList.toggle('active', String(el.getAttribute('data-rb-color') || '') === tab);
      });

      // sync desktop wrappers
      qsa('[data-color-type]', card).forEach(function(el){
        el.style.display = String(el.getAttribute('data-color-type') || '') === tab ? '' : 'none';
      });

      if (tab === 'fancy') {
        // clear desktop white mode visuals not required, but set fancy tile correctly
        var fancy = qs('[data-rb-fancy-color].is-active, [data-rb-fancy-color].active', modal);
        var fv = fancy ? String(fancy.getAttribute('data-rb-fancy-color') || '').toLowerCase() : '';

        qsa('[data-rb-fancy-color]', card).forEach(function(el){
          var same = String(el.getAttribute('data-rb-fancy-color') || '').toLowerCase() === fv;
          el.classList.toggle('is-active', same);
          el.classList.toggle('active', same);
        });
      } else {
        // white mode: clear desktop fancy selection
        qsa('[data-rb-fancy-color]', card).forEach(function(el){
          el.classList.remove('is-active');
          el.classList.remove('active');
        });
      }

      // copy white slider values from mobile popup to desktop card
      var srcFrom = qs('[data-rb-from]', modal);
      var srcTo = qs('[data-rb-to]', modal);
      var dstFrom = qs('[data-rb-from]', card);
      var dstTo = qs('[data-rb-to]', card);

      if (srcFrom && dstFrom) dstFrom.value = srcFrom.value;
      if (srcTo && dstTo) dstTo.value = srcTo.value;

      try {
        if (dstFrom) dstFrom.dispatchEvent(new Event('input', { bubbles: true }));
        if (dstTo) dstTo.dispatchEvent(new Event('input', { bubbles: true }));
        if (dstFrom) dstFrom.dispatchEvent(new Event('change', { bubbles: true }));
        if (dstTo) dstTo.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}

      return;
    }

    // other range popups
    var srcWrap = qs('[data-rb-price], [data-rb-color], [data-rb-stone-popup-carat], [data-rb-stone-popup-price]', modal);
    var dstWrap = qs('[data-rb-price], [data-rb-color]', card);

    if (srcWrap && dstWrap) {
      ['[data-rb-from]','[data-rb-to]','[data-rb-min-display]','[data-rb-max-display]'].forEach(function(sel){
        var s = qs(sel, srcWrap), d = qs(sel, dstWrap);
        if (s && d) d.value = s.value;
      });

      ['[data-rb-from]','[data-rb-to]','[data-rb-min-display]','[data-rb-max-display]'].forEach(function(sel){
        var d = qs(sel, dstWrap);
        if (d) {
          d.dispatchEvent(new Event('input', { bubbles:true }));
          d.dispatchEvent(new Event('change', { bubbles:true }));
        }
      });
    }
  }

  function closePopups(){ qsa('.rb-modal-popup.is-open, .rb-modal-popup-mob.is-open').forEach(function(m){ m.classList.remove('is-open'); m.hidden = true; }); var o=qs('[data-rb-overlay]'); if (o){o.classList.remove('is-open'); o.hidden=true; o.style.display='none';} document.body.style.overflow=''; document.documentElement.style.overflow=''; }
  function openPopup(modal){ if (!modal) return; var o=qs('[data-rb-overlay]'); modal.hidden=false; modal.classList.add('is-open'); if(o){o.hidden=false; o.style.display='block'; o.classList.add('is-open');} document.body.style.overflow='hidden'; document.documentElement.style.overflow='hidden'; }
  var fetchT;
  function refetchFromModal(modal){
    syncPopupToDesktop(modal); updateMobileSummariesFromDesktop();
    clearTimeout(fetchT);
    fetchT = setTimeout(function(){ try { if (typeof fetchDiamonds === 'function') fetchDiamonds(1, getStep2DesktopGridPatched() || modal); } catch(e){} }, 180);
  }

  document.addEventListener('click', function(e){
    var card = e.target.closest && e.target.closest('.rb-grid.mobile-grid[data-step="2"] .rb-filter-card[data-rb-open]');
    if (!card) return;
    e.preventDefault(); e.stopPropagation();
    var modal = qs(card.getAttribute('data-rb-open'));
    if (!modal) return;
    syncPopupFromDesktop(modal);
    openPopup(modal);
  }, true);

  document.addEventListener('click', function(e){
    var tile = e.target.closest && e.target.closest('.rb-modal-popup[id$="_stone_modal"] .rb-tile');
    if (!tile) return;
    e.preventDefault(); e.stopPropagation();
    var modal = tile.closest('.rb-modal-popup');
    if (!modal) return;
    var id = modal.id || '';
    if (id === 'rb_shape_stone_modal' || id === 'rb_lab_stone_modal') {
      qsa('.rb-tile', modal).forEach(function(t){ t.classList.remove('is-active','active'); });
      tile.classList.add('is-active','active');
    } else if (id === 'rb_color_stone_modal' && tile.hasAttribute('data-rb-fancy-color')) {
      qsa('[data-rb-fancy-color]', modal).forEach(function(t){
        t.classList.remove('is-active', 'active');
      });
      tile.classList.add('is-active', 'active');
    } else {
      tile.classList.toggle('is-active');
      tile.classList.toggle('active');
    }
    refetchFromModal(modal);
  }, true);

  document.addEventListener('click', function(e){
    var tab = e.target.closest && e.target.closest('.rb-modal-popup[id$="_stone_modal"] [data-rb-color-tab]');
    if (!tab) return;
    e.preventDefault(); e.stopPropagation();
    var modal = tab.closest('.rb-modal-popup');
    qsa('[data-rb-color-tab]', modal).forEach(function(x){ x.classList.remove('active'); });
    tab.classList.add('active');
    var t = String(tab.getAttribute('data-rb-color-tab')||'');
    qsa('[data-color-type]', modal).forEach(function(el){ el.style.display = String(el.getAttribute('data-color-type')||'')===t ? '' : 'none'; });
    refetchFromModal(modal);
  }, true);

  document.addEventListener('input', function(e){
    var t = e.target; if (!t || !t.closest) return;
    var modal = t.closest('.rb-modal-popup[id$="_stone_modal"]');
    if (!modal) return;
    if (window.__rbSyncingStonePopup || window.__rbSuppressPopupAjax) return;
    if (!t.matches('[data-rb-from],[data-rb-to],[data-rb-min-display],[data-rb-max-display]')) return;
    refetchFromModal(modal);
  }, true);
  document.addEventListener('change', function(e){
    var t = e.target; if (!t || !t.closest) return;
    var modal = t.closest('.rb-modal-popup[id$="_stone_modal"]');
    if (!modal) return;
    if (window.__rbSyncingStonePopup || window.__rbSuppressPopupAjax) return;
    if (!t.matches('[data-rb-from],[data-rb-to],[data-rb-min-display],[data-rb-max-display]')) return;
    refetchFromModal(modal);
  }, true); 

   document.addEventListener('input', function(e){
          var t = e.target; if (!t || !t.closest) return;
          var modal = t.closest('.rb-modal-popup[id$="_stone_modal"]');
          if (!modal) return;
          if (window.__rbSyncingStonePopup || window.__rbSuppressPopupAjax) return;

          // live refetch only for sliders
          if (t.matches('[data-rb-from],[data-rb-to]')) {
            refetchFromModal(modal);
            return;
          }

          // typed text should first update slider; commit on change/blur
          if (t.matches('[data-rb-min-display],[data-rb-max-display]')) {
            return;
          }
        }, true);
  document.addEventListener('click', function(e){
    var close = e.target.closest && e.target.closest('.rb-modal-popup[id$="_stone_modal"] .rb-modal-close');
    if (!close) return;
    e.preventDefault(); e.stopPropagation();
    var modal = close.closest('.rb-modal-popup');
    syncPopupToDesktop(modal); updateMobileSummariesFromDesktop(); closePopups();
  }, true);

  document.addEventListener('rb:ajax:updated', function(){ setTimeout(updateMobileSummariesFromDesktop, 30); });
  document.addEventListener('rb:ajaxmobile:updated', function(){ setTimeout(updateMobileSummariesFromDesktop, 30); });
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(updateMobileSummariesFromDesktop, 80); });
  window.rbUpdateMobileStoneSummaries = updateMobileSummariesFromDesktop;
})();


/* ===== RB mobile ring summary + price sync targeted fix ===== */
(function(){
  function qs(sel, ctx){ return (ctx||document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }
  function txt(el){ return (el && (el.textContent || el.innerText) || '').replace(/\s+/g,' ').trim(); }
  function setSummary(key, value){ qsa('[data-filter-val="'+key+'"]').forEach(function(el){ el.textContent = value; }); }
  function getStep1DesktopGrid(){
    var grids = qsa('.rb-grid[data-step="1"]');
    for (var i=0;i<grids.length;i++) if (!grids[i].classList.contains('mobile-grid')) return grids[i];
    return qs('.desktop-view .rb-grid[data-step="1"]') || grids[0] || null;
  }
  function findStep1Card(title){
    title = String(title||'').trim().toLowerCase();
    var grid = getStep1DesktopGrid();
    if (!grid) return null;
    var cards = qsa('.rb-card', grid);
    for (var i=0;i<cards.length;i++) {
      var t = qs('.rb-title', cards[i]);
      if (t && txt(t).toLowerCase() === title) return cards[i];
    }
    return null;
  }
  function activeTileSummary(card, emptyText){
    if (!card) return emptyText || 'All';
    var labels = qsa('.rb-tile.is-active .rb-label, .rb-tile.active .rb-label', card).map(txt).filter(Boolean);
    if (!labels.length) return emptyText || 'All';
    var allCount = qsa('.rb-tile .rb-label', card).length;
    if (allCount && labels.length === allCount) return emptyText || 'All';
    return labels.join(', ');
  }
  function valueFromParams(name){
    try { return new URLSearchParams(window.location.search).get(name) || ''; } catch(e) { return ''; }
  }
  function priceSummaryFromCard(card){
    if (!card) return 'Any';
    var wrap = qs('[data-rb-price]', card) || card;
    var minD = qs('[data-rb-min-display]', wrap), maxD = qs('[data-rb-max-display]', wrap);
    var minR = qs('[data-rb-from]', wrap), maxR = qs('[data-rb-to]', wrap);
    var minHidden = qs('[data-rb-min]', wrap), maxHidden = qs('[data-rb-max]', wrap);
    var a = minD ? String(minD.value || '').trim() : '';
    var b = maxD ? String(maxD.value || '').trim() : '';
    if (!a && minHidden) a = String(Math.round((parseFloat(minHidden.value||'0')||0)/100));
    if (!b && maxHidden) b = String(Math.round((parseFloat(maxHidden.value||'0')||0)/100));
    var fromV = minHidden ? String(minHidden.value||'').trim() : (minR ? String(minR.value||'').trim() : '');
    var toV   = maxHidden ? String(maxHidden.value||'').trim() : (maxR ? String(maxR.value||'').trim() : '');
    var minV  = minR ? String(minR.min||'0').trim() : '0';
    var maxV  = maxR ? String(maxR.max||'').trim() : '';
    var params = new URLSearchParams(window.location.search);
    var qMin = params.get('filter.v.price.gte') || '';
    var qMax = params.get('filter.v.price.lte') || '';
    if (!qMin && !qMax && ((fromV === minV && toV === maxV) || (!fromV && !toV))) return 'Any';
    if (qMin || qMax) {
      var qa = qMin ? String(Math.round((parseFloat(qMin)||0))) : a || '0';
      var qb = qMax ? String(Math.round((parseFloat(qMax)||0))) : b || '';
      if (qb) return '$' + qa + ' - $' + qb;
    }
    if (a && b) return '$' + a + ' - $' + b;
    return 'Any';
  }
  function updateRingSummaries(){
    setSummary('ring', activeTileSummary(findStep1Card('Ring Style'), 'All'));
    setSummary('metal', activeTileSummary(findStep1Card('Metal Type'), 'All'));
    setSummary('ring_shape', activeTileSummary(findStep1Card('Supported Shape'), 'All'));
    setSummary('ring_price', priceSummaryFromCard(findStep1Card('Price')));
  }
  function syncRingPricePopupFromDesktop(modal){
    if (!modal) return;
    var card = findStep1Card('Price');
    if (!card) return;
    var src = qs('[data-rb-price]', card) || card;
    var dst = qs('[data-rb-ring-popup-price]', modal) || qs('[data-rb-price]', modal) || modal;
    if (!src || !dst) return;
    window.__rbSuppressPopupAjax = true;
    ['[data-rb-from]','[data-rb-to]','[data-rb-min]','[data-rb-max]','[data-rb-min-display]','[data-rb-max-display]'].forEach(function(sel){
      var s = qs(sel, src), d = qs(sel, dst);
      if (s && d) d.value = s.value;
    });
    var from = qs('[data-rb-from]', dst), to = qs('[data-rb-to]', dst);
    if (from) from.dispatchEvent(new Event('input', { bubbles:true }));
    if (to) to.dispatchEvent(new Event('input', { bubbles:true }));
    var minD = qs('[data-rb-min-display]', dst), maxD = qs('[data-rb-max-display]', dst);
    if (minD) minD.dispatchEvent(new Event('change', { bubbles:true }));
    if (maxD) maxD.dispatchEvent(new Event('change', { bubbles:true }));
    setTimeout(function(){ window.__rbSuppressPopupAjax = false; }, 0);
  }
  function syncRingPricePopupToDesktop(modal){
    if (!modal) return;
    var card = findStep1Card('Price');
    if (!card) return;
    var src = qs('[data-rb-ring-popup-price]', modal) || qs('[data-rb-price]', modal) || modal;
    var dst = qs('[data-rb-price]', card) || card;
    if (!src || !dst) return;
    ['[data-rb-from]','[data-rb-to]','[data-rb-min]','[data-rb-max]','[data-rb-min-display]','[data-rb-max-display]'].forEach(function(sel){
      var s = qs(sel, src), d = qs(sel, dst);
      if (s && d) d.value = s.value;
    });
    ['[data-rb-from]','[data-rb-to]','[data-rb-min-display]','[data-rb-max-display]'].forEach(function(sel){
      var d = qs(sel, dst);
      if (d) { d.dispatchEvent(new Event('input', { bubbles:true })); d.dispatchEvent(new Event('change', { bubbles:true })); }
    });
  }
  document.addEventListener('click', function(e){
    var card = e.target.closest && e.target.closest('.rb-grid.mobile-grid[data-step="1"] .rb-filter-card[data-filter="price"]');
    if (!card) return;
    var modal = qs('#rb_price_modal');
    if (!modal) return;
    setTimeout(function(){ syncRingPricePopupFromDesktop(modal); updateRingSummaries(); }, 0);
  }, true);
  document.addEventListener('click', function(e){
    var close = e.target.closest && e.target.closest('#rb_price_modal .rb-modal-close');
    if (!close) return;
    var modal = close.closest('#rb_price_modal');
    syncRingPricePopupToDesktop(modal);
    updateRingSummaries();
  }, true);
  document.addEventListener('input', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var modal = t.closest('#rb_price_modal');
    if (!modal) return;
    if (window.__rbSuppressPopupAjax) return;
    if (!t.matches('[data-rb-from],[data-rb-to],[data-rb-min-display],[data-rb-max-display]')) return;
    updateRingSummaries();
  }, true);
  document.addEventListener('change', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var modal = t.closest('#rb_price_modal');
    if (!modal) return;
    if (window.__rbSuppressPopupAjax) return;
    if (!t.matches('[data-rb-from],[data-rb-to],[data-rb-min-display],[data-rb-max-display]')) return;
    updateRingSummaries();
  }, true);
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(updateRingSummaries, 80); });
  document.addEventListener('rb:ajax:updated', function(){ setTimeout(updateRingSummaries, 30); });
  window.rbUpdateMobileRingSummaries = updateRingSummaries;
})();


/* ===== RB clear buttons + ring price live apply targeted fix ===== */
(function(){
  function qs(sel, ctx){ return (ctx||document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }
  function trigger(el, name){ try { el && el.dispatchEvent(new Event(name, { bubbles:true })); } catch(e){} }
  function visibleStep2DesktopGrid(){
    var grids = qsa('.rb-grid[data-step="2"]');
    for (var i=0;i<grids.length;i++) if (!grids[i].classList.contains('mobile-grid')) return grids[i];
    return grids[0] || null;
  }
  function closePopup(modal){
    if (!modal) return;
    try { modal.classList.remove('is-open'); modal.hidden = true; } catch(e){}
    var overlay = qs('[data-rb-overlay]');
    if (overlay) {
      try { overlay.classList.remove('is-open'); overlay.hidden = true; overlay.style.display = 'none'; } catch(e){}
    }
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
  function resetRange(root){
    if (!root) return;
    var from = qs('[data-rb-from]', root);
    var to = qs('[data-rb-to]', root);
    if (!from || !to) return;
    from.value = from.min || '0';
    to.value = to.max || to.value || '0';
    var minDisp = qs('[data-rb-min-display]', root);
    var maxDisp = qs('[data-rb-max-display]', root);
    var minHidden = qs('[data-rb-min]', root);
    var maxHidden = qs('[data-rb-max]', root);
    trigger(from, 'input');
    trigger(to, 'input');
    if (minDisp) trigger(minDisp, 'change');
    if (maxDisp) trigger(maxDisp, 'change');
    if (minHidden) trigger(minHidden, 'change');
    if (maxHidden) trigger(maxHidden, 'change');
  }
  function clearRingFacetModal(modal){
    if (!modal) return false;
    var active = qs('a.rb-tile.is-active[href]', modal) || qs('a.rb-tile.active[href]', modal);
    if (!active) {
      var summaryMap = { rb_ring_modal:'ring', rb_metal_modal:'metal', rb_shape_modal:'ring_shape' };
      var key = summaryMap[modal.id || ''];
      if (key) {
        try { document.querySelectorAll('[data-filter-val="'+key+'"]').forEach(function(el){ el.textContent = 'All'; }); } catch(e){}
      }
      closePopup(modal);
      return true;
    }
    var href = active.getAttribute('href') || '';
    if (!href) return true;
    try {
      if (typeof rbAjaxLoadUrl === 'function') rbAjaxLoadUrl(href, active);
      else window.location.href = href;
    } catch(e){ window.location.href = href; }
    closePopup(modal);
    return true;
  }
  function syncRingPricePopupToDesktopLive(modal){
    if (!modal) return;
    var card = null;
    try {
      var grid = document.querySelector('.desktop-view .rb-grid[data-step="1"]') || document.querySelector('.rb-grid[data-step="1"]:not(.mobile-grid)');
      if (grid) {
        qsa('.rb-card', grid).some(function(c){
          var t = qs('.rb-title', c);
          if (t && String(t.textContent||'').trim().toLowerCase() === 'price') { card = c; return true; }
          return false;
        });
      }
    } catch(e){}
    if (!card) return;
    var src = qs('[data-rb-ring-popup-price]', modal) || qs('[data-rb-price]', modal) || modal;
    var dst = qs('[data-rb-price]', card) || card;
    if (!src || !dst) return;
    ['[data-rb-from]','[data-rb-to]','[data-rb-min]','[data-rb-max]','[data-rb-min-display]','[data-rb-max-display]'].forEach(function(sel){
      var s = qs(sel, src), d = qs(sel, dst);
      if (s && d) d.value = s.value;
    });
    ['[data-rb-from]','[data-rb-to]','[data-rb-min-display]','[data-rb-max-display]'].forEach(function(sel){
      var d = qs(sel, dst);
      if (d) { trigger(d, 'input'); trigger(d, 'change'); }
    });
  }
  var ringPriceTimer = null;
  function applyRingPriceLive(modal){
    syncRingPricePopupToDesktopLive(modal);
    try { if (window.rbUpdateMobileRingSummaries) window.rbUpdateMobileRingSummaries(); } catch(e){}
    clearTimeout(ringPriceTimer);
    ringPriceTimer = setTimeout(function(){
      try {
        var form = document.querySelector('form[data-rb-form]');
        if (form && typeof rbAjaxSubmit === 'function') rbAjaxSubmit(form);
      } catch(e){}
    }, 220);
  }
  function clearStep2Modal(modal){
    if (!modal) return true;
    var id = modal.id || '';
    if (id === 'rb_shape_stone_modal' || id === 'rb_lab_stone_modal') {
      qsa('.rb-tile', modal).forEach(function(tile){ tile.classList.add('is-active'); tile.classList.add('active'); });
    } else if (id === 'rb_color_stone_modal') {
      qsa('[data-rb-color-tab]', modal).forEach(function(tab){ tab.classList.remove('active'); });
      var white = qs('[data-rb-color-tab="white"]', modal) || qs('[data-rb-color-tab]', modal);
      if (white) white.classList.add('active');
      qsa('[data-color-type]', modal).forEach(function(el){ el.style.display = (String(el.getAttribute('data-color-type')||'') === 'white') ? '' : 'none'; });
      qsa('[data-rb-fancy-color]', modal).forEach(function(tile){ tile.classList.remove('is-active'); tile.classList.remove('active'); });
      resetRange(qs('[data-rb-color]', modal) || modal);
    } else {
      resetRange(qs('[data-rb-price], [data-rb-ring-popup-price], [data-rb-stone-popup-carat], [data-rb-stone-popup-price]', modal) || modal);
    }
    try {
      if (typeof window.rbSyncMobileStep2ToDesktop === 'function') window.rbSyncMobileStep2ToDesktop(modal);
    } catch(e){}
    try { if (window.rbUpdateMobileStoneSummaries) window.rbUpdateMobileStoneSummaries(); } catch(e){}
    try {
      if (typeof fetchDiamonds === 'function') fetchDiamonds(1, visibleStep2DesktopGrid() || modal);
    } catch(e){}
    return true;
  }
  function clearRingPriceModal(modal){
    if (!modal) return true;
    resetRange(qs('[data-rb-ring-popup-price]', modal) || qs('[data-rb-price]', modal) || modal);
    applyRingPriceLive(modal);
    closePopup(modal);
    return true;
  }
  document.addEventListener('click', function(e){
    var clearBtn = e.target && e.target.closest ? e.target.closest('.rb-modal-clear') : null;
    if (!clearBtn) return;
    var modal = clearBtn.closest('.rb-modal-popup, .rb-modal-popup-mob');
    if (!modal) return;
    e.preventDefault();
    e.stopPropagation();
    var id = modal.id || '';
    if (id === 'rb_ring_modal' || id === 'rb_metal_modal' || id === 'rb_shape_modal') { clearRingFacetModal(modal); return; }
    if (id === 'rb_price_modal') { clearRingPriceModal(modal); return; }
    if (/_stone_modal$/.test(id)) { clearStep2Modal(modal); return; }
  }, true);
  document.addEventListener('input', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var modal = t.closest('#rb_price_modal');
    if (!modal) return;
    if (!t.matches('[data-rb-from],[data-rb-to],[data-rb-min-display],[data-rb-max-display]')) return;
    if (window.__rbSuppressPopupAjax) return;
    applyRingPriceLive(modal); 
  }, true);
  document.addEventListener('change', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var modal = t.closest('#rb_price_modal');
    if (!modal) return;
    if (!t.matches('[data-rb-from],[data-rb-to],[data-rb-min-display],[data-rb-max-display]')) return;
    if (window.__rbSuppressPopupAjax) return;
    applyRingPriceLive(modal);
  }, true);
})(); 

/* ===== RB merged URL init: ring filters + ring selection + step 2 defaults ===== */
(function () {
  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function txt(el) {
    return ((el && (el.textContent || el.innerText)) || '').trim();
  }

  function norm(v) {
    return String(v || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function rbNorm(v) {
    return String(v || '')
      .trim()
      .toLowerCase()
      .replace(/\+/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/[^a-z0-9 ]/g, '')
      .trim();
  }

  function getParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function hasBuilderParams() {
    return !!(
      getParam('handle') ||
      getParam('variant') ||
      getParam('style_id') ||
      getParam('metal') ||
      getParam('shape') ||
      getParam('ring_size') ||
      getParam('gold_purity') ||
      getParam('engraving') ||
      getParam('product_title') ||
      getParam('diamond_shape') ||
      getParam('diamond-shape') ||
      getParam('diamondShape') ||
      getParam('diamondColor') ||
      getParam('diamond_color') ||
      getParam('diamond-color')
    );
  }

  function hasDirectRingSelection() {
    return !!getParam('handle');
  }

  function hasExplicitDiamondShapeParam() {
    return !!(
      getParam('diamond-shape') ||
      getParam('diamond_shape') ||
      getParam('diamondShape')
    );
  }

  function showLoader() {
    try {
      if (typeof rbShowPageLoader === 'function') rbShowPageLoader();
    } catch (e) {}
  }

  function hideLoader() {
    try {
      if (typeof rbHidePageLoader === 'function') rbHidePageLoader();
    } catch (e) {}
  }

  function resetBuilderStorage() {
    var keys = [
      'rb_setting',
      'rb_setting_handle',
      'rb_setting_variant_id',
      'rb_setting_price',
      'rb_setting_image',
      'rb_setting_purity',
      'rb_setting_base_price',
      'rb_setting_ring_size',
      'rb_setting_ring_size_unknown',
      'rb_setting_engraving',
      'rb_setting_product_url',
      'rb_diamond',
      'rb_total_price',
      'rb_setting_shape',
      'rb_diamond_shape_url',
      'rb_diamond_color_url'
    ];

    try {
      keys.forEach(function (k) {
        localStorage.removeItem(k);
      });
    } catch (e) {}

    try {
      if (window.updateHeadersFromStorage) window.updateHeadersFromStorage();
    } catch (e) {}
  }

  if (!hasBuilderParams()) {
    window.__rbUrlDefaultsPresent = false;
    window.__rbApplyingParamsOnly = false;
    window.__rbParamsFetchDone = false;
    return;
  }

  window.__rbUrlDefaultsPresent = true;
  window.__rbApplyingParamsOnly = true;
  window.__rbParamsFetchDone = false;

  resetBuilderStorage();
  showLoader();

  function getDesktopStep1Grid() {
    return document.querySelector('.desktop-view .rb-grid[data-step="1"]');
  }

  function getFilterCardByTitle(title) {
    var grid = getDesktopStep1Grid();
    if (!grid) return null;

    var target = norm(title);
    var cards = qsa('.rb-card', grid);

    for (var i = 0; i < cards.length; i++) {
      var heading = qs('.rb-title, .rb-card-title', cards[i]);
      if (!heading) continue;
      if (norm(txt(heading)) === target) return cards[i];
    }

    return null;
  }

  function getTiles(card) {
    if (!card) return [];
    return qsa('a.rb-tile[href]', card);
  }

  function findTileByText(card, value) {
    if (!card || !value) return null;

    var target = norm(value);
    var tiles = getTiles(card);

    for (var i = 0; i < tiles.length; i++) {
      var labelEl = qs('.rb-label', tiles[i]);
      var label = norm(txt(labelEl || tiles[i]));
      if (!label) continue;

      if (label === target || label.indexOf(target) > -1 || target.indexOf(label) > -1) {
        return tiles[i];
      }
    }

    return null;
  }

  function findTileByHrefContains(card, rawValue) {
    if (!card || !rawValue) return null;

    var target = String(rawValue).toLowerCase();
    var tiles = getTiles(card);

    for (var i = 0; i < tiles.length; i++) {
      var href = String(tiles[i].getAttribute('href') || '').toLowerCase();
      if (!href) continue;

      if (href.indexOf(target) > -1 || href.indexOf(encodeURIComponent(target)) > -1) {
        return tiles[i];
      }
    }

    return null;
  }

  function findRingStyleTile(styleId) {
    var card = getFilterCardByTitle('Ring Style');
    if (!card || !styleId) return null;

    var target = norm(styleId);
    var tiles = getTiles(card);

    for (var i = 0; i < tiles.length; i++) {
      var tile = tiles[i];
      var ringTag = norm(tile.getAttribute('data-rb-ring-tag') || '');
      var ringLabel = norm(tile.getAttribute('data-rb-ring-label') || '');
      var label = norm(txt(qs('.rb-label', tile) || tile));

      if (
        ringTag === target ||
        ringLabel === target ||
        label === target ||
        ringTag.indexOf(target) > -1 ||
        ringLabel.indexOf(target) > -1 ||
        label.indexOf(target) > -1 ||
        target.indexOf(ringTag) > -1 ||
        target.indexOf(ringLabel) > -1 ||
        target.indexOf(label) > -1
      ) {
        return tile;
      }
    }

    return null;
  }

  function slugifyRingTag(v) {
    return String(v || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function findMetalTile(metal) {
    var card = getFilterCardByTitle('Metal Type');
    if (!card || !metal) return null;
    return findTileByText(card, metal) || findTileByHrefContains(card, metal);
  }

  function findShapeTile(shape) {
    var card = getFilterCardByTitle('Supported Shape');
    if (!card || !shape) return null;
    return findTileByText(card, shape) || findTileByHrefContains(card, shape);
  }

  function tileIsActive(tile) {
    return !!(tile && tile.classList.contains('is-active'));
  }

  function mergeFacetParams(finalParams, href) {
    if (!href) return;

    try {
      var u = new URL(href, window.location.origin);

      u.searchParams.forEach(function (v, k) {
        if (!k) return;
        if (k.indexOf('filter.') !== 0 && k !== 'sort_by') return;
        finalParams.delete(k);
      });

      u.searchParams.forEach(function (v, k) {
        if (!k) return;
        if (k.indexOf('filter.') !== 0 && k !== 'sort_by') return;
        finalParams.append(k, v);
      });
    } catch (e) {}
  }

  function applyStep1CollectionDefaultsFromUrl() {
    if (document.__rbCollectionDefaultsApplied || document.__rbCollectionDefaultsApplying) return false;

    if (hasDirectRingSelection()) {
      return false;
    }

    var styleId = getParam('style_id');
    var metal = getParam('metal');
    var shape = getParam('shape');

    if (!styleId && !metal && !shape) {
      return false;
    }

    var form = qs('form[data-rb-form]');
    var grid = getDesktopStep1Grid();

    if (!form || !grid) {
      return false;
    }

    var styleTile = findRingStyleTile(styleId);
    var metalTile = findMetalTile(metal);
    var shapeTile = findShapeTile(shape);

    var nonStyleSelected = [];
    if (metalTile) nonStyleSelected.push(metalTile);
    if (shapeTile) nonStyleSelected.push(shapeTile);

    var allActive =
      (!styleTile || tileIsActive(styleTile)) &&
      nonStyleSelected.every(tileIsActive);

    if (allActive) {
      document.__rbCollectionDefaultsApplied = true;
      return false;
    }

    var finalParams = new URLSearchParams(window.location.search);
    nonStyleSelected.forEach(function (tile) {
      mergeFacetParams(finalParams, tile.getAttribute('href') || '');
    });

    finalParams.delete('page');

    var m = String(window.location.pathname || '').match(/^(\/collections\/[^\/]+)/i);
    var basePath = m ? m[1] : String(window.location.pathname || '');
    var requestPath = basePath;

    if (styleTile) {
      var ringTag = (styleTile.getAttribute('data-rb-ring-tag') || '').trim();
      if (ringTag) {
        requestPath = basePath + '/' + slugifyRingTag(ringTag);
      }
    }

    document.__rbCollectionDefaultsApplying = true;
    document.__rbCollectionDefaultsApplied = true;
    showLoader();

    var url = requestPath + (finalParams.toString() ? ('?' + finalParams.toString()) : '');

    if (typeof rbAjaxLoadUrl === 'function') {
      rbAjaxLoadUrl(url, form);
      return true;
    }

    window.location.href = url;
    return true;
  }

  function rbFindProductJsonByHandle(handle) {
    if (!handle) return null;

    var script =
      document.querySelector('script[data-rb-product-json="' + handle + '"]') ||
      document.querySelector('script[data-rb-product-json][data-handle="' + handle + '"]');

    if (!script) return null;

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function rbFindProductLinkByHandle(handle) {
    if (!handle) return null;
    return document.querySelector('[data-rb-product-link][data-handle="' + handle + '"]');
  }

  function rbFindCardByHandle(handle) {
    var link = rbFindProductLinkByHandle(handle);
    return link ? (link.closest('.rb-product') || link.closest('.rb-product-card') || link.closest('.grid__item')) : null;
  }

  function rbGetCardPrice(handle) {
    var card = rbFindCardByHandle(handle);
    if (!card) return '';
    var priceEl = card.querySelector('.rb-pprice, [data-rb-price], .price, .rb-price');
    return priceEl ? String(priceEl.textContent || '').replace(/[^0-9.]/g, '') : '';
  }

  function rbGetCardImage(handle) {
    var card = rbFindCardByHandle(handle);
    if (!card) return '';
    var img = card.querySelector('img');
    return img && img.src ? img.src : '';
  }

  function rbMoneyFromCents(cents) {
    var n = Number(cents || 0);
    if (!isFinite(n)) return '';
    return String((n / 100).toFixed(2)).replace(/\.00$/, '');
  }

  function rbResolveVariant(product, variantId) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;

    var wanted = String(variantId || '').trim();
    if (wanted) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === wanted) return product.variants[i];
      }
    }

    for (var j = 0; j < product.variants.length; j++) {
      if (product.variants[j] && product.variants[j].available) return product.variants[j];
    }

    return product.variants[0] || null;
  }

  function rbResolveImage(product, handle) {
    var cardImage = rbGetCardImage(handle);
    if (cardImage) return cardImage;

    if (!product) return '';
    if (typeof product.featured_image === 'string' && product.featured_image) return product.featured_image;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    if (Array.isArray(product.images) && product.images.length) return product.images[0] || '';

    return '';
  }

  function rbResolvePrice(product, handle, variantId,goldPurity) {
    // var cardPrice = rbGetCardPrice(handle);
     
    
    // if (cardPrice){ 
    //   if(goldPurity == '14K'){
    //       cardPrice = Number(cardPrice) + 100;
    //     }
    //     if(goldPurity == '18K'){
    //       cardPrice = Number(cardPrice) + 200;
    //     }
    //   return cardPrice;
    // }

    var variant = rbResolveVariant(product, variantId);
    var vprice = variant.price;
    var pprice = product.price;
    if(goldPurity == '14K'){
      vprice = vprice + 10000;
      pprice = pprice + 10000;
    }
     if(goldPurity == '18K'){
      vprice = vprice + 20000;
      pprice = pprice + 20000;
    }
    
    if (variant && typeof variant.price !== 'undefined') return rbMoneyFromCents(vprice);
    if (product && typeof product.price !== 'undefined') return rbMoneyFromCents(pprice);

    return '';
  }

  async function rbFetchProductByHandle(handle) {
    if (!handle) return null;

    try {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      var res = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin'
      });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function markSelectedRingCard(handle) {
    try {
      document.querySelectorAll('[data-rb-product-link][data-handle]').forEach(function (a) {
        var isMatch = a.getAttribute('data-handle') === handle;
        a.classList.toggle('is-selected', isMatch);
        var card = a.closest('.rb-product-card, .grid__item, .rb-product');
        if (card) card.classList.toggle('is-selected', isMatch);
      });
    } catch (e) {}
  }

  function rbHasSelectedRing() {
    try {
      return !!localStorage.getItem('rb_setting_handle');
    } catch (e) {
      return false;
    }
  }

  function rbFindStep2ColorCard() {
    var grids = document.querySelectorAll('.rb-grid[data-step="2"]');
    for (var i = 0; i < grids.length; i++) {
      if (grids[i].classList.contains('mobile-grid')) continue;

      var cards = grids[i].querySelectorAll('.rb-card');
      for (var j = 0; j < cards.length; j++) {
        var title = cards[j].querySelector('.rb-title');
        if (title && rbNorm(title.textContent) === 'color') return cards[j];
      }
    }
    return null;
  }

  function rbSetDesktopDiamondColor(colorValue) {
    var card = rbFindStep2ColorCard();
    if (!card) return false;

    var val = rbNorm(colorValue);
    var isWhite = !val || val === 'white';

    var whiteTab = card.querySelector('.rb-swatch[data-rb-color="white"]');
    var fancyTab = card.querySelector('.rb-swatch[data-rb-color="fancy"]');

    card.querySelectorAll('.rb-swatch[data-rb-color]').forEach(function (el) {
      el.classList.remove('active');
    });

    if (isWhite) {
      if (whiteTab) whiteTab.classList.add('active');
    } else {
      if (fancyTab) fancyTab.classList.add('active');
    }

    card.querySelectorAll('[data-color-type]').forEach(function (wrap) {
      var type = rbNorm(wrap.getAttribute('data-color-type'));
      wrap.style.display = (isWhite ? type === 'white' : type === 'fancy') ? '' : 'none';
    });

    card.querySelectorAll('[data-rb-fancy-color]').forEach(function (tile) {
      tile.classList.remove('is-active');
      tile.classList.remove('active');
    });

    if (!isWhite) {
      var match = null;
      card.querySelectorAll('[data-rb-fancy-color]').forEach(function (tile) {
        if (rbNorm(tile.getAttribute('data-rb-fancy-color')) === val) {
          match = tile;
        }
      });
      if (match) {
        match.classList.add('is-active');
        match.classList.add('active');
      }
    }

    return true;
  }

  function rbSetMobileDiamondColor(colorValue) {
    var modal = document.querySelector('#rb_color_stone_modal');
    if (!modal) return false;

    var val = rbNorm(colorValue);
    var isWhite = !val || val === 'white';

    var whiteTab = modal.querySelector('.rb-swatch[data-rb-color-tab="white"]');
    var fancyTab = modal.querySelector('.rb-swatch[data-rb-color-tab="fancy"]');

    modal.querySelectorAll('.rb-swatch[data-rb-color-tab]').forEach(function (el) {
      el.classList.remove('active');
    });

    if (isWhite) {
      if (whiteTab) whiteTab.classList.add('active');
    } else {
      if (fancyTab) fancyTab.classList.add('active');
    }

    modal.querySelectorAll('[data-color-type]').forEach(function (wrap) {
      var type = rbNorm(wrap.getAttribute('data-color-type'));
      wrap.style.display = (isWhite ? type === 'white' : type === 'fancy') ? '' : 'none';
    });

    modal.querySelectorAll('[data-rb-fancy-color]').forEach(function (tile) {
      tile.classList.remove('is-active');
      tile.classList.remove('active');
    });

    if (!isWhite) {
      var match = null;
      modal.querySelectorAll('[data-rb-fancy-color]').forEach(function (tile) {
        if (rbNorm(tile.getAttribute('data-rb-fancy-color')) === val) {
          match = tile;
        }
      });
      if (match) {
        match.classList.add('is-active');
        match.classList.add('active');
      }
    }

    try {
      if (window.rbSyncMobileStep2ToDesktop) {
        window.rbSyncMobileStep2ToDesktop(modal);
      }
    } catch (e) {}

    return true;
  }

  function rbIsShapeTitle(v) {
    var t = rbNorm(v);
    return t === 'shape' || t === 'supported shape';
  }

  function rbFindStep2ShapeCard() {
    var grids = document.querySelectorAll('.rb-grid[data-step="2"]');
    for (var i = 0; i < grids.length; i++) {
      if (grids[i].classList.contains('mobile-grid')) continue;

      var cards = grids[i].querySelectorAll('.rb-card');
      for (var j = 0; j < cards.length; j++) {
        var title = cards[j].querySelector('.rb-title');
        if (title && rbIsShapeTitle(title.textContent)) return cards[j];
      }
    }

    return null;
  }

  function rbSetDesktopDiamondShape(shapeValue) {
    var card = rbFindStep2ShapeCard();
    if (!card) return false;

    var val = rbNorm(shapeValue);
    if (!val) return false;

    var match = null;

    card.querySelectorAll('.rb-tile').forEach(function (tile) {
      var lbl = tile.querySelector('.rb-label');
      var same = lbl && rbNorm(lbl.textContent) === val;
      tile.classList.remove('is-active');
      tile.classList.remove('active');
      if (same) match = tile;
    });

    if (!match) {
      var targetSing = val.replace(/s\b/g, '');
      card.querySelectorAll('.rb-tile').forEach(function (tile) {
        var lbl = tile.querySelector('.rb-label');
        var cur = lbl ? rbNorm(lbl.textContent).replace(/s\b/g, '') : '';
        if (!match && cur === targetSing) match = tile;
      });
    }

    if (match) {
      match.classList.add('is-active');
      match.classList.add('active');
      var a = match.querySelector('a');
      if (a) a.setAttribute('href', 'javascript:void(0)');
      return true;
    }

    return false;
  }

  function rbSetMobileDiamondShape(shapeValue) {
    var modal = document.querySelector('#rb_shape_stone_modal');
    if (!modal) return false;

    var val = rbNorm(shapeValue);
    if (!val) return false;

    var match = null;

    modal.querySelectorAll('.rb-tile').forEach(function (tile) {
      var lbl = tile.querySelector('.rb-label');
      var same = lbl && rbNorm(lbl.textContent) === val;
      tile.classList.remove('is-active');
      tile.classList.remove('active');
      if (same) match = tile;
    });

    if (!match) {
      var targetSing = val.replace(/s\b/g, '');
      modal.querySelectorAll('.rb-tile').forEach(function (tile) {
        var lbl = tile.querySelector('.rb-label');
        var cur = lbl ? rbNorm(lbl.textContent).replace(/s\b/g, '') : '';
        if (!match && cur === targetSing) match = tile;
      });
    }

    if (match) {
      match.classList.add('is-active');
      match.classList.add('active');
    }

    try {
      if (window.rbSyncMobileStep2ToDesktop) {
        window.rbSyncMobileStep2ToDesktop(modal);
      }
    } catch (e) {}

    return !!match;
  }

  function applyUrlDiamondColor() {
    if (!rbHasSelectedRing()) return false;

    var colorParam =
      getParam('diamond-color') ||
      getParam('diamond_color') ||
      getParam('diamondColor');

    if (!colorParam) return false;

    rbSetDesktopDiamondColor(colorParam);
    rbSetMobileDiamondColor(colorParam);

    try {
      localStorage.setItem('rb_diamond_color_url', colorParam);
    } catch (e) {}

    return true;
  }

  function applyUrlDiamondShape() {
    if (!rbHasSelectedRing()) return false;

    var shapeParam =
      getParam('diamond-shape') ||
      getParam('diamond_shape') ||
      getParam('shape') ||
      getParam('diamondShape');

    if (!shapeParam) return false;

    rbSetDesktopDiamondShape(shapeParam);
    rbSetMobileDiamondShape(shapeParam);

    try {
      localStorage.setItem('rb_diamond_shape_url', shapeParam);
    } catch (e) {}

    return true;
  }

  function applyStep2DefaultsFromUrl() {
    var applied = false;
    applied = applyUrlDiamondColor() || applied;
    applied = applyUrlDiamondShape() || applied;

    try {
      if (window.rbUpdateMobileStoneSummaries) window.rbUpdateMobileStoneSummaries();
    } catch (e) {}

    return applied;
  }

  function finishUrlInit() {
    window.__rbApplyingParamsOnly = false;
    window.__rbUrlDefaultsPresent = false;

    setTimeout(function () {
      try {
        if (typeof window.rbReinitPriceColorOnly === 'function') {
          window.rbReinitPriceColorOnly();
        }
      } catch (e) {}

      try {
        if (typeof window.rbUpdateMobileRingSummaries === 'function') {
          window.rbUpdateMobileRingSummaries();
        }
      } catch (e) {}

      try {
        if (typeof window.rbUpdateMobileStoneSummaries === 'function') {
          window.rbUpdateMobileStoneSummaries();
        }
      } catch (e) {}

      try {
        document.dispatchEvent(new CustomEvent('rb:ajaxmobile:updated'));
      } catch (e) {}
    }, 0);

    hideLoader();
  }

  function finalizeParamInitAndFetch() {
    if (!window.__rbApplyingParamsOnly || window.__rbParamsFetchDone) return;

    window.__rbParamsFetchDone = true;

    setTimeout(function () {
      applyStep2DefaultsFromUrl();

      try {
        if (window.rbUpdateMobileStoneSummaries) {
          window.rbUpdateMobileStoneSummaries();
        }
      } catch (e) {}

      var fetchResult = null;
      try {
        if (typeof window.fetchDiamonds === 'function') {
          fetchResult = window.fetchDiamonds(1);
        }
      } catch (e) {}

      Promise.resolve(fetchResult).finally(function () {
        setTimeout(function () {
          finishUrlInit();
        }, 50);
      });
    }, hasExplicitDiamondShapeParam() ? 500 : 500);
  }

  async function persistUrlSelectedRing() {
    var handle       = getParam('handle');
    var variant      = getParam('variant');
    var styleId      = getParam('style_id');
    var metal        = getParam('metal');
    var shape        = getParam('shape');
    var ringSize     = getParam('ring_size');
    var goldPurity   = getParam('gold_purity');
    var engraving    = getParam('engraving');
    var productTitle = getParam('product_title');

    if (!handle) return false;

    var meta = rbFindProductJsonByHandle(handle) || {};
    var product = await rbFetchProductByHandle(handle);
    var variantObj = rbResolveVariant(product, variant);

    var resolvedVariantId = variant || (variantObj && variantObj.id ? String(variantObj.id) : '');
    var resolvedTitle = productTitle || (product && product.title ? product.title : '');
    var resolvedPrice = rbResolvePrice(product, handle, resolvedVariantId,goldPurity);
    var resolvedImage = rbResolveImage(product, handle);
    $('.engraving_input').val(engraving)

    var payload = {
      handle: handle,
      variant_id: resolvedVariantId,
      ring_size: ringSize || '',
      purity: goldPurity || '',
      engraving: engraving || '',
      style_id: styleId || meta.style_id || '',
      metal: metal || meta.current_metal || '',
      shape: shape || meta.current_shape || '',
      product_title: resolvedTitle || '',
      title: resolvedTitle || '',
      product_url: '/products/' + handle,
      ts: Date.now()
    };

    try {
      localStorage.setItem('rb_setting', JSON.stringify(payload));
      localStorage.setItem('rb_setting_handle', payload.handle);
      localStorage.setItem('rb_setting_variant_id', payload.variant_id || '');
      localStorage.setItem('rb_setting_ring_size', payload.ring_size || '');
      localStorage.setItem('rb_setting_ring_size_unknown', '0');
      localStorage.setItem('rb_setting_purity', payload.purity || '');
      localStorage.setItem('rb_setting_engraving', payload.engraving || '');
      localStorage.setItem('rb_setting_product_url', payload.product_url || '');

      if (resolvedPrice) localStorage.setItem('rb_setting_price', resolvedPrice);
      if (resolvedImage) localStorage.setItem('rb_setting_image', resolvedImage);
      if (payload.shape) localStorage.setItem('rb_setting_shape', payload.shape);
    } catch (e) {}

    markSelectedRingCard(handle);

    try {
      if (window.updateHeadersFromStorage) window.updateHeadersFromStorage();
    } catch (e) {}

    try {
      window.__rbSkipNextStep2AutoFetch = true;
      if (window.activateStep) window.activateStep(2);
    } catch (e) {}

    return true;
  }

  async function applyUrlRingSelection() {
    var handle = getParam('handle');
    if (!handle) return false;

    if (window.__rbApplyingUrlRingSelection) return false;
    if (window.__rbUrlRingSelectionDone) return true;

    window.__rbApplyingUrlRingSelection = true;

    try {
      var ok = await persistUrlSelectedRing();
      if (ok) {
        window.__rbUrlRingSelectionDone = true;
        return true;
      }
      return false;
    } catch (e) {
      console.error(e);
      return false;
    } finally {
      window.__rbApplyingUrlRingSelection = false;
    }
  }

  async function runMergedUrlInit() {
    if (!window.__rbUrlDefaultsPresent) return;
    if (window.__rbMergedUrlInitRunning) return;

    window.__rbMergedUrlInitRunning = true;

    try {
      var didCollectionAjax = applyStep1CollectionDefaultsFromUrl();
      if (didCollectionAjax) return;

      if (hasDirectRingSelection()) {
        var ok = await applyUrlRingSelection();
        if (ok) {
          finalizeParamInitAndFetch();
          return;
        }
      }

      finishUrlInit();
    } finally {
      window.__rbMergedUrlInitRunning = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(runMergedUrlInit, 80);
    });
  } else {
    setTimeout(runMergedUrlInit, 80);
  }

  document.addEventListener('rb:ajax:updated', function () {
    if (!window.__rbUrlDefaultsPresent) return;

    document.__rbCollectionDefaultsApplying = false;

    if (window.__rbUrlRingSelectionDone) return;

    setTimeout(async function () {
      if (hasDirectRingSelection()) {
        var ok = await applyUrlRingSelection();
        if (ok) {
          finalizeParamInitAndFetch();
          return;
        }
      }

      finishUrlInit();
    }, 100);
  });

  window.addEventListener('pageshow', function () {
    if (!window.__rbUrlDefaultsPresent) return;
    if (document.__rbCollectionDefaultsApplying) return;
    hideLoader();
  });
  $('.engraving_input').change(function(){
    var engval = $(this).val();
    console.log(engval)
    localStorage.setItem('rb_setting_engraving',engval );
  })
})();

const el = document.querySelector('.buy-buttons-wrapper');

    if (el) {
      const stickyPoint = el.offsetTop;

      function checkSticky() {
        if (window.scrollY >= stickyPoint) {
          el.classList.add('sticky');
        } else {
          el.classList.remove('sticky');
        }
      }

      window.addEventListener('scroll', checkSticky);
      window.addEventListener('resize', checkSticky);
      checkSticky();
    }